var AcceptEscalationResultStatus;

(function (AcceptEscalationResultStatus) {
  AcceptEscalationResultStatus["NOT_ALLOWED"] = "NOT_ALLOWED";
  AcceptEscalationResultStatus["ACCEPTED"] = "ACCEPTED";
  AcceptEscalationResultStatus["ALREADY_CLAIMED"] = "ALREADY_CLAIMED";
  AcceptEscalationResultStatus["ESCALATION_CLOSED"] = "ESCALATION_CLOSED";
})(AcceptEscalationResultStatus || (AcceptEscalationResultStatus = {}));

var AcceptRequestMode;

(function (AcceptRequestMode) {
  AcceptRequestMode["ALWAYS"] = "ALWAYS";
  AcceptRequestMode["WHEN_ACTIVATED"] = "WHEN_ACTIVATED";
  AcceptRequestMode["WHEN_ACTIVATED_AND_AS_BACKUP"] = "WHEN_ACTIVATED_AND_AS_BACKUP";
})(AcceptRequestMode || (AcceptRequestMode = {}));

var AddressValidationStatus;

(function (AddressValidationStatus) {
  /**
   * This can represent:
   * - an unknown type (e.g. incoming type from users), or
   * - existing persistent data, because it can be valid (all shipping address) or unknown (billing address).
   */
  AddressValidationStatus["UNKNOWN"] = "UNKNOWN";
  /**
   * This only use for validation result. Address in db will not have this type because we will not write
   * invalid address voluntary (i.e. it has to be user OVERRIDE). An address in memory (returned to client) may have
   * this value (e.g. data read from DB having UNKNOWN value, and subsequently validated to have this value).
   * This can represent:
   * - false negative address (e.g. a newly created address / complex).
   * - real invalid address (e.g. a totally bogus address).
   */

  AddressValidationStatus["INVALID"] = "INVALID";
  /** address has passed validation (by third party, generally) */

  AddressValidationStatus["VALID_VERIFIED"] = "VALID_VERIFIED";
  /**
   * address did not pass validation, but it is considered valid due to user override. Similar to INVALID,
   * this can represent false negative address or real invalid address.
   */

  AddressValidationStatus["VALID_USER_OVERRIDE"] = "VALID_USER_OVERRIDE";
})(AddressValidationStatus || (AddressValidationStatus = {}));

var AirportType;

(function (AirportType) {
  AirportType["LARGE_AIRPORT"] = "LARGE_AIRPORT";
  AirportType["MEDIUM_AIRPORT"] = "MEDIUM_AIRPORT";
  AirportType["SMALL_AIRPORT"] = "SMALL_AIRPORT";
})(AirportType || (AirportType = {}));

var ApprovableEntityState;

(function (ApprovableEntityState) {
  ApprovableEntityState["DRAFT"] = "DRAFT";
  ApprovableEntityState["IN_REVIEW"] = "IN_REVIEW";
  ApprovableEntityState["PUBLISHED"] = "PUBLISHED";
  ApprovableEntityState["ARCHIVED"] = "ARCHIVED";
})(ApprovableEntityState || (ApprovableEntityState = {}));

var ApprovalRequestActivityEntryType;

(function (ApprovalRequestActivityEntryType) {
  ApprovalRequestActivityEntryType["SUBMIT_FOR_REVIEW"] = "SUBMIT_FOR_REVIEW";
  ApprovalRequestActivityEntryType["COMMENT"] = "COMMENT";
  ApprovalRequestActivityEntryType["APPROVE"] = "APPROVE";
  ApprovalRequestActivityEntryType["REJECT"] = "REJECT";
  ApprovalRequestActivityEntryType["PUBLISH"] = "PUBLISH";
  ApprovalRequestActivityEntryType["CLOSE"] = "CLOSE";
})(ApprovalRequestActivityEntryType || (ApprovalRequestActivityEntryType = {}));

var ApprovalRequestEntityType;

(function (ApprovalRequestEntityType) {
  ApprovalRequestEntityType["PATH_SCHEMA"] = "PATH_SCHEMA";
  ApprovalRequestEntityType["PATH_SCHEMA_FRAGMENT"] = "PATH_SCHEMA_FRAGMENT";
  ApprovalRequestEntityType["ATTRIBUTE_SCHEMA"] = "ATTRIBUTE_SCHEMA";
  ApprovalRequestEntityType["VENDOR_AGREEMENT"] = "VENDOR_AGREEMENT";
})(ApprovalRequestEntityType || (ApprovalRequestEntityType = {}));

var ApprovalRequestState;

(function (ApprovalRequestState) {
  ApprovalRequestState["PREPARING_REVIEW"] = "PREPARING_REVIEW";
  ApprovalRequestState["IN_REVIEW"] = "IN_REVIEW";
  ApprovalRequestState["PUBLISHING"] = "PUBLISHING";
  ApprovalRequestState["PUBLISHED"] = "PUBLISHED";
  ApprovalRequestState["CLOSING"] = "CLOSING";
  ApprovalRequestState["CLOSED"] = "CLOSED";
})(ApprovalRequestState || (ApprovalRequestState = {}));

var ApprovalRequestSubmitDraftDependencyState;

(function (ApprovalRequestSubmitDraftDependencyState) {
  ApprovalRequestSubmitDraftDependencyState["INCLUDED"] = "INCLUDED";
  ApprovalRequestSubmitDraftDependencyState["EXCLUDED"] = "EXCLUDED";
  ApprovalRequestSubmitDraftDependencyState["REQUIRED"] = "REQUIRED";
})(ApprovalRequestSubmitDraftDependencyState || (ApprovalRequestSubmitDraftDependencyState = {}));

var ApprovalReviewStatus;

(function (ApprovalReviewStatus) {
  ApprovalReviewStatus["APPROVED"] = "APPROVED";
  ApprovalReviewStatus["REJECTED"] = "REJECTED";
})(ApprovalReviewStatus || (ApprovalReviewStatus = {}));

var ArticleContentBlockType;

(function (ArticleContentBlockType) {
  ArticleContentBlockType["RICH_TEXT"] = "RICH_TEXT";
  ArticleContentBlockType["MEDIA_FILE"] = "MEDIA_FILE";
  ArticleContentBlockType["EMBED_MEDIA"] = "EMBED_MEDIA";
  ArticleContentBlockType["SELLABLE"] = "SELLABLE";
  ArticleContentBlockType["SELLABLE_LIST"] = "SELLABLE_LIST";
})(ArticleContentBlockType || (ArticleContentBlockType = {}));

var ArticleRevisionState;

(function (ArticleRevisionState) {
  ArticleRevisionState["DRAFT"] = "DRAFT";
  ArticleRevisionState["PUBLISHED"] = "PUBLISHED";
  ArticleRevisionState["ARCHIVED"] = "ARCHIVED";
})(ArticleRevisionState || (ArticleRevisionState = {}));

var ArticleSort;

(function (ArticleSort) {
  /** The date when it is first published */
  ArticleSort["FIRST_PUBLISHED"] = "FIRST_PUBLISHED";
  /** The date when it is last updated */

  ArticleSort["LAST_UPDATED"] = "LAST_UPDATED";
  /** The view count */

  ArticleSort["VIEW_COUNT"] = "VIEW_COUNT";
  /** Relevance score computed from sellables that match users intent */

  ArticleSort["RELEVANCE"] = "RELEVANCE";
})(ArticleSort || (ArticleSort = {}));

var AttentionNeededLeadChangeType;

(function (AttentionNeededLeadChangeType) {
  AttentionNeededLeadChangeType["ADD"] = "ADD";
  AttentionNeededLeadChangeType["REMOVE"] = "REMOVE";
  AttentionNeededLeadChangeType["UPDATE"] = "UPDATE";
})(AttentionNeededLeadChangeType || (AttentionNeededLeadChangeType = {}));

var AttributedHtmlTextViewModelAttributeType;

(function (AttributedHtmlTextViewModelAttributeType) {
  /** Denotes this attribute is an image view model */
  AttributedHtmlTextViewModelAttributeType["IMAGE"] = "IMAGE";
})(AttributedHtmlTextViewModelAttributeType || (AttributedHtmlTextViewModelAttributeType = {}));
/** AttributeFunction is used to assign and classify an Attribute with a special purpose */


var AttributeFunction;

(function (AttributeFunction) {
  /**
   * Primary Attributes define the importance of the Attribute for identifying a product or a Service
   * This can manifest itself as fundamental User intent about a specific product or service or can be associated with a
   * Sellable specification.  Someone looking for a road bike or Golf Wedges or Charter in Miami.
   *
   * A Path should be restricted to very few Primary Functions. It should be thought of as one thing that differentiates
   * a Sellable from others
   *
   * Some examples of Primary Attributes include:
   * 1. Bike Type
   * 2. Golf Club type
   * 3. Charter Location
   */
  AttributeFunction["PRIMARY"] = "PRIMARY";
  /**
   * Secondary Attributes define other useful information that can be used to further narrow down the specificity of
   * a product or service or a Sellable Variation.
   *
   * Someone looking for a 56 cm Carbon fiber bike or Burton Men's Snowboard
   *
   * Some examples of secondary Attributes include:
   * 1. Bike Size
   * 2. Dominant Hand
   * 3. Ski/Snowboard Length
   * 4. Gender preferences
   * 5. Brand preferences
   */

  AttributeFunction["SECONDARY"] = "SECONDARY";
  /** For attributes associated with a User, this includes personal information like phone number, email etc */

  AttributeFunction["PERSONAL_INFORMATION"] = "PERSONAL_INFORMATION";
  /**
   * Defines an Attribute that is of Accessory type associated with a Parent Sellable path.
   * Some examples include:
   * 1. Bike Helmets
   * 2. Snowboard/Ski Goggles
   */

  AttributeFunction["ACCESSORY"] = "ACCESSORY";
  /**
   * TAGGABLE function is used to identify the Attributes to show as taggable suggestions to the experts
   * when saving ExpertCuratedItems
   */

  AttributeFunction["TAGGABLE"] = "TAGGABLE";
  /**
   * Whether the parent entity which contains this attribute should be considered for building the sitemap index.
   * For example, when building the sitemap urls for SERP pages, only the attributes of sellable that have this function
   * will be considered.
   */

  AttributeFunction["SITEMAP_INDEXABLE"] = "SITEMAP_INDEXABLE";
  /** Attribute that is used for expert matching.  It can be used for attributes on lead and expert. */

  AttributeFunction["EXPERT_MATCHING"] = "EXPERT_MATCHING";
})(AttributeFunction || (AttributeFunction = {}));

var AttributeSchemaMetadataType;

(function (AttributeSchemaMetadataType) {
  AttributeSchemaMetadataType["GOOGLE_SHOPPING_FEED"] = "GOOGLE_SHOPPING_FEED";
  AttributeSchemaMetadataType["HIDDEN"] = "HIDDEN";
  AttributeSchemaMetadataType["SEARCH_FACET_NAME_ALIAS"] = "SEARCH_FACET_NAME_ALIAS";
  AttributeSchemaMetadataType["SEARCH_FACET_CAPPED_NUMERIC"] = "SEARCH_FACET_CAPPED_NUMERIC";
  AttributeSchemaMetadataType["SEARCH_FACET_DECIMAL_SCALE"] = "SEARCH_FACET_DECIMAL_SCALE";
  AttributeSchemaMetadataType["SEARCH_FACET_FIXED_INTEGER_BUCKET"] = "SEARCH_FACET_FIXED_INTEGER_BUCKET";
  AttributeSchemaMetadataType["SEARCH_FACET_HISTOGRAM_BUCKET"] = "SEARCH_FACET_HISTOGRAM_BUCKET";
  AttributeSchemaMetadataType["MISSING_ATTRIBUTE"] = "MISSING_ATTRIBUTE";
  AttributeSchemaMetadataType["EXPERT_NOTE"] = "EXPERT_NOTE";
  AttributeSchemaMetadataType["SEARCH_FILTER_FIELD"] = "SEARCH_FILTER_FIELD";
  AttributeSchemaMetadataType["PRO_CON"] = "PRO_CON";
})(AttributeSchemaMetadataType || (AttributeSchemaMetadataType = {}));

var AttributeSchemaRevisionQueryDraftFilter;

(function (AttributeSchemaRevisionQueryDraftFilter) {
  /** Show all drafts and non drafts */
  AttributeSchemaRevisionQueryDraftFilter["INCLUDE"] = "INCLUDE";
  /** Show drafts that are newly created (not from replacing an existing attribute schema revision) and non drafts */

  AttributeSchemaRevisionQueryDraftFilter["INCLUDE_CREATED_DRAFT"] = "INCLUDE_CREATED_DRAFT";
  /** Only show drafts (and no non drafts) */

  AttributeSchemaRevisionQueryDraftFilter["ONLY"] = "ONLY";
  /** Show no drafts; only non drafts */

  AttributeSchemaRevisionQueryDraftFilter["NONE"] = "NONE";
})(AttributeSchemaRevisionQueryDraftFilter || (AttributeSchemaRevisionQueryDraftFilter = {}));

var AttributeSchemaRevisionSort;

(function (AttributeSchemaRevisionSort) {
  AttributeSchemaRevisionSort["NAME"] = "NAME";
  AttributeSchemaRevisionSort["CREATED_AT"] = "CREATED_AT";
  AttributeSchemaRevisionSort["KEYWORD_RELEVANCE"] = "KEYWORD_RELEVANCE";
})(AttributeSchemaRevisionSort || (AttributeSchemaRevisionSort = {}));

var AttributeSchemaRevisionState;

(function (AttributeSchemaRevisionState) {
  AttributeSchemaRevisionState["DRAFT"] = "DRAFT";
  AttributeSchemaRevisionState["IN_REVIEW"] = "IN_REVIEW";
  AttributeSchemaRevisionState["PUBLISHED"] = "PUBLISHED";
  AttributeSchemaRevisionState["REPLACED"] = "REPLACED";
})(AttributeSchemaRevisionState || (AttributeSchemaRevisionState = {}));
/**
 * AttributeSearchFunction is used to assist the Search system to identify whether a particular Attribute
 * is relevant for the Search(ing) of the Parent entity to which it belongs and how it should be treated for indexing
 * and other search operations.
 */


var AttributeSearchFunction;

(function (AttributeSearchFunction) {
  /** Marks an Attribute to be indexed as a Facet */
  AttributeSearchFunction["FACET"] = "FACET";
  /**
   * By default the AttributeType is used to structure the facets into their types and when the facet results
   * are parsed they are mapped based on the type specific aggregations.
   * This results in the bucketed aggregation for keyword/string types and stats aggregation for the numeric types
   * that gives a range of values instead of buckets.
   * In some cases, we might want to override the behavior of these types, for example if you we want to see the
   * numeric values as bucket values instead of range.
   *
   * Use this type to perform such transformation during indexing or search queries.
   * The values will be automatically converted to their stringified value both during indexing and query.
   */

  AttributeSearchFunction["OVERRIDE_FACET_TYPE_AS_KEYWORD"] = "OVERRIDE_FACET_TYPE_AS_KEYWORD";
  /**
   * When a RawAttribute is linked to this specific attribute's AttributeSchemaRevision, the raw attribute value will
   * be used as a keyword facet type.
   *
   * This is useful for when the standardized {@link Attribute} is a number, but the raw attribute contains more context
   * that is lost. For example, snowboard sizes have multiple variants at the same size, e.g.: "159W" for "wide".
   *
   * If there is no matching raw attribute, this attribute will not be indexed.
   */

  AttributeSearchFunction["OVERRIDE_FACET_RAW_ATTRIBUTE_AS_KEYWORD"] = "OVERRIDE_FACET_RAW_ATTRIBUTE_AS_KEYWORD";
  /**
   * Used to Order display facet terms by their values in ascending order
   * Does not apply to range attributes
   */

  AttributeSearchFunction["ORDER_FACET_TERMS_BY_LO_HI"] = "ORDER_FACET_TERMS_BY_LO_HI";
  /**
   * Similar to ORDER_FACET_TERMS_BY_LO_HI, except that the keyword will be sorted numerically first (extracting
   * any numeric portion out of the keyword), and then alphabetically.
   */

  AttributeSearchFunction["ORDER_FACET_TERMS_BY_LO_HI_AS_NUMERIC"] = "ORDER_FACET_TERMS_BY_LO_HI_AS_NUMERIC";
  /**
   * Used to Order display facet terms by their values in descending order.
   * Does not apply to range attributes
   */

  AttributeSearchFunction["ORDER_FACET_TERMS_BY_HI_LO"] = "ORDER_FACET_TERMS_BY_HI_LO";
  /**
   * Orders display facet terms by the order they're defined in the attribute enum definition.
   * Only applies to enum attributes.
   */

  AttributeSearchFunction["ORDER_FACET_TERMS_BY_ENUM_DEFINITION_ORDER"] = "ORDER_FACET_TERMS_BY_ENUM_DEFINITION_ORDER";
})(AttributeSearchFunction || (AttributeSearchFunction = {}));
/**
 * There is a 1:1 correlation between AttributeType and a GraphQL type.
 * The corresponding GraphQL type declaration name is ("AttributeValue" + pascalCaseOf(AttributeType))
 */


var AttributeType;

(function (AttributeType) {
  AttributeType["INTEGER"] = "INTEGER";
  AttributeType["INTEGER_RANGE"] = "INTEGER_RANGE";
  AttributeType["DECIMAL"] = "DECIMAL";
  AttributeType["DECIMAL_RANGE"] = "DECIMAL_RANGE";
  AttributeType["TEXT"] = "TEXT";
  AttributeType["ENUMERATION"] = "ENUMERATION";
  AttributeType["LOCAL_DATE"] = "LOCAL_DATE";
  AttributeType["LOCAL_DATE_RANGE"] = "LOCAL_DATE_RANGE";
  AttributeType["LOCAL_TIME"] = "LOCAL_TIME";
  AttributeType["LOCAL_TIME_RANGE"] = "LOCAL_TIME_RANGE";
  AttributeType["LOCAL_DATE_TIME"] = "LOCAL_DATE_TIME";
  AttributeType["LOCAL_DATE_TIME_RANGE"] = "LOCAL_DATE_TIME_RANGE";
  AttributeType["ZONE_ID"] = "ZONE_ID";
  AttributeType["ID"] = "ID";
})(AttributeType || (AttributeType = {}));

var AttributeValidatorType;

(function (AttributeValidatorType) {
  AttributeValidatorType["CHARACTER_COUNT"] = "CHARACTER_COUNT";
  AttributeValidatorType["IN_RANGE_INTEGER"] = "IN_RANGE_INTEGER";
  AttributeValidatorType["IN_RANGE_DECIMAL"] = "IN_RANGE_DECIMAL";
  AttributeValidatorType["REGEX"] = "REGEX";
  /**
   * Validate either if the given attribute which represents a contact (phone number, email, etc) is available, or
   * belongs to the logged in user.
   * Only validates text attributes
   */

  AttributeValidatorType["CONTACT_AVAILABLE"] = "CONTACT_AVAILABLE";
  /** Ensure the phone number is SMS capable. */

  AttributeValidatorType["SMS_CAPABLE_PHONE_NUMBER"] = "SMS_CAPABLE_PHONE_NUMBER";
  /** Ensure the email address is valid */

  AttributeValidatorType["VALID_EMAIL_ADDRESS"] = "VALID_EMAIL_ADDRESS";
  /**
   * Ensure the OAuth token is not mapped to a user, or mapped to the logged in user.
   * Only validates text attributes
   */

  AttributeValidatorType["OAUTH_TOKEN_NOT_MAPPED"] = "OAUTH_TOKEN_NOT_MAPPED";
  /**
   * Ensure the Id is of a certain type.
   * Only validates id attributes
   */

  AttributeValidatorType["ID_ENTITY_TYPE"] = "ID_ENTITY_TYPE";
})(AttributeValidatorType || (AttributeValidatorType = {}));

var AuthenticationMethod;

(function (AuthenticationMethod) {
  AuthenticationMethod["NO_PASSWORD"] = "NO_PASSWORD";
  AuthenticationMethod["PASSWORD"] = "PASSWORD";
  AuthenticationMethod["CHALLENGE"] = "CHALLENGE";
  AuthenticationMethod["LOGIN_TOKEN"] = "LOGIN_TOKEN";
  AuthenticationMethod["EXTERNAL_OAUTH"] = "EXTERNAL_OAUTH";
})(AuthenticationMethod || (AuthenticationMethod = {}));

var AuthenticationResult;

(function (AuthenticationResult) {
  AuthenticationResult["SUCCESS"] = "SUCCESS";
  AuthenticationResult["FAILURE"] = "FAILURE";
  AuthenticationResult["CHALLENGE"] = "CHALLENGE";
})(AuthenticationResult || (AuthenticationResult = {}));

var AwayAutoReplyStatus;

(function (AwayAutoReplyStatus) {
  AwayAutoReplyStatus["PENDING"] = "PENDING";
  AwayAutoReplyStatus["ACTIVE"] = "ACTIVE";
  AwayAutoReplyStatus["EXPIRED"] = "EXPIRED";
})(AwayAutoReplyStatus || (AwayAutoReplyStatus = {}));

var BookingSearchSort;

(function (BookingSearchSort) {
  BookingSearchSort["DEFAULT"] = "DEFAULT";
  BookingSearchSort["ORDER_CREATE_AT"] = "ORDER_CREATE_AT";
})(BookingSearchSort || (BookingSearchSort = {}));

var BookingState;

(function (BookingState) {
  BookingState["TRIP_COMPLETED"] = "TRIP_COMPLETED";
  BookingState["TRIP_UPCOMING"] = "TRIP_UPCOMING";
  BookingState["VERIFYING_PAYMENT"] = "VERIFYING_PAYMENT";
})(BookingState || (BookingState = {}));

var BroadcastOfferType;

(function (BroadcastOfferType) {
  BroadcastOfferType["PRODUCT"] = "PRODUCT";
  BroadcastOfferType["SERVICE"] = "SERVICE";
})(BroadcastOfferType || (BroadcastOfferType = {}));

var BusinessUserActivityType;

(function (BusinessUserActivityType) {
  BusinessUserActivityType["START_RECEIVING_LEADS"] = "START_RECEIVING_LEADS";
  BusinessUserActivityType["STOP_RECEIVING_LEADS"] = "STOP_RECEIVING_LEADS";
  BusinessUserActivityType["START_ON_CALL"] = "START_ON_CALL";
  BusinessUserActivityType["STOP_ON_CALL"] = "STOP_ON_CALL";
  BusinessUserActivityType["EXPERT_DEACTIVATED"] = "EXPERT_DEACTIVATED";
  BusinessUserActivityType["EXPERT_ACTIVATED"] = "EXPERT_ACTIVATED";
  BusinessUserActivityType["EXPERT_LEAD_GATE_ADDED"] = "EXPERT_LEAD_GATE_ADDED";
  BusinessUserActivityType["EXPERT_LEAD_GATE_REMOVED"] = "EXPERT_LEAD_GATE_REMOVED";
})(BusinessUserActivityType || (BusinessUserActivityType = {}));

var BusinessUserState;

(function (BusinessUserState) {
  BusinessUserState["ACTIVE"] = "ACTIVE";
  BusinessUserState["DEACTIVATING"] = "DEACTIVATING";
  BusinessUserState["DEACTIVATED"] = "DEACTIVATED";
  BusinessUserState["PENDING"] = "PENDING";
})(BusinessUserState || (BusinessUserState = {}));

var CallStatus;

(function (CallStatus) {
  CallStatus["QUEUED"] = "QUEUED";
  CallStatus["INITIATED"] = "INITIATED";
  CallStatus["RINGING"] = "RINGING";
  CallStatus["IN_PROGRESS"] = "IN_PROGRESS";
  CallStatus["COMPLETED"] = "COMPLETED";
  CallStatus["BUSY"] = "BUSY";
  CallStatus["NO_ANSWER"] = "NO_ANSWER";
  CallStatus["CANCELLED"] = "CANCELLED";
  CallStatus["FAILED"] = "FAILED";
  CallStatus["OTHER"] = "OTHER";
})(CallStatus || (CallStatus = {}));

var CallType;

(function (CallType) {
  CallType["EXPERT_TO_CONSUMER"] = "EXPERT_TO_CONSUMER";
  CallType["CONSUMER_TO_EXPERT"] = "CONSUMER_TO_EXPERT";
  CallType["APPLICANT_TO_ONBOARDING_SPECIALIST"] = "APPLICANT_TO_ONBOARDING_SPECIALIST";
  CallType["ONBOARDING_SPECIALIST_TO_APPLICANT"] = "ONBOARDING_SPECIALIST_TO_APPLICANT";
  CallType["OPERATOR_OUTGOING"] = "OPERATOR_OUTGOING";
  CallType["OPERATOR_INCOMING"] = "OPERATOR_INCOMING";
})(CallType || (CallType = {}));

var CampaignAudienceExternalPlatform;

(function (CampaignAudienceExternalPlatform) {
  CampaignAudienceExternalPlatform["FACEBOOK"] = "FACEBOOK";
})(CampaignAudienceExternalPlatform || (CampaignAudienceExternalPlatform = {}));

var CampaignAudienceFacebookValueType;

(function (CampaignAudienceFacebookValueType) {
  CampaignAudienceFacebookValueType["NONE"] = "NONE";
  CampaignAudienceFacebookValueType["PREDICTED_LIFETIME_VALUE"] = "PREDICTED_LIFETIME_VALUE";
  CampaignAudienceFacebookValueType["REVENUE"] = "REVENUE";
})(CampaignAudienceFacebookValueType || (CampaignAudienceFacebookValueType = {}));

var CampaignAudienceMemberType;

(function (CampaignAudienceMemberType) {
  CampaignAudienceMemberType["LEAD"] = "LEAD";
  CampaignAudienceMemberType["EXPERT"] = "EXPERT";
  CampaignAudienceMemberType["EXPERT_APPLICANT"] = "EXPERT_APPLICANT";
})(CampaignAudienceMemberType || (CampaignAudienceMemberType = {}));

var CampaignAudienceSort;

(function (CampaignAudienceSort) {
  CampaignAudienceSort["NAME"] = "NAME";
  CampaignAudienceSort["LAST_UPDATED"] = "LAST_UPDATED";
})(CampaignAudienceSort || (CampaignAudienceSort = {}));

var CampaignAudienceState;

(function (CampaignAudienceState) {
  CampaignAudienceState["DRAFT"] = "DRAFT";
  CampaignAudienceState["PUBLISHED"] = "PUBLISHED";
  CampaignAudienceState["ARCHIVED"] = "ARCHIVED";
})(CampaignAudienceState || (CampaignAudienceState = {}));

var CampaignDeliveryFrequency;

(function (CampaignDeliveryFrequency) {
  CampaignDeliveryFrequency["EMAIL"] = "EMAIL";
  CampaignDeliveryFrequency["SMS_LONG_CODE"] = "SMS_LONG_CODE";
  CampaignDeliveryFrequency["SMS_SHORT_CODE"] = "SMS_SHORT_CODE";
})(CampaignDeliveryFrequency || (CampaignDeliveryFrequency = {}));

var CampaignRecipientSortOrder;

(function (CampaignRecipientSortOrder) {
  CampaignRecipientSortOrder["MOST_RECENT_ACTIVITY"] = "MOST_RECENT_ACTIVITY";
  CampaignRecipientSortOrder["RANDOM"] = "RANDOM";
})(CampaignRecipientSortOrder || (CampaignRecipientSortOrder = {}));

var CampaignState;

(function (CampaignState) {
  CampaignState["DRAFT"] = "DRAFT";
  CampaignState["PREPARING"] = "PREPARING";
  CampaignState["PUBLISHED"] = "PUBLISHED";
  CampaignState["DELIVERING"] = "DELIVERING";
  CampaignState["DEACTIVATED"] = "DEACTIVATED";
})(CampaignState || (CampaignState = {}));

var CardFieldValidationStatus;

(function (CardFieldValidationStatus) {
  CardFieldValidationStatus["PASS"] = "PASS";
  CardFieldValidationStatus["FAIL"] = "FAIL";
  CardFieldValidationStatus["UNAVAILABLE"] = "UNAVAILABLE";
  CardFieldValidationStatus["UNCHECKED"] = "UNCHECKED";
})(CardFieldValidationStatus || (CardFieldValidationStatus = {}));

var CardFundingType;

(function (CardFundingType) {
  CardFundingType["UNKNOWN"] = "UNKNOWN";
  CardFundingType["CREDIT"] = "CREDIT";
  CardFundingType["DEBIT"] = "DEBIT";
  CardFundingType["PREPAID"] = "PREPAID";
})(CardFundingType || (CardFundingType = {}));

var CartSyncUseCase;

(function (CartSyncUseCase) {
  /** Syncing to display the cart */
  CartSyncUseCase["CART_VIEW"] = "CART_VIEW";
  /** Syncing to display during the checkout flow */

  CartSyncUseCase["CHECKOUT"] = "CHECKOUT";
})(CartSyncUseCase || (CartSyncUseCase = {}));

var CategoryTaxCaptureStrategy;

(function (CategoryTaxCaptureStrategy) {
  CategoryTaxCaptureStrategy["RE_EMIT"] = "RE_EMIT";
  CategoryTaxCaptureStrategy["PASS_THROUGH"] = "PASS_THROUGH";
  CategoryTaxCaptureStrategy["NONE"] = "NONE";
})(CategoryTaxCaptureStrategy || (CategoryTaxCaptureStrategy = {}));

var CategoryType;

(function (CategoryType) {
  CategoryType["PRODUCT"] = "PRODUCT";
  CategoryType["SERVICE"] = "SERVICE";
})(CategoryType || (CategoryType = {}));

var ChallengeType;

(function (ChallengeType) {
  ChallengeType["OTP"] = "OTP";
  ChallengeType["PASSWORD"] = "PASSWORD";
})(ChallengeType || (ChallengeType = {}));

var ChannelType;

(function (ChannelType) {
  ChannelType["EMAIL"] = "EMAIL";
  ChannelType["SMS"] = "SMS";
  ChannelType["INAPP"] = "INAPP";
  ChannelType["FACEBOOK"] = "FACEBOOK";
  ChannelType["PUSH_NOTIFICATION"] = "PUSH_NOTIFICATION";
  ChannelType["SLACK"] = "SLACK";
})(ChannelType || (ChannelType = {}));

var ClaimPromotionErrorCode;

(function (ClaimPromotionErrorCode) {
  ClaimPromotionErrorCode["NOT_FIRST_PURCHASE"] = "NOT_FIRST_PURCHASE";
  ClaimPromotionErrorCode["NO_PROMOTION_FOUND"] = "NO_PROMOTION_FOUND";
  ClaimPromotionErrorCode["LIMIT_EXCEEDED"] = "LIMIT_EXCEEDED";
  ClaimPromotionErrorCode["ALREADY_CLAIMED"] = "ALREADY_CLAIMED";
})(ClaimPromotionErrorCode || (ClaimPromotionErrorCode = {}));

var CloseTicketReason;

(function (CloseTicketReason) {
  CloseTicketReason["RESOLVED"] = "RESOLVED";
  CloseTicketReason["NO_ACTION_NEEDED"] = "NO_ACTION_NEEDED";
  CloseTicketReason["REQUESTER_DID_NOT_FOLLOWUP"] = "REQUESTER_DID_NOT_FOLLOWUP";
  CloseTicketReason["OPENED_NEW_TICKET"] = "OPENED_NEW_TICKET";
  CloseTicketReason["MERGED"] = "MERGED";
  CloseTicketReason["UNABLE_TO_PROCESS"] = "UNABLE_TO_PROCESS";
  CloseTicketReason["CANCELLATION_REQUESTED"] = "CANCELLATION_REQUESTED";
})(CloseTicketReason || (CloseTicketReason = {}));

var ConditionType;

(function (ConditionType) {
  ConditionType["ALWAYS_TRUE"] = "ALWAYS_TRUE";
  ConditionType["SUBJECT_ID_IN"] = "SUBJECT_ID_IN";
  ConditionType["STRING_BINARY"] = "STRING_BINARY";
  ConditionType["LOGICAL"] = "LOGICAL";
})(ConditionType || (ConditionType = {}));

var ConsumerInitialLeadAction;

(function (ConsumerInitialLeadAction) {
  ConsumerInitialLeadAction["BROWSE"] = "BROWSE";
  ConsumerInitialLeadAction["CHAT"] = "CHAT";
})(ConsumerInitialLeadAction || (ConsumerInitialLeadAction = {}));

var ConsumerReviewSearchSort;

(function (ConsumerReviewSearchSort) {
  ConsumerReviewSearchSort["RELEVANCE"] = "RELEVANCE";
  ConsumerReviewSearchSort["REVIEWED_AT"] = "REVIEWED_AT";
})(ConsumerReviewSearchSort || (ConsumerReviewSearchSort = {}));

var ConsumerReviewSource;

(function (ConsumerReviewSource) {
  ConsumerReviewSource["CURATED"] = "CURATED";
  ConsumerReviewSource["SHOPPER_APPROVED"] = "SHOPPER_APPROVED";
})(ConsumerReviewSource || (ConsumerReviewSource = {}));

var ConsumerSellableReactionRating;

(function (ConsumerSellableReactionRating) {
  ConsumerSellableReactionRating["SKIP"] = "SKIP";
  ConsumerSellableReactionRating["DISLIKE"] = "DISLIKE";
  ConsumerSellableReactionRating["LIKE"] = "LIKE";
  ConsumerSellableReactionRating["LOVE"] = "LOVE";
})(ConsumerSellableReactionRating || (ConsumerSellableReactionRating = {}));

var ConsumerSellableReactionReason;

(function (ConsumerSellableReactionReason) {
  ConsumerSellableReactionReason["PRICE"] = "PRICE";
  ConsumerSellableReactionReason["BRAND"] = "BRAND";
  ConsumerSellableReactionReason["STYLE"] = "STYLE";
  ConsumerSellableReactionReason["FEATURES"] = "FEATURES";
})(ConsumerSellableReactionReason || (ConsumerSellableReactionReason = {}));

var ConsumerSellableReactionSource;

(function (ConsumerSellableReactionSource) {
  ConsumerSellableReactionSource["SYSTEM_CURATED_ITEM_SURVEY"] = "SYSTEM_CURATED_ITEM_SURVEY";
  ConsumerSellableReactionSource["FAVORITES_PAGE"] = "FAVORITES_PAGE";
  ConsumerSellableReactionSource["SEARCH_RESULTS"] = "SEARCH_RESULTS";
  ConsumerSellableReactionSource["PRODUCT_DETAILS"] = "PRODUCT_DETAILS";
})(ConsumerSellableReactionSource || (ConsumerSellableReactionSource = {}));

var ContactType;

(function (ContactType) {
  ContactType["PHONE"] = "PHONE";
  ContactType["EMAIL"] = "EMAIL";
  ContactType["FACEBOOK"] = "FACEBOOK";
  ContactType["PUSH_NOTIFICATION"] = "PUSH_NOTIFICATION";
})(ContactType || (ContactType = {}));

var ContentSelectionAdLevel;

(function (ContentSelectionAdLevel) {
  ContentSelectionAdLevel["NONE"] = "NONE";
  ContentSelectionAdLevel["AD"] = "AD";
  ContentSelectionAdLevel["AD_GROUP"] = "AD_GROUP";
  ContentSelectionAdLevel["CAMPAIGN"] = "CAMPAIGN";
  ContentSelectionAdLevel["SOURCE"] = "SOURCE";
})(ContentSelectionAdLevel || (ContentSelectionAdLevel = {}));

var ContentSelectionChannelType;

(function (ContentSelectionChannelType) {
  ContentSelectionChannelType["ENGAGEMENT_CHANNEL"] = "ENGAGEMENT_CHANNEL";
  ContentSelectionChannelType["LANDING_PAGE"] = "LANDING_PAGE";
  ContentSelectionChannelType["EXPERT_HIRING"] = "EXPERT_HIRING";
  ContentSelectionChannelType["PRODUCT_DETAIL"] = "PRODUCT_DETAIL";
})(ContentSelectionChannelType || (ContentSelectionChannelType = {}));

var ContentSelectionDeviceType;

(function (ContentSelectionDeviceType) {
  ContentSelectionDeviceType["DESKTOP"] = "DESKTOP";
  ContentSelectionDeviceType["MOBILE_WEB"] = "MOBILE_WEB";
})(ContentSelectionDeviceType || (ContentSelectionDeviceType = {}));

var ContentSelectionMethodType;

(function (ContentSelectionMethodType) {
  ContentSelectionMethodType["EXPERIMENT"] = "EXPERIMENT";
  ContentSelectionMethodType["HARDCODED"] = "HARDCODED";
})(ContentSelectionMethodType || (ContentSelectionMethodType = {}));

var ConversationStarterContextType;

(function (ConversationStarterContextType) {
  ConversationStarterContextType["SELLABLE_SEARCH"] = "SELLABLE_SEARCH";
  ConversationStarterContextType["SELLABLE"] = "SELLABLE";
})(ConversationStarterContextType || (ConversationStarterContextType = {}));

var ConversationStarterLocation;

(function (ConversationStarterLocation) {
  ConversationStarterLocation["RECOMMENDED_LIST_PAGE"] = "RECOMMENDED_LIST_PAGE";
  ConversationStarterLocation["SELLABLE_PAGE_COMPARISON_MODULE"] = "SELLABLE_PAGE_COMPARISON_MODULE";
  ConversationStarterLocation["SELLABLE_PAGE_CONFIGURATION_MODULE"] = "SELLABLE_PAGE_CONFIGURATION_MODULE";
})(ConversationStarterLocation || (ConversationStarterLocation = {}));

var DatePathFlowQuestionType;

(function (DatePathFlowQuestionType) {
  DatePathFlowQuestionType["DATE"] = "DATE";
  DatePathFlowQuestionType["DATE_TIME"] = "DATE_TIME";
})(DatePathFlowQuestionType || (DatePathFlowQuestionType = {}));

var DateRangeFilterField;

(function (DateRangeFilterField) {
  DateRangeFilterField["LAST_PAID_DATE"] = "LAST_PAID_DATE";
  DateRangeFilterField["CREATED_DATE"] = "CREATED_DATE";
  DateRangeFilterField["LAST_CURATION_DATE"] = "LAST_CURATION_DATE";
  DateRangeFilterField["LAST_ACTIVITY_DATE"] = "LAST_ACTIVITY_DATE";
  DateRangeFilterField["ORDER_PAID_DATE"] = "ORDER_PAID_DATE";
  DateRangeFilterField["STARTED_DATE"] = "STARTED_DATE";
  DateRangeFilterField["COMPLETED_DATE"] = "COMPLETED_DATE";
  DateRangeFilterField["DUE_DATE"] = "DUE_DATE";
  DateRangeFilterField["LAST_MARKETING_EMAIL_SENT_DATE"] = "LAST_MARKETING_EMAIL_SENT_DATE";
  DateRangeFilterField["LAST_MARKETING_TEXT_SENT_DATE"] = "LAST_MARKETING_TEXT_SENT_DATE";
  DateRangeFilterField["LAST_MARKETING_CHAT_SENT_DATE"] = "LAST_MARKETING_CHAT_SENT_DATE";
  DateRangeFilterField["LAST_MARKETING_EMAIL_OPENED_DATE"] = "LAST_MARKETING_EMAIL_OPENED_DATE";
  DateRangeFilterField["LAST_MARKETING_EMAIL_CLICKED_DATE"] = "LAST_MARKETING_EMAIL_CLICKED_DATE";
  DateRangeFilterField["LAST_MARKETING_TEXT_CLICKED_DATE"] = "LAST_MARKETING_TEXT_CLICKED_DATE";
  DateRangeFilterField["LAST_MARKETING_CHAT_CLICKED_DATE"] = "LAST_MARKETING_CHAT_CLICKED_DATE";
  DateRangeFilterField["LAST_MARKETING_EMAIL_RESPONDED_DATE"] = "LAST_MARKETING_EMAIL_RESPONDED_DATE";
  DateRangeFilterField["LAST_MARKETING_TEXT_RESPONDED_DATE"] = "LAST_MARKETING_TEXT_RESPONDED_DATE";
  DateRangeFilterField["LAST_MARKETING_CHAT_RESPONDED_DATE"] = "LAST_MARKETING_CHAT_RESPONDED_DATE";
  DateRangeFilterField["LAST_MARKETING_ENGAGED_DATE"] = "LAST_MARKETING_ENGAGED_DATE";
})(DateRangeFilterField || (DateRangeFilterField = {}));

var DateRangePathFlowQuestionType;

(function (DateRangePathFlowQuestionType) {
  DateRangePathFlowQuestionType["DATE"] = "DATE";
  DateRangePathFlowQuestionType["DATE_TIME"] = "DATE_TIME";
})(DateRangePathFlowQuestionType || (DateRangePathFlowQuestionType = {}));

var DayOfWeek;

(function (DayOfWeek) {
  DayOfWeek["MONDAY"] = "MONDAY";
  DayOfWeek["TUESDAY"] = "TUESDAY";
  DayOfWeek["WEDNESDAY"] = "WEDNESDAY";
  DayOfWeek["THURSDAY"] = "THURSDAY";
  DayOfWeek["FRIDAY"] = "FRIDAY";
  DayOfWeek["SATURDAY"] = "SATURDAY";
  DayOfWeek["SUNDAY"] = "SUNDAY";
})(DayOfWeek || (DayOfWeek = {}));

var DealState;

(function (DealState) {
  DealState["ACTIVE"] = "ACTIVE";
  DealState["INACTIVE"] = "INACTIVE";
})(DealState || (DealState = {}));

var DealTermsType;

(function (DealTermsType) {
  DealTermsType["PRODUCT"] = "PRODUCT";
  DealTermsType["SERVICE"] = "SERVICE";
})(DealTermsType || (DealTermsType = {}));

var DepartmentNavigationLabelStyle;

(function (DepartmentNavigationLabelStyle) {
  DepartmentNavigationLabelStyle["BOLD"] = "BOLD";
})(DepartmentNavigationLabelStyle || (DepartmentNavigationLabelStyle = {}));

var DepartmentNavigationResponsiveFullSizeOptions;

(function (DepartmentNavigationResponsiveFullSizeOptions) {
  DepartmentNavigationResponsiveFullSizeOptions["SHOW"] = "SHOW";
})(DepartmentNavigationResponsiveFullSizeOptions || (DepartmentNavigationResponsiveFullSizeOptions = {}));

var DepartmentNavigationResponsiveSmallSizeOptions;

(function (DepartmentNavigationResponsiveSmallSizeOptions) {
  /** Show element in persistent element attached to the chrome. */
  DepartmentNavigationResponsiveSmallSizeOptions["SHOW_IN_PERSISTENT_HEADER"] = "SHOW_IN_PERSISTENT_HEADER";
  /** Show element in flyout panel that expands from the side of the page */

  DepartmentNavigationResponsiveSmallSizeOptions["SHOW_IN_FLYOUT_PANEL"] = "SHOW_IN_FLYOUT_PANEL";
})(DepartmentNavigationResponsiveSmallSizeOptions || (DepartmentNavigationResponsiveSmallSizeOptions = {}));
/**
 * Best effort enumeration of available departments for easy type safe comparisons.
 * There is no guarantee all departments will have a department type. The departments that are not assigned an
 * explicit type will be assigned `OTHER`.
 */


var DepartmentType;

(function (DepartmentType) {
  DepartmentType["CYCLING"] = "CYCLING";
  DepartmentType["CAMPING"] = "CAMPING";
  DepartmentType["CURATED_INTERNAL"] = "CURATED_INTERNAL";
  DepartmentType["FISHING"] = "FISHING";
  DepartmentType["GOLF"] = "GOLF";
  DepartmentType["JEWELRY"] = "JEWELRY";
  DepartmentType["JET_CHARTERS"] = "JET_CHARTERS";
  DepartmentType["OTHER"] = "OTHER";
  DepartmentType["WINTER_SPORTS"] = "WINTER_SPORTS";
  DepartmentType["YACHT_CHARTERS"] = "YACHT_CHARTERS";
  DepartmentType["WINE"] = "WINE";
})(DepartmentType || (DepartmentType = {}));

var DependencyUpdateType;

(function (DependencyUpdateType) {
  DependencyUpdateType["BLOCKED_BY"] = "BLOCKED_BY";
  DependencyUpdateType["UNBLOCKED_BY"] = "UNBLOCKED_BY";
})(DependencyUpdateType || (DependencyUpdateType = {}));

var DurationUnit;

(function (DurationUnit) {
  DurationUnit["NANOS"] = "NANOS";
  DurationUnit["MILLIS"] = "MILLIS";
  DurationUnit["SECONDS"] = "SECONDS";
  DurationUnit["MINUTES"] = "MINUTES";
  DurationUnit["HOURS"] = "HOURS";
  DurationUnit["DAYS"] = "DAYS";
})(DurationUnit || (DurationUnit = {}));

var EditableUserSourceType;

(function (EditableUserSourceType) {
  EditableUserSourceType["ORGANIC"] = "ORGANIC";
  EditableUserSourceType["INVESTOR"] = "INVESTOR";
})(EditableUserSourceType || (EditableUserSourceType = {}));

var EmbedMediaType;

(function (EmbedMediaType) {
  EmbedMediaType["YOUTUBE"] = "YOUTUBE";
})(EmbedMediaType || (EmbedMediaType = {}));

var EndPathNodeConfigType;

(function (EndPathNodeConfigType) {
  EndPathNodeConfigType["ACCOUNT_LEAD_REDIRECT"] = "ACCOUNT_LEAD_REDIRECT";
  EndPathNodeConfigType["ACCOUNT_EXPERT_APPLICATION_REDIRECT"] = "ACCOUNT_EXPERT_APPLICATION_REDIRECT";
  EndPathNodeConfigType["CONSUMER_EXPERT_REVIEW_REDIRECT"] = "CONSUMER_EXPERT_REVIEW_REDIRECT";
  EndPathNodeConfigType["SURVEY_REDIRECT"] = "SURVEY_REDIRECT";
  EndPathNodeConfigType["REDIRECT"] = "REDIRECT";
})(EndPathNodeConfigType || (EndPathNodeConfigType = {}));

var EntityCreatedTypePathGraphFlowEvent;

(function (EntityCreatedTypePathGraphFlowEvent) {
  EntityCreatedTypePathGraphFlowEvent["USER"] = "USER";
  EntityCreatedTypePathGraphFlowEvent["DEAL_REQUEST"] = "DEAL_REQUEST";
  EntityCreatedTypePathGraphFlowEvent["LEAD"] = "LEAD";
  EntityCreatedTypePathGraphFlowEvent["CONSUMER_EXPERT_REVIEW"] = "CONSUMER_EXPERT_REVIEW";
  EntityCreatedTypePathGraphFlowEvent["EXPERT_APPLICATION"] = "EXPERT_APPLICATION";
  EntityCreatedTypePathGraphFlowEvent["SURVEY_RESPONSE"] = "SURVEY_RESPONSE";
})(EntityCreatedTypePathGraphFlowEvent || (EntityCreatedTypePathGraphFlowEvent = {}));

var Environment;

(function (Environment) {
  Environment["DEVELOPMENT"] = "DEVELOPMENT";
  Environment["STAGING"] = "STAGING";
  Environment["PRODUCTION"] = "PRODUCTION";
})(Environment || (Environment = {}));

var EscalationItemCondition;

(function (EscalationItemCondition) {
  EscalationItemCondition["NEW"] = "NEW";
  EscalationItemCondition["GOOD"] = "GOOD";
  EscalationItemCondition["OKAY"] = "OKAY";
})(EscalationItemCondition || (EscalationItemCondition = {}));

var EscalationResolution;

(function (EscalationResolution) {
  EscalationResolution["ORDER_CANCELLED"] = "ORDER_CANCELLED";
  EscalationResolution["UNAVAILABLE_INVENTORY"] = "UNAVAILABLE_INVENTORY";
  EscalationResolution["REPLACEMENT_FOUND"] = "REPLACEMENT_FOUND";
})(EscalationResolution || (EscalationResolution = {}));

var ExperimentSortBy;

(function (ExperimentSortBy) {
  ExperimentSortBy["DEFAULT"] = "DEFAULT";
  ExperimentSortBy["NAME"] = "NAME";
  ExperimentSortBy["CREATED_AT"] = "CREATED_AT";
  ExperimentSortBy["UPDATED_AT"] = "UPDATED_AT";
})(ExperimentSortBy || (ExperimentSortBy = {}));

var ExperimentState;

(function (ExperimentState) {
  ExperimentState["ACTIVE"] = "ACTIVE";
  ExperimentState["ARCHIVED"] = "ARCHIVED";
})(ExperimentState || (ExperimentState = {}));

var ExperimentUsageType;

(function (ExperimentUsageType) {
  ExperimentUsageType["CODE"] = "CODE";
  ExperimentUsageType["TRIGGER"] = "TRIGGER";
  ExperimentUsageType["CONTENT_SELECTION_RULE"] = "CONTENT_SELECTION_RULE";
  ExperimentUsageType["TEMPLATE"] = "TEMPLATE";
})(ExperimentUsageType || (ExperimentUsageType = {}));

var ExpertApplicationFolderItemChangeType;

(function (ExpertApplicationFolderItemChangeType) {
  ExpertApplicationFolderItemChangeType["ADD"] = "ADD";
  ExpertApplicationFolderItemChangeType["REMOVE"] = "REMOVE";
  ExpertApplicationFolderItemChangeType["UPDATE"] = "UPDATE";
})(ExpertApplicationFolderItemChangeType || (ExpertApplicationFolderItemChangeType = {}));

var ExpertApplicationFolderType;

(function (ExpertApplicationFolderType) {
  ExpertApplicationFolderType["PIPELINE"] = "PIPELINE";
  ExpertApplicationFolderType["FOLDERS"] = "FOLDERS";
})(ExpertApplicationFolderType || (ExpertApplicationFolderType = {}));

var ExpertApplicationInterviewState;

(function (ExpertApplicationInterviewState) {
  ExpertApplicationInterviewState["PENDING"] = "PENDING";
  ExpertApplicationInterviewState["COMPLETED"] = "COMPLETED";
})(ExpertApplicationInterviewState || (ExpertApplicationInterviewState = {}));

var ExpertApplicationInterviewType;

(function (ExpertApplicationInterviewType) {
  ExpertApplicationInterviewType["SPARK_HIRE"] = "SPARK_HIRE";
})(ExpertApplicationInterviewType || (ExpertApplicationInterviewType = {}));

var ExpertApplicationRating;

(function (ExpertApplicationRating) {
  ExpertApplicationRating["YES"] = "YES";
  ExpertApplicationRating["NO"] = "NO";
})(ExpertApplicationRating || (ExpertApplicationRating = {}));

var ExpertApplicationSearchSort;

(function (ExpertApplicationSearchSort) {
  ExpertApplicationSearchSort["DEFAULT"] = "DEFAULT";
  ExpertApplicationSearchSort["APPLICATION_SUBMITTED_AT"] = "APPLICATION_SUBMITTED_AT";
})(ExpertApplicationSearchSort || (ExpertApplicationSearchSort = {}));

var ExpertApplicationState;

(function (ExpertApplicationState) {
  ExpertApplicationState["REJECTED"] = "REJECTED";
  ExpertApplicationState["ONBOARDED"] = "ONBOARDED";
  ExpertApplicationState["SCHEDULING"] = "SCHEDULING";
  ExpertApplicationState["FINAL_EVALUATION"] = "FINAL_EVALUATION";
  ExpertApplicationState["ONBOARDING"] = "ONBOARDING";
  ExpertApplicationState["APPROVED"] = "APPROVED";
  ExpertApplicationState["PENDING"] = "PENDING";
})(ExpertApplicationState || (ExpertApplicationState = {}));

var ExpertApplicationSubscriptionChangeType;

(function (ExpertApplicationSubscriptionChangeType) {
  ExpertApplicationSubscriptionChangeType["ADD"] = "ADD";
  ExpertApplicationSubscriptionChangeType["REMOVE"] = "REMOVE";
})(ExpertApplicationSubscriptionChangeType || (ExpertApplicationSubscriptionChangeType = {}));

var ExpertApplicationSuggestedActionDismissReason;

(function (ExpertApplicationSuggestedActionDismissReason) {
  ExpertApplicationSuggestedActionDismissReason["ACTION_COMPLETED"] = "ACTION_COMPLETED";
  ExpertApplicationSuggestedActionDismissReason["NOT_APPLICABLE"] = "NOT_APPLICABLE";
})(ExpertApplicationSuggestedActionDismissReason || (ExpertApplicationSuggestedActionDismissReason = {}));

var ExpertApplicationSuggestedActionType;

(function (ExpertApplicationSuggestedActionType) {
  ExpertApplicationSuggestedActionType["FOLLOW_UP"] = "FOLLOW_UP";
  ExpertApplicationSuggestedActionType["RESPOND_TO_MESSAGE"] = "RESPOND_TO_MESSAGE";
  ExpertApplicationSuggestedActionType["PERFORM_TASK"] = "PERFORM_TASK";
})(ExpertApplicationSuggestedActionType || (ExpertApplicationSuggestedActionType = {}));

var ExpertApplicationTaskState;

(function (ExpertApplicationTaskState) {
  ExpertApplicationTaskState["NOT_STARTED"] = "NOT_STARTED";
  ExpertApplicationTaskState["IN_PROGRESS"] = "IN_PROGRESS";
  ExpertApplicationTaskState["ERROR"] = "ERROR";
  ExpertApplicationTaskState["COMPLETED"] = "COMPLETED";
})(ExpertApplicationTaskState || (ExpertApplicationTaskState = {}));

var ExpertApplicationTaskType;

(function (ExpertApplicationTaskType) {
  ExpertApplicationTaskType["CALL_APPLICANT"] = "CALL_APPLICANT";
  ExpertApplicationTaskType["APPROVE_PROFILE"] = "APPROVE_PROFILE";
  ExpertApplicationTaskType["SIGN_CONTRACT"] = "SIGN_CONTRACT";
  ExpertApplicationTaskType["SETUP_PAYROLL"] = "SETUP_PAYROLL";
  ExpertApplicationTaskType["COMPLETE_TRAINING"] = "COMPLETE_TRAINING";
  ExpertApplicationTaskType["SETUP_7SHIFT"] = "SETUP_7SHIFT";
  ExpertApplicationTaskType["SETUP_SLACK"] = "SETUP_SLACK";
  ExpertApplicationTaskType["COMPLETE_HOMEWORK"] = "COMPLETE_HOMEWORK";
  ExpertApplicationTaskType["WAIT_FOR_SCHEDULING"] = "WAIT_FOR_SCHEDULING";
  ExpertApplicationTaskType["ADD_AVAILABILITY"] = "ADD_AVAILABILITY";
  ExpertApplicationTaskType["SCHEDULE_SHIFT"] = "SCHEDULE_SHIFT";
  ExpertApplicationTaskType["COMPLETE_FIRST_SHIFT"] = "COMPLETE_FIRST_SHIFT";
  ExpertApplicationTaskType["PASS_RESPONSIVE_EVAL"] = "PASS_RESPONSIVE_EVAL";
  ExpertApplicationTaskType["PASS_SKILL_EVAL"] = "PASS_SKILL_EVAL";
  ExpertApplicationTaskType["ACTIVATE_SCHEDULING"] = "ACTIVATE_SCHEDULING";
  ExpertApplicationTaskType["ACTIVATE_EXPERT_ACCOUNT"] = "ACTIVATE_EXPERT_ACCOUNT";
  ExpertApplicationTaskType["GET_GOOGLE_SITE_ACCESS"] = "GET_GOOGLE_SITE_ACCESS";
  ExpertApplicationTaskType["ASSIGN_TO_TEAM"] = "ASSIGN_TO_TEAM";
  ExpertApplicationTaskType["DOWNLOAD_MOBILE_APP"] = "DOWNLOAD_MOBILE_APP";
  ExpertApplicationTaskType["COMPLETE_ONE_WAY_INTERVIEW"] = "COMPLETE_ONE_WAY_INTERVIEW";
  ExpertApplicationTaskType["ATTEND_KICKOFF_METTING"] = "ATTEND_KICKOFF_METTING";
  ExpertApplicationTaskType["SHADOW_LIVE_SHIFT"] = "SHADOW_LIVE_SHIFT";
  ExpertApplicationTaskType["SIGN_NDA"] = "SIGN_NDA";
  ExpertApplicationTaskType["CREATE_PROFILE"] = "CREATE_PROFILE";
  ExpertApplicationTaskType["SCHEDULE_FINAL_EVAL"] = "SCHEDULE_FINAL_EVAL";
})(ExpertApplicationTaskType || (ExpertApplicationTaskType = {}));

var ExpertCommissionRefundTreatment;

(function (ExpertCommissionRefundTreatment) {
  ExpertCommissionRefundTreatment["ALL_EXEMPT"] = "ALL_EXEMPT";
  ExpertCommissionRefundTreatment["TIP_EXEMPT"] = "TIP_EXEMPT";
  ExpertCommissionRefundTreatment["NOT_EXEMPT"] = "NOT_EXEMPT";
})(ExpertCommissionRefundTreatment || (ExpertCommissionRefundTreatment = {}));

var ExpertCuratedItemNoteSort;

(function (ExpertCuratedItemNoteSort) {
  ExpertCuratedItemNoteSort["USE_COUNT"] = "USE_COUNT";
  ExpertCuratedItemNoteSort["CREATED_AT"] = "CREATED_AT";
  ExpertCuratedItemNoteSort["UPDATED_AT"] = "UPDATED_AT";
})(ExpertCuratedItemNoteSort || (ExpertCuratedItemNoteSort = {}));

var ExpertCuratedItemNoteState;

(function (ExpertCuratedItemNoteState) {
  /** Single use note */
  ExpertCuratedItemNoteState["NONE"] = "NONE";
  /** Editable note. On activation this becomes either NONE or PENDING */

  ExpertCuratedItemNoteState["DRAFT"] = "DRAFT";
  /** Waiting to be reviewed by operator */

  ExpertCuratedItemNoteState["PENDING"] = "PENDING";
  /** Approved by operator */

  ExpertCuratedItemNoteState["APPROVED"] = "APPROVED";
  /** Rejected by operator */

  ExpertCuratedItemNoteState["REJECTED"] = "REJECTED";
  /** Archived by operator or system. soft delete */

  ExpertCuratedItemNoteState["ARCHIVED"] = "ARCHIVED";
})(ExpertCuratedItemNoteState || (ExpertCuratedItemNoteState = {}));

var ExpertCuratedItemPriceOverrideReasonType;

(function (ExpertCuratedItemPriceOverrideReasonType) {
  ExpertCuratedItemPriceOverrideReasonType["PRICE_MATCH"] = "PRICE_MATCH";
  ExpertCuratedItemPriceOverrideReasonType["SPECIAL_DISCOUNT"] = "SPECIAL_DISCOUNT";
  ExpertCuratedItemPriceOverrideReasonType["OTHER"] = "OTHER";
  ExpertCuratedItemPriceOverrideReasonType["SECRET_DEAL"] = "SECRET_DEAL";
})(ExpertCuratedItemPriceOverrideReasonType || (ExpertCuratedItemPriceOverrideReasonType = {}));

var ExpertCuratedItemRankChangeType;

(function (ExpertCuratedItemRankChangeType) {
  ExpertCuratedItemRankChangeType["INCREMENT"] = "INCREMENT";
  ExpertCuratedItemRankChangeType["DECREMENT"] = "DECREMENT";
})(ExpertCuratedItemRankChangeType || (ExpertCuratedItemRankChangeType = {}));

var ExpertCuratedItemRemovedReason;

(function (ExpertCuratedItemRemovedReason) {
  /** Internal reason used when an item is replaced/updated */
  ExpertCuratedItemRemovedReason["REPLACED"] = "REPLACED";
  /** Should be provided by experts to indicate they removed the item (no further reason is required for them) */

  ExpertCuratedItemRemovedReason["REMOVED_BY_EXPERT"] = "REMOVED_BY_EXPERT";
  /** Default reason that should be used if the user isn't prompted for the remaining reasons */

  ExpertCuratedItemRemovedReason["NOT_INTERESTED"] = "NOT_INTERESTED";
  ExpertCuratedItemRemovedReason["TOO_EXPENSIVE"] = "TOO_EXPENSIVE";
  ExpertCuratedItemRemovedReason["LOW_QUALITY"] = "LOW_QUALITY";
  ExpertCuratedItemRemovedReason["UGLY"] = "UGLY";
  ExpertCuratedItemRemovedReason["DONT_NEED"] = "DONT_NEED";
  ExpertCuratedItemRemovedReason["BOUGHT_ELSEWHERE"] = "BOUGHT_ELSEWHERE";
  ExpertCuratedItemRemovedReason["OTHER"] = "OTHER";
})(ExpertCuratedItemRemovedReason || (ExpertCuratedItemRemovedReason = {}));

var ExpertCuratedItemSort;

(function (ExpertCuratedItemSort) {
  /** Use the default sorting; this is the default, and should always be used in the consumer use case. */
  ExpertCuratedItemSort["DEFAULT"] = "DEFAULT";
  /**
   * Sort only by createdAt which guarantees consistent sorting when the expert is modifying expert curated items
   * (e.g.: changing the tags, which typically changes sort order)
   */

  ExpertCuratedItemSort["CREATED_AT"] = "CREATED_AT";
})(ExpertCuratedItemSort || (ExpertCuratedItemSort = {}));
/** Basic filters based on state. When multiple filters are applied, they are OR-ed together. */


var ExpertCuratedItemStateFilter;

(function (ExpertCuratedItemStateFilter) {
  /** Include items that are in draft state (only valid for experts) */
  ExpertCuratedItemStateFilter["DRAFT"] = "DRAFT";
  /** Include items that are active (not in draft state, not removed) */

  ExpertCuratedItemStateFilter["ACTIVE"] = "ACTIVE";
  /** Include items that are removed */

  ExpertCuratedItemStateFilter["REMOVED"] = "REMOVED";
  /** Include items that not removed */

  ExpertCuratedItemStateFilter["NOT_REMOVED"] = "NOT_REMOVED";
})(ExpertCuratedItemStateFilter || (ExpertCuratedItemStateFilter = {}));

var ExpertCuratedItemTagType;

(function (ExpertCuratedItemTagType) {
  ExpertCuratedItemTagType["SPECIAL_OFFER"] = "SPECIAL_OFFER";
  ExpertCuratedItemTagType["THE_ALTERNATIVE"] = "THE_ALTERNATIVE";
  ExpertCuratedItemTagType["SALE_PRICE"] = "SALE_PRICE";
  ExpertCuratedItemTagType["EXPERT_PICK"] = "EXPERT_PICK";
  ExpertCuratedItemTagType["BUDGET_PICK"] = "BUDGET_PICK";
  ExpertCuratedItemTagType["CUSTOM"] = "CUSTOM";
  ExpertCuratedItemTagType["OTHER"] = "OTHER";
})(ExpertCuratedItemTagType || (ExpertCuratedItemTagType = {}));

var ExpertCuratedItemWriteErrorType;

(function (ExpertCuratedItemWriteErrorType) {
  ExpertCuratedItemWriteErrorType["UPDATE_ALREADY_EXISTS"] = "UPDATE_ALREADY_EXISTS";
})(ExpertCuratedItemWriteErrorType || (ExpertCuratedItemWriteErrorType = {}));

var ExpertCuratedOrderClosedReason;

(function (ExpertCuratedOrderClosedReason) {
  ExpertCuratedOrderClosedReason["MANUAL"] = "MANUAL";
  ExpertCuratedOrderClosedReason["REPLACED"] = "REPLACED";
})(ExpertCuratedOrderClosedReason || (ExpertCuratedOrderClosedReason = {}));

var ExpertCuratedOrderSelectErrorCode;

(function (ExpertCuratedOrderSelectErrorCode) {
  /**
   * Expert curated order is not in an active state. This may be due to the curated order being replaced, or manually
   * closed. If being replaced, {@link #getActiveReplacement()} will have the updated curated order.
   */
  ExpertCuratedOrderSelectErrorCode["NOT_ACTIVE"] = "NOT_ACTIVE";
})(ExpertCuratedOrderSelectErrorCode || (ExpertCuratedOrderSelectErrorCode = {}));

var ExpertCuratedOrderServiceLocationErrorCode;

(function (ExpertCuratedOrderServiceLocationErrorCode) {
  /** An invalid address was supplied. */
  ExpertCuratedOrderServiceLocationErrorCode["INVALID_ADDRESS"] = "INVALID_ADDRESS";
})(ExpertCuratedOrderServiceLocationErrorCode || (ExpertCuratedOrderServiceLocationErrorCode = {}));

var ExpertCuratedOrdersForLeadQueryCustomFilter;

(function (ExpertCuratedOrdersForLeadQueryCustomFilter) {
  /** Show custom and not custom */
  ExpertCuratedOrdersForLeadQueryCustomFilter["INCLUDE"] = "INCLUDE";
  /** Only show custom */

  ExpertCuratedOrdersForLeadQueryCustomFilter["ONLY"] = "ONLY";
  /** Show no custom; only non custom */

  ExpertCuratedOrdersForLeadQueryCustomFilter["NONE"] = "NONE";
})(ExpertCuratedOrdersForLeadQueryCustomFilter || (ExpertCuratedOrdersForLeadQueryCustomFilter = {}));

var ExpertCuratedOrdersForLeadQueryDraftFilter;

(function (ExpertCuratedOrdersForLeadQueryDraftFilter) {
  /** Show all drafts and non drafts */
  ExpertCuratedOrdersForLeadQueryDraftFilter["INCLUDE"] = "INCLUDE";
  /** Show drafts that are newly created (not from replacing an existing curated order) and non drafts */

  ExpertCuratedOrdersForLeadQueryDraftFilter["INCLUDE_CREATED_DRAFT"] = "INCLUDE_CREATED_DRAFT";
  /** Only show drafts (and no non drafts) */

  ExpertCuratedOrdersForLeadQueryDraftFilter["ONLY"] = "ONLY";
  /** Show no drafts; only non drafts */

  ExpertCuratedOrdersForLeadQueryDraftFilter["NONE"] = "NONE";
})(ExpertCuratedOrdersForLeadQueryDraftFilter || (ExpertCuratedOrdersForLeadQueryDraftFilter = {}));

var ExpertCuratedOrderState;

(function (ExpertCuratedOrderState) {
  ExpertCuratedOrderState["DRAFT"] = "DRAFT";
  ExpertCuratedOrderState["ACTIVE"] = "ACTIVE";
  ExpertCuratedOrderState["CLOSED"] = "CLOSED";
  ExpertCuratedOrderState["EXPIRED"] = "EXPIRED";
})(ExpertCuratedOrderState || (ExpertCuratedOrderState = {}));

var ExpertGender;

(function (ExpertGender) {
  ExpertGender["MALE"] = "MALE";
  ExpertGender["FEMALE"] = "FEMALE";
  ExpertGender["OTHER"] = "OTHER";
})(ExpertGender || (ExpertGender = {}));

var ExpertHiringFeedbackState;

(function (ExpertHiringFeedbackState) {
  ExpertHiringFeedbackState["DRAFT"] = "DRAFT";
  ExpertHiringFeedbackState["SUBMITTED"] = "SUBMITTED";
})(ExpertHiringFeedbackState || (ExpertHiringFeedbackState = {}));

var ExpertHiringFeedbackType;

(function (ExpertHiringFeedbackType) {
  ExpertHiringFeedbackType["INTERVIEW_FEEDBACK"] = "INTERVIEW_FEEDBACK";
  ExpertHiringFeedbackType["APPLICATION_EVALUATION"] = "APPLICATION_EVALUATION";
  ExpertHiringFeedbackType["APPLICATION_RATING"] = "APPLICATION_RATING";
})(ExpertHiringFeedbackType || (ExpertHiringFeedbackType = {}));

var ExpertLeadFolderGroupType;

(function (ExpertLeadFolderGroupType) {
  ExpertLeadFolderGroupType["INBOX"] = "INBOX";
  ExpertLeadFolderGroupType["INBOX_ASSISTANT"] = "INBOX_ASSISTANT";
  ExpertLeadFolderGroupType["SALES_PIPELINE"] = "SALES_PIPELINE";
  ExpertLeadFolderGroupType["FOLDERS"] = "FOLDERS";
})(ExpertLeadFolderGroupType || (ExpertLeadFolderGroupType = {}));

var ExpertLeadFolderItemChangeType;

(function (ExpertLeadFolderItemChangeType) {
  ExpertLeadFolderItemChangeType["ADD"] = "ADD";
  ExpertLeadFolderItemChangeType["REMOVE"] = "REMOVE";
  ExpertLeadFolderItemChangeType["UPDATE"] = "UPDATE";
})(ExpertLeadFolderItemChangeType || (ExpertLeadFolderItemChangeType = {}));

var ExpertLeadGateType;

(function (ExpertLeadGateType) {
  ExpertLeadGateType["NEW_EXPERT"] = "NEW_EXPERT";
  ExpertLeadGateType["ADMIN_OVERRIDE"] = "ADMIN_OVERRIDE";
})(ExpertLeadGateType || (ExpertLeadGateType = {}));

var ExpertNoteVisibilityType;

(function (ExpertNoteVisibilityType) {
  ExpertNoteVisibilityType["PUBLIC"] = "PUBLIC";
  ExpertNoteVisibilityType["PRIVATE"] = "PRIVATE";
})(ExpertNoteVisibilityType || (ExpertNoteVisibilityType = {}));

var ExpertNotificationMode;

(function (ExpertNotificationMode) {
  ExpertNotificationMode["NONE"] = "NONE";
  ExpertNotificationMode["ALWAYS"] = "ALWAYS";
  ExpertNotificationMode["WHEN_NOT_ACTIVATED"] = "WHEN_NOT_ACTIVATED";
  ExpertNotificationMode["WHEN_NOT_ONLINE"] = "WHEN_NOT_ONLINE";
})(ExpertNotificationMode || (ExpertNotificationMode = {}));

var ExpertNotificationType;

(function (ExpertNotificationType) {
  ExpertNotificationType["LEAD_ESCALATION"] = "LEAD_ESCALATION";
  ExpertNotificationType["PRESENCE_STATUS_CHANGE"] = "PRESENCE_STATUS_CHANGE";
  ExpertNotificationType["SHIFT_ENDED"] = "SHIFT_ENDED";
  ExpertNotificationType["LEAD_SURGE"] = "LEAD_SURGE";
})(ExpertNotificationType || (ExpertNotificationType = {}));

var ExpertPerformanceRating;

(function (ExpertPerformanceRating) {
  ExpertPerformanceRating["NEW"] = "NEW";
  ExpertPerformanceRating["MASTER"] = "MASTER";
  ExpertPerformanceRating["DIAMOND"] = "DIAMOND";
  ExpertPerformanceRating["PLATINUM"] = "PLATINUM";
  ExpertPerformanceRating["GOLD"] = "GOLD";
  ExpertPerformanceRating["SILVER"] = "SILVER";
  ExpertPerformanceRating["BRONZE"] = "BRONZE";
})(ExpertPerformanceRating || (ExpertPerformanceRating = {}));

var ExpertPresenceStatus;

(function (ExpertPresenceStatus) {
  ExpertPresenceStatus["OFF_SHIFT"] = "OFF_SHIFT";
  ExpertPresenceStatus["ON_SHIFT"] = "ON_SHIFT";
  ExpertPresenceStatus["ON_STANDBY"] = "ON_STANDBY";
  ExpertPresenceStatus["ON_CALL"] = "ON_CALL";
  ExpertPresenceStatus["AWAY"] = "AWAY";
})(ExpertPresenceStatus || (ExpertPresenceStatus = {}));

var ExpertProfileState;

(function (ExpertProfileState) {
  ExpertProfileState["DRAFT"] = "DRAFT";
  ExpertProfileState["SUBMITTED"] = "SUBMITTED";
  ExpertProfileState["PUBLISHED"] = "PUBLISHED";
})(ExpertProfileState || (ExpertProfileState = {}));

var ExpertRecommendationStrategy;

(function (ExpertRecommendationStrategy) {
  ExpertRecommendationStrategy["LEAST_WORKLOAD"] = "LEAST_WORKLOAD";
  ExpertRecommendationStrategy["PERFORMANCE_WEIGHTED"] = "PERFORMANCE_WEIGHTED";
  ExpertRecommendationStrategy["ASSISTANT_FIRST"] = "ASSISTANT_FIRST";
})(ExpertRecommendationStrategy || (ExpertRecommendationStrategy = {}));

var ExpertSearchSort;

(function (ExpertSearchSort) {
  ExpertSearchSort["DEFAULT"] = "DEFAULT";
  ExpertSearchSort["PERFORMANCE"] = "PERFORMANCE";
  ExpertSearchSort["FEATURED"] = "FEATURED";
})(ExpertSearchSort || (ExpertSearchSort = {}));

var ExternalAdPlatform;

(function (ExternalAdPlatform) {
  ExternalAdPlatform["FACEBOOK"] = "FACEBOOK";
  ExternalAdPlatform["GOOGLE"] = "GOOGLE";
})(ExternalAdPlatform || (ExternalAdPlatform = {}));

var ExternalAdStatus;

(function (ExternalAdStatus) {
  ExternalAdStatus["ACTIVE"] = "ACTIVE";
  ExternalAdStatus["PAUSED"] = "PAUSED";
  ExternalAdStatus["DELETED"] = "DELETED";
})(ExternalAdStatus || (ExternalAdStatus = {}));

var ExternalInventoryItemSourceType;

(function (ExternalInventoryItemSourceType) {
  ExternalInventoryItemSourceType["SHOPIFY"] = "SHOPIFY";
})(ExternalInventoryItemSourceType || (ExternalInventoryItemSourceType = {}));

var ExternalProfileType;

(function (ExternalProfileType) {
  ExternalProfileType["FACEBOOK_MESSENGER"] = "FACEBOOK_MESSENGER";
  ExternalProfileType["PIPL"] = "PIPL";
})(ExternalProfileType || (ExternalProfileType = {}));

var ExternalVideoIdType;

(function (ExternalVideoIdType) {
  ExternalVideoIdType["YOUTUBE"] = "YOUTUBE";
  ExternalVideoIdType["VIMEO"] = "VIMEO";
})(ExternalVideoIdType || (ExternalVideoIdType = {}));

var FacetImageType;

(function (FacetImageType) {
  /** Facets that are shown as Icons on the UI */
  FacetImageType["ICON"] = "ICON";
  /** BACKGROUND */

  FacetImageType["BACKGROUND"] = "BACKGROUND";
})(FacetImageType || (FacetImageType = {}));

var FilterConditionType;

(function (FilterConditionType) {
  FilterConditionType["FIELD"] = "FIELD";
  FilterConditionType["LOGICAL"] = "LOGICAL";
})(FilterConditionType || (FilterConditionType = {}));

var FilterFieldNumberType;

(function (FilterFieldNumberType) {
  FilterFieldNumberType["INTEGER"] = "INTEGER";
  FilterFieldNumberType["FLOAT"] = "FLOAT";
  FilterFieldNumberType["MONETARY_AMOUNT"] = "MONETARY_AMOUNT";
})(FilterFieldNumberType || (FilterFieldNumberType = {}));

var FilterLogicalOperator;

(function (FilterLogicalOperator) {
  FilterLogicalOperator["AND"] = "AND";
  FilterLogicalOperator["OR"] = "OR";
})(FilterLogicalOperator || (FilterLogicalOperator = {}));

var FlightPlanEditErrorCode;

(function (FlightPlanEditErrorCode) {
  FlightPlanEditErrorCode["EMPTY_LEGS"] = "EMPTY_LEGS";
  FlightPlanEditErrorCode["NO_SUCH_LEG"] = "NO_SUCH_LEG";
  FlightPlanEditErrorCode["MISSING_AIRPORT"] = "MISSING_AIRPORT";
  FlightPlanEditErrorCode["SAME_AIRPORT"] = "SAME_AIRPORT";
  FlightPlanEditErrorCode["OVERLAPPING_LEGS"] = "OVERLAPPING_LEGS";
  FlightPlanEditErrorCode["NOT_DRAFT"] = "NOT_DRAFT";
})(FlightPlanEditErrorCode || (FlightPlanEditErrorCode = {}));

var FlightPlanState;

(function (FlightPlanState) {
  FlightPlanState["DRAFT"] = "DRAFT";
  FlightPlanState["ACTIVE"] = "ACTIVE";
})(FlightPlanState || (FlightPlanState = {}));

var FrontendTaskStatus;

(function (FrontendTaskStatus) {
  FrontendTaskStatus["CREATED"] = "CREATED";
  FrontendTaskStatus["PROCESSING"] = "PROCESSING";
  FrontendTaskStatus["COMPLETED"] = "COMPLETED";
  FrontendTaskStatus["ABORTED"] = "ABORTED";
})(FrontendTaskStatus || (FrontendTaskStatus = {}));

var FulfillmentChannelType;

(function (FulfillmentChannelType) {
  FulfillmentChannelType["WAREHOUSE"] = "WAREHOUSE";
  FulfillmentChannelType["MANUFACTURER"] = "MANUFACTURER";
  FulfillmentChannelType["RETAILER"] = "RETAILER";
  FulfillmentChannelType["GOOGLE_SHOPPING"] = "GOOGLE_SHOPPING";
  FulfillmentChannelType["AD_HOC"] = "AD_HOC";
  FulfillmentChannelType["OFFLINE_PARTNERS"] = "OFFLINE_PARTNERS";
})(FulfillmentChannelType || (FulfillmentChannelType = {}));

var FulfillmentOrderDeliveryStatus;

(function (FulfillmentOrderDeliveryStatus) {
  FulfillmentOrderDeliveryStatus["ATTEMPTED_DELIVERY"] = "ATTEMPTED_DELIVERY";
  FulfillmentOrderDeliveryStatus["CANCELED"] = "CANCELED";
  FulfillmentOrderDeliveryStatus["CONFIRMED"] = "CONFIRMED";
  FulfillmentOrderDeliveryStatus["DELIVERED"] = "DELIVERED";
  FulfillmentOrderDeliveryStatus["FAILURE"] = "FAILURE";
  FulfillmentOrderDeliveryStatus["FULFILLED"] = "FULFILLED";
  FulfillmentOrderDeliveryStatus["IN_TRANSIT"] = "IN_TRANSIT";
  FulfillmentOrderDeliveryStatus["LABEL_PRINTED"] = "LABEL_PRINTED";
  FulfillmentOrderDeliveryStatus["LABEL_PURCHASED"] = "LABEL_PURCHASED";
  FulfillmentOrderDeliveryStatus["LABEL_VOIDED"] = "LABEL_VOIDED";
  FulfillmentOrderDeliveryStatus["MARKED_AS_FULFILLED"] = "MARKED_AS_FULFILLED";
  FulfillmentOrderDeliveryStatus["NOT_DELIVERED"] = "NOT_DELIVERED";
  FulfillmentOrderDeliveryStatus["OUT_FOR_DELIVERY"] = "OUT_FOR_DELIVERY";
  FulfillmentOrderDeliveryStatus["READY_FOR_PICKUP"] = "READY_FOR_PICKUP";
  FulfillmentOrderDeliveryStatus["SUBMITTED"] = "SUBMITTED";
})(FulfillmentOrderDeliveryStatus || (FulfillmentOrderDeliveryStatus = {}));

var FulfillmentOrderSourceType;

(function (FulfillmentOrderSourceType) {
  FulfillmentOrderSourceType["DEAL"] = "DEAL";
  FulfillmentOrderSourceType["SHOPIFY"] = "SHOPIFY";
  FulfillmentOrderSourceType["EXTERNAL_PARTNER"] = "EXTERNAL_PARTNER";
})(FulfillmentOrderSourceType || (FulfillmentOrderSourceType = {}));

var FulfillmentServiceProvider;

(function (FulfillmentServiceProvider) {
  FulfillmentServiceProvider["DEAL"] = "DEAL";
  FulfillmentServiceProvider["UPS"] = "UPS";
})(FulfillmentServiceProvider || (FulfillmentServiceProvider = {}));

var FulfillmentServiceType;

(function (FulfillmentServiceType) {
  FulfillmentServiceType["THIRD_PARTY_LOGISTICS"] = "THIRD_PARTY_LOGISTICS";
  FulfillmentServiceType["DEAL_WH"] = "DEAL_WH";
})(FulfillmentServiceType || (FulfillmentServiceType = {}));

var FulfillmentStatus;

(function (FulfillmentStatus) {
  FulfillmentStatus["REQUESTED"] = "REQUESTED";
  FulfillmentStatus["CANCELLED"] = "CANCELLED";
  FulfillmentStatus["ERROR"] = "ERROR";
  FulfillmentStatus["FAILED"] = "FAILED";
  FulfillmentStatus["PROCESSING"] = "PROCESSING";
  FulfillmentStatus["PENDING"] = "PENDING";
  FulfillmentStatus["PARTIAL"] = "PARTIAL";
  FulfillmentStatus["COMPLETED"] = "COMPLETED";
})(FulfillmentStatus || (FulfillmentStatus = {}));

var FulfillmentSuggestionStatus;

(function (FulfillmentSuggestionStatus) {
  FulfillmentSuggestionStatus["PENDING"] = "PENDING";
  FulfillmentSuggestionStatus["FULFILLED"] = "FULFILLED";
  FulfillmentSuggestionStatus["SKIPPED"] = "SKIPPED";
  FulfillmentSuggestionStatus["UNAVAILABLE"] = "UNAVAILABLE";
  FulfillmentSuggestionStatus["PRICE_TOO_HIGH"] = "PRICE_TOO_HIGH";
  FulfillmentSuggestionStatus["SHIPPING_TOO_SLOW"] = "SHIPPING_TOO_SLOW";
  FulfillmentSuggestionStatus["FAILED"] = "FAILED";
})(FulfillmentSuggestionStatus || (FulfillmentSuggestionStatus = {}));

var GetEntityErrorCode;

(function (GetEntityErrorCode) {
  GetEntityErrorCode["ENTITY_NOT_FOUND"] = "ENTITY_NOT_FOUND";
  GetEntityErrorCode["USER_NOT_ALLOWED"] = "USER_NOT_ALLOWED";
})(GetEntityErrorCode || (GetEntityErrorCode = {}));

var GiftCardState;

(function (GiftCardState) {
  GiftCardState["PURCHASED"] = "PURCHASED";
  GiftCardState["REDEEMED"] = "REDEEMED";
  GiftCardState["EXPIRED"] = "EXPIRED";
  GiftCardState["TERMINATED"] = "TERMINATED";
})(GiftCardState || (GiftCardState = {}));

var GuestConversationSequenceState;

(function (GuestConversationSequenceState) {
  GuestConversationSequenceState["DRAFT"] = "DRAFT";
  GuestConversationSequenceState["ACTIVE"] = "ACTIVE";
  GuestConversationSequenceState["INACTIVE"] = "INACTIVE";
})(GuestConversationSequenceState || (GuestConversationSequenceState = {}));

var HandleType;

(function (HandleType) {
  HandleType["EMAIL"] = "EMAIL";
  HandleType["PHONE"] = "PHONE";
})(HandleType || (HandleType = {}));

var IdentityType;

(function (IdentityType) {
  IdentityType["GUEST"] = "GUEST";
  IdentityType["USER"] = "USER";
  IdentityType["BUSINESS_USER"] = "BUSINESS_USER";
  IdentityType["OPERATOR"] = "OPERATOR";
  IdentityType["SYSTEM_USER"] = "SYSTEM_USER";
  IdentityType["IMPORTED_IDENTITY"] = "IMPORTED_IDENTITY";
})(IdentityType || (IdentityType = {}));

var IdPathFlowQuestionType;

(function (IdPathFlowQuestionType) {
  IdPathFlowQuestionType["MEDIA_ID_IMAGE_UPLOAD"] = "MEDIA_ID_IMAGE_UPLOAD";
  IdPathFlowQuestionType["EXPERT_ID_SELECTION"] = "EXPERT_ID_SELECTION";
  IdPathFlowQuestionType["PRODUCTS_TYPEAHEAD"] = "PRODUCTS_TYPEAHEAD";
  IdPathFlowQuestionType["FLIGHT_PLAN"] = "FLIGHT_PLAN";
})(IdPathFlowQuestionType || (IdPathFlowQuestionType = {}));

var IncomingCallState;

(function (IncomingCallState) {
  IncomingCallState["RINGING"] = "RINGING";
  IncomingCallState["IN_PROGRESS"] = "IN_PROGRESS";
  IncomingCallState["TERMINATED"] = "TERMINATED";
})(IncomingCallState || (IncomingCallState = {}));

var IndividualSellableProConType;

(function (IndividualSellableProConType) {
  IndividualSellableProConType["ATTRIBUTE"] = "ATTRIBUTE";
  IndividualSellableProConType["CUSTOM"] = "CUSTOM";
})(IndividualSellableProConType || (IndividualSellableProConType = {}));

var InputTextPathFlowQuestionFieldType;

(function (InputTextPathFlowQuestionFieldType) {
  /** Typeahead for airports only */
  InputTextPathFlowQuestionFieldType["AIRPORT_TYPEAHEAD"] = "AIRPORT_TYPEAHEAD";
  /** Single line "telephone" with SMS text context */

  InputTextPathFlowQuestionFieldType["SMS_TEXT"] = "SMS_TEXT";
  /** Facebook user expectedReference */

  InputTextPathFlowQuestionFieldType["FACEBOOK_USER_REF"] = "FACEBOOK_USER_REF";
  /** FCM Token */

  InputTextPathFlowQuestionFieldType["FCM_TOKEN"] = "FCM_TOKEN";
  /** Single line text entry */

  InputTextPathFlowQuestionFieldType["INPUT_FIELD"] = "INPUT_FIELD";
  /** Multi-line text area */

  InputTextPathFlowQuestionFieldType["TEXT_AREA"] = "TEXT_AREA";
  /** Single line entry (numeric only) */

  InputTextPathFlowQuestionFieldType["NUMERIC"] = "NUMERIC";
  /** Single line "telephone"-like entry (numeric only) */

  InputTextPathFlowQuestionFieldType["TELEPHONE"] = "TELEPHONE";
  /** Single line "telephone" with its own submit action */

  InputTextPathFlowQuestionFieldType["TELEPHONE_SUBMIT"] = "TELEPHONE_SUBMIT";
  /** Single line "email"-like entry (shows @ sign) */

  InputTextPathFlowQuestionFieldType["EMAIL"] = "EMAIL";
  /** Text which is provided programmatically, thus should be hidden from the user */

  InputTextPathFlowQuestionFieldType["HIDDEN"] = "HIDDEN";
})(InputTextPathFlowQuestionFieldType || (InputTextPathFlowQuestionFieldType = {}));

var InputTextPathFlowQuestionValidationType;

(function (InputTextPathFlowQuestionValidationType) {
  InputTextPathFlowQuestionValidationType["LENGTH"] = "LENGTH";
  InputTextPathFlowQuestionValidationType["REGEX"] = "REGEX";
  InputTextPathFlowQuestionValidationType["PHONE_NUMBER"] = "PHONE_NUMBER";
})(InputTextPathFlowQuestionValidationType || (InputTextPathFlowQuestionValidationType = {}));

var InputTextPathQuestionSchemaRenderingStyle;

(function (InputTextPathQuestionSchemaRenderingStyle) {
  InputTextPathQuestionSchemaRenderingStyle["INPUT_FIELD"] = "INPUT_FIELD";
  InputTextPathQuestionSchemaRenderingStyle["TEXT_AREA"] = "TEXT_AREA";
  InputTextPathQuestionSchemaRenderingStyle["NUMERIC"] = "NUMERIC";
  InputTextPathQuestionSchemaRenderingStyle["TELEPHONE"] = "TELEPHONE";
  InputTextPathQuestionSchemaRenderingStyle["EMAIL"] = "EMAIL";
})(InputTextPathQuestionSchemaRenderingStyle || (InputTextPathQuestionSchemaRenderingStyle = {}));

var InterstitialPathFlowPageMetadataType;

(function (InterstitialPathFlowPageMetadataType) {
  InterstitialPathFlowPageMetadataType["ALMOST_DONE"] = "ALMOST_DONE";
  InterstitialPathFlowPageMetadataType["BROWSE_EXPERTS"] = "BROWSE_EXPERTS";
  InterstitialPathFlowPageMetadataType["CALCULATING"] = "CALCULATING";
  InterstitialPathFlowPageMetadataType["CONNECTING_TO_OPERATOR"] = "CONNECTING_TO_OPERATOR";
  InterstitialPathFlowPageMetadataType["FINDING_MERCHANTS"] = "FINDING_MERCHANTS";
  /** GENERIC_WITH_BUTTON interstitial uses a button to submit */

  InterstitialPathFlowPageMetadataType["GENERIC_WITH_BUTTON"] = "GENERIC_WITH_BUTTON";
  /** GENERIC_WITH_TITLE interstitial that uses timer to submit */

  InterstitialPathFlowPageMetadataType["GENERIC_WITH_TITLE"] = "GENERIC_WITH_TITLE";
  InterstitialPathFlowPageMetadataType["HIGH_SECURITY"] = "HIGH_SECURITY";
  InterstitialPathFlowPageMetadataType["LOADING_QUESTIONS"] = "LOADING_QUESTIONS";
  InterstitialPathFlowPageMetadataType["SNOWBOARD_INT_LEARN"] = "SNOWBOARD_INT_LEARN";
  InterstitialPathFlowPageMetadataType["WELCOME"] = "WELCOME";
  InterstitialPathFlowPageMetadataType["GIVE_US_A_SEC"] = "GIVE_US_A_SEC";
  InterstitialPathFlowPageMetadataType["REQUEST_PUSH_NOTIFICATION_PERMISSION"] = "REQUEST_PUSH_NOTIFICATION_PERMISSION";
  InterstitialPathFlowPageMetadataType["WHAT_HAPPENS_NEXT"] = "WHAT_HAPPENS_NEXT";
})(InterstitialPathFlowPageMetadataType || (InterstitialPathFlowPageMetadataType = {}));

var InterstitialPathNodeConfigType;

(function (InterstitialPathNodeConfigType) {
  InterstitialPathNodeConfigType["CONTINUE_WITH_BUTTON"] = "CONTINUE_WITH_BUTTON";
  InterstitialPathNodeConfigType["TIMED_CONTINUE"] = "TIMED_CONTINUE";
})(InterstitialPathNodeConfigType || (InterstitialPathNodeConfigType = {}));

var LeadActivityType;

(function (LeadActivityType) {
  LeadActivityType["DELEGATE_EXPERT_CHANGED"] = "DELEGATE_EXPERT_CHANGED";
  LeadActivityType["SNOOZE_CHANGED"] = "SNOOZE_CHANGED";
  LeadActivityType["WOKE_UP_FROM_SNOOZE"] = "WOKE_UP_FROM_SNOOZE";
  LeadActivityType["REASSIGNED"] = "REASSIGNED";
  LeadActivityType["ARCHIVED"] = "ARCHIVED";
  LeadActivityType["CONSUMER_FIRST_MESSAGE_SENT"] = "CONSUMER_FIRST_MESSAGE_SENT";
  LeadActivityType["CONSUMER_CALLED"] = "CONSUMER_CALLED";
  LeadActivityType["EXPERT_CALLED"] = "EXPERT_CALLED";
  LeadActivityType["CONSUMER_PAYMENT_FAILED"] = "CONSUMER_PAYMENT_FAILED";
  LeadActivityType["CONSUMER_PAYMENT_SUCCEEDED"] = "CONSUMER_PAYMENT_SUCCEEDED";
  LeadActivityType["CONSUMER_ORDER_PAID"] = "CONSUMER_ORDER_PAID";
  LeadActivityType["CONSUMER_REVIEW_ADDED"] = "CONSUMER_REVIEW_ADDED";
  LeadActivityType["ESCALATION_STARTED"] = "ESCALATION_STARTED";
  LeadActivityType["ESCALATION_CHANGED"] = "ESCALATION_CHANGED";
  LeadActivityType["QUALITY_CONVERSATION_ESTABLISHED"] = "QUALITY_CONVERSATION_ESTABLISHED";
  LeadActivityType["QUALITY_CONVO_WITH_CURATION_ESTABLISHED"] = "QUALITY_CONVO_WITH_CURATION_ESTABLISHED";
  LeadActivityType["LEAD_CREATED"] = "LEAD_CREATED";
  LeadActivityType["STOP_REQUESTED"] = "STOP_REQUESTED";
  LeadActivityType["GIFT_CARD_REDEEMED"] = "GIFT_CARD_REDEEMED";
  LeadActivityType["REQUEST_SUBMITTED"] = "REQUEST_SUBMITTED";
  LeadActivityType["NOTE_ADDED"] = "NOTE_ADDED";
})(LeadActivityType || (LeadActivityType = {}));

var LeadAssignmentStage;

(function (LeadAssignmentStage) {
  LeadAssignmentStage["INITIAL"] = "INITIAL";
  LeadAssignmentStage["ESCALATING"] = "ESCALATING";
  LeadAssignmentStage["FINAL"] = "FINAL";
})(LeadAssignmentStage || (LeadAssignmentStage = {}));

var LeadCampaignRecipientSortOrder;

(function (LeadCampaignRecipientSortOrder) {
  LeadCampaignRecipientSortOrder["MOST_RECENT_ACTIVITY"] = "MOST_RECENT_ACTIVITY";
  LeadCampaignRecipientSortOrder["RANDOM"] = "RANDOM";
})(LeadCampaignRecipientSortOrder || (LeadCampaignRecipientSortOrder = {}));

var LeadCampaignState;

(function (LeadCampaignState) {
  LeadCampaignState["DRAFT"] = "DRAFT";
  LeadCampaignState["PREPARING"] = "PREPARING";
  LeadCampaignState["PUBLISHED"] = "PUBLISHED";
  LeadCampaignState["DELIVERING"] = "DELIVERING";
  LeadCampaignState["DEACTIVATED"] = "DEACTIVATED";
})(LeadCampaignState || (LeadCampaignState = {}));

var LeadCampaignTriggerExecutionInterval;

(function (LeadCampaignTriggerExecutionInterval) {
  LeadCampaignTriggerExecutionInterval["EMAIL"] = "EMAIL";
  LeadCampaignTriggerExecutionInterval["SMS_LONG_CODE"] = "SMS_LONG_CODE";
  LeadCampaignTriggerExecutionInterval["SMS_SHORT_CODE"] = "SMS_SHORT_CODE";
})(LeadCampaignTriggerExecutionInterval || (LeadCampaignTriggerExecutionInterval = {}));

var LeadEscalationLevel;

(function (LeadEscalationLevel) {
  LeadEscalationLevel["NOT_STARTED"] = "NOT_STARTED";
  LeadEscalationLevel["ONLINE_TEAM_MEMBERS"] = "ONLINE_TEAM_MEMBERS";
  LeadEscalationLevel["ALL_TEAM_MEMBERS"] = "ALL_TEAM_MEMBERS";
  LeadEscalationLevel["SUPPORT"] = "SUPPORT";
  LeadEscalationLevel["ONLINE_EXPERTS"] = "ONLINE_EXPERTS";
  LeadEscalationLevel["ALL_EXPERTS"] = "ALL_EXPERTS";
  LeadEscalationLevel["ON_CALL_EXPERTS"] = "ON_CALL_EXPERTS";
})(LeadEscalationLevel || (LeadEscalationLevel = {}));

var LeadEscalationStatus;

(function (LeadEscalationStatus) {
  LeadEscalationStatus["OPEN"] = "OPEN";
  LeadEscalationStatus["CLOSED"] = "CLOSED";
})(LeadEscalationStatus || (LeadEscalationStatus = {}));

var LeadEscalationType;

(function (LeadEscalationType) {
  LeadEscalationType["CONSUMER_WAITING_RESPONSE"] = "CONSUMER_WAITING_RESPONSE";
})(LeadEscalationType || (LeadEscalationType = {}));

var LeadExpertRole;

(function (LeadExpertRole) {
  LeadExpertRole["PRIMARY"] = "PRIMARY";
  LeadExpertRole["DELEGATE"] = "DELEGATE";
})(LeadExpertRole || (LeadExpertRole = {}));

var LeadIntentLabel;

(function (LeadIntentLabel) {
  /** Lead predicted to have a high intent for conversion. */
  LeadIntentLabel["HIGH_INTENT_FOR_CONVERSION"] = "HIGH_INTENT_FOR_CONVERSION";
})(LeadIntentLabel || (LeadIntentLabel = {}));

var LeadParticipantType;

(function (LeadParticipantType) {
  LeadParticipantType["EXPERT"] = "EXPERT";
  LeadParticipantType["DELEGATE_EXPERT"] = "DELEGATE_EXPERT";
  LeadParticipantType["CONSUMER"] = "CONSUMER";
  LeadParticipantType["ASSISTANT"] = "ASSISTANT";
  LeadParticipantType["DEAL_BOT"] = "DEAL_BOT";
})(LeadParticipantType || (LeadParticipantType = {}));

var LeadPostOrderCheckinReason;

(function (LeadPostOrderCheckinReason) {
  LeadPostOrderCheckinReason["FIRST_ITEM_SHIPPED"] = "FIRST_ITEM_SHIPPED";
  LeadPostOrderCheckinReason["ITEM_UNAVAILABLE"] = "ITEM_UNAVAILABLE";
})(LeadPostOrderCheckinReason || (LeadPostOrderCheckinReason = {}));

var LeadReassignmentReason;

(function (LeadReassignmentReason) {
  LeadReassignmentReason["EXPERT_DEACTIVATED"] = "EXPERT_DEACTIVATED";
  LeadReassignmentReason["EXPERT_UNAVAILABLE"] = "EXPERT_UNAVAILABLE";
  LeadReassignmentReason["CATEGORY_TRANSFER"] = "CATEGORY_TRANSFER";
  LeadReassignmentReason["SPECIALITY_TRANSFER"] = "SPECIALITY_TRANSFER";
  LeadReassignmentReason["ORDER_SUPPORT_ACTION"] = "ORDER_SUPPORT_ACTION";
  LeadReassignmentReason["ESCALATION_ACCEPTED"] = "ESCALATION_ACCEPTED";
  LeadReassignmentReason["SURGE_LEAD_CLAIMED"] = "SURGE_LEAD_CLAIMED";
  LeadReassignmentReason["FINAL_ASSIGNMENT"] = "FINAL_ASSIGNMENT";
  LeadReassignmentReason["OTHER"] = "OTHER";
})(LeadReassignmentReason || (LeadReassignmentReason = {}));

var LeadSortOrder;

(function (LeadSortOrder) {
  LeadSortOrder["ACTIVITY_DATE"] = "ACTIVITY_DATE";
  LeadSortOrder["CREATION_DATE"] = "CREATION_DATE";
  LeadSortOrder["CURATION_DATE"] = "CURATION_DATE";
  LeadSortOrder["ESCALATION_PRIORITY"] = "ESCALATION_PRIORITY";
  LeadSortOrder["NEEDS_ACTION_PRIORITY"] = "NEEDS_ACTION_PRIORITY";
})(LeadSortOrder || (LeadSortOrder = {}));

var LeadSourceFlowType;

(function (LeadSourceFlowType) {
  LeadSourceFlowType["REGISTRATION"] = "REGISTRATION";
  LeadSourceFlowType["PATH"] = "PATH";
  LeadSourceFlowType["CONVERSATION_STARTER"] = "CONVERSATION_STARTER";
  LeadSourceFlowType["DIRECT_EXPERT_CHAT"] = "DIRECT_EXPERT_CHAT";
  LeadSourceFlowType["INCOMING_CALL_OR_MESSAGE"] = "INCOMING_CALL_OR_MESSAGE";
  LeadSourceFlowType["POST_ORDER_CHECKIN"] = "POST_ORDER_CHECKIN";
})(LeadSourceFlowType || (LeadSourceFlowType = {}));

var LeadSourcePageType;

(function (LeadSourcePageType) {
  LeadSourcePageType["SELLABLE_DETAIL"] = "SELLABLE_DETAIL";
  LeadSourcePageType["EXPERT_PROFILE"] = "EXPERT_PROFILE";
  LeadSourcePageType["SELLABLE_SEARCH"] = "SELLABLE_SEARCH";
  LeadSourcePageType["SELLABLE_TOP_LIST"] = "SELLABLE_TOP_LIST";
  LeadSourcePageType["DEPARTMENT"] = "DEPARTMENT";
  LeadSourcePageType["GIFT_CARD_REDEEM"] = "GIFT_CARD_REDEEM";
})(LeadSourcePageType || (LeadSourcePageType = {}));

var LeadSupportTaskReason;

(function (LeadSupportTaskReason) {
  LeadSupportTaskReason["NEW_UNASSIGNED_LEAD"] = "NEW_UNASSIGNED_LEAD";
  LeadSupportTaskReason["EXPERT_OUT_OF_SLA"] = "EXPERT_OUT_OF_SLA";
  LeadSupportTaskReason["ESCALATION_FAILED"] = "ESCALATION_FAILED";
  LeadSupportTaskReason["ESCALATION_FOR_DELEGATION_FAILED"] = "ESCALATION_FOR_DELEGATION_FAILED";
  LeadSupportTaskReason["ESCALATION_FOR_REASSIGNMENT_FAILED"] = "ESCALATION_FOR_REASSIGNMENT_FAILED";
  LeadSupportTaskReason["UNSNOOZED"] = "UNSNOOZED";
  LeadSupportTaskReason["SPAM_RISK"] = "SPAM_RISK";
  LeadSupportTaskReason["RESPONDED_TO_SUPPORT"] = "RESPONDED_TO_SUPPORT";
  LeadSupportTaskReason["EVALUATE_CONVERSATION"] = "EVALUATE_CONVERSATION";
  LeadSupportTaskReason["DEFAULT"] = "DEFAULT";
})(LeadSupportTaskReason || (LeadSupportTaskReason = {}));

var LedgerTransactionType;

(function (LedgerTransactionType) {
  LedgerTransactionType["AUTHORIZE"] = "AUTHORIZE";
  LedgerTransactionType["AUTHORIZE_AND_POST"] = "AUTHORIZE_AND_POST";
  LedgerTransactionType["CANCEL_AUTHORIZATION"] = "CANCEL_AUTHORIZATION";
  LedgerTransactionType["EXTEND_AUTHORIZATION"] = "EXTEND_AUTHORIZATION";
  LedgerTransactionType["POST"] = "POST";
})(LedgerTransactionType || (LedgerTransactionType = {}));

var LedgerType;

(function (LedgerType) {
  LedgerType["EXPERT_DISCOUNT_CASH"] = "EXPERT_DISCOUNT_CASH";
  LedgerType["CONSUMER_STORE_CREDIT"] = "CONSUMER_STORE_CREDIT";
})(LedgerType || (LedgerType = {}));

var ListPathFlowQuestionRenderStyle;

(function (ListPathFlowQuestionRenderStyle) {
  /**
   * The default/stock rendering style that is guaranteed to fit in with the rest of the components, and will have the
   * best support in combining different options that impact rendering. Unless a path with a specific UI treatment is
   * being tested, using DEFAULT is strongly recommended.
   */
  ListPathFlowQuestionRenderStyle["DEFAULT"] = "DEFAULT";
  /** If images should be rendered as full width (bleeds into edges of select container) */

  ListPathFlowQuestionRenderStyle["FULL_WIDTH_IMAGES"] = "FULL_WIDTH_IMAGES";
  /** If text should be rendered as an overlay of the image in the background */

  ListPathFlowQuestionRenderStyle["OVERLAY_IMAGE"] = "OVERLAY_IMAGE";
  /** Use a simpler radio style select that doesn't render the full cards */

  ListPathFlowQuestionRenderStyle["SIMPLE_RADIO"] = "SIMPLE_RADIO";
})(ListPathFlowQuestionRenderStyle || (ListPathFlowQuestionRenderStyle = {}));

var ListPathFlowQuestionType;

(function (ListPathFlowQuestionType) {
  ListPathFlowQuestionType["SINGLE_SELECT_LIST"] = "SINGLE_SELECT_LIST";
  ListPathFlowQuestionType["MULTI_SELECT_LIST"] = "MULTI_SELECT_LIST";
  ListPathFlowQuestionType["DROP_DOWN"] = "DROP_DOWN";
  ListPathFlowQuestionType["MULTI_SELECT_PILLS"] = "MULTI_SELECT_PILLS";
})(ListPathFlowQuestionType || (ListPathFlowQuestionType = {}));

var ListPathQuestionSchemaType;

(function (ListPathQuestionSchemaType) {
  ListPathQuestionSchemaType["SINGLE_SELECT_LIST"] = "SINGLE_SELECT_LIST";
  ListPathQuestionSchemaType["MULTI_SELECT_LIST"] = "MULTI_SELECT_LIST";
  ListPathQuestionSchemaType["DROP_DOWN"] = "DROP_DOWN";
  ListPathQuestionSchemaType["MULTI_SELECT_PILLS"] = "MULTI_SELECT_PILLS";
})(ListPathQuestionSchemaType || (ListPathQuestionSchemaType = {}));

var LogicalConditionOperator;

(function (LogicalConditionOperator) {
  LogicalConditionOperator["AND"] = "AND";
  LogicalConditionOperator["OR"] = "OR";
})(LogicalConditionOperator || (LogicalConditionOperator = {}));

var LogicalOperator;

(function (LogicalOperator) {
  LogicalOperator["AND"] = "AND";
  LogicalOperator["OR"] = "OR";
})(LogicalOperator || (LogicalOperator = {}));

var LookupReferralCodeError;

(function (LookupReferralCodeError) {
  LookupReferralCodeError["INVALID_CODE"] = "INVALID_CODE";
})(LookupReferralCodeError || (LookupReferralCodeError = {}));

var LtvType;

(function (LtvType) {
  LtvType["LEAD"] = "LEAD";
  LtvType["REQUEST"] = "REQUEST";
  LtvType["RESPONSE"] = "RESPONSE";
  LtvType["VIEW_CURATIONS"] = "VIEW_CURATIONS";
})(LtvType || (LtvType = {}));

var ManualAdjustmentPayType;

(function (ManualAdjustmentPayType) {
  ManualAdjustmentPayType["ONBOARDING_SPECIALIST"] = "ONBOARDING_SPECIALIST";
  ManualAdjustmentPayType["SHIFT_SPIFF"] = "SHIFT_SPIFF";
  ManualAdjustmentPayType["COMPETITION"] = "COMPETITION";
  ManualAdjustmentPayType["TEAM_LEAD"] = "TEAM_LEAD";
  ManualAdjustmentPayType["UTILITY_PLAYER"] = "UTILITY_PLAYER";
  ManualAdjustmentPayType["CONTENT"] = "CONTENT";
  ManualAdjustmentPayType["EXPERT_TASK"] = "EXPERT_TASK";
  ManualAdjustmentPayType["REFERRAL_BONUS"] = "REFERRAL_BONUS";
  ManualAdjustmentPayType["MISC"] = "MISC";
})(ManualAdjustmentPayType || (ManualAdjustmentPayType = {}));

var MerchantSortField;

(function (MerchantSortField) {
  MerchantSortField["NAME"] = "NAME";
})(MerchantSortField || (MerchantSortField = {}));

var MerchantState;

(function (MerchantState) {
  MerchantState["ACTIVE"] = "ACTIVE";
  MerchantState["DEACTIVATED"] = "DEACTIVATED";
})(MerchantState || (MerchantState = {}));

var MessageBodyType;

(function (MessageBodyType) {
  MessageBodyType["TEXT"] = "TEXT";
  MessageBodyType["FILE"] = "FILE";
  MessageBodyType["AUDIO"] = "AUDIO";
  MessageBodyType["VIDEO"] = "VIDEO";
  MessageBodyType["IMAGE"] = "IMAGE";
  MessageBodyType["MULTI_MEDIA"] = "MULTI_MEDIA";
  MessageBodyType["OFFER"] = "OFFER";
  MessageBodyType["DEAL"] = "DEAL";
  MessageBodyType["VIDEO_CHAT_REQUESTED"] = "VIDEO_CHAT_REQUESTED";
  MessageBodyType["VIDEO_CHAT_DECLINED"] = "VIDEO_CHAT_DECLINED";
  MessageBodyType["OTHER"] = "OTHER";
})(MessageBodyType || (MessageBodyType = {}));

var MessageRichCardType;

(function (MessageRichCardType) {
  MessageRichCardType["ONBOARDING_REQUEST_CONFIRMATION"] = "ONBOARDING_REQUEST_CONFIRMATION";
  MessageRichCardType["ONBOARDING_HOW_CURATED_WORKS"] = "ONBOARDING_HOW_CURATED_WORKS";
  MessageRichCardType["ONBOARDING_EXPERT_JOINED"] = "ONBOARDING_EXPERT_JOINED";
  MessageRichCardType["NEW_CUSTOM_CURATED_ORDER"] = "NEW_CUSTOM_CURATED_ORDER";
  MessageRichCardType["NEW_BOOKABLE_CURATED_ORDER"] = "NEW_BOOKABLE_CURATED_ORDER";
  MessageRichCardType["NEW_EXPERT_CURATED_ORDER_LIST"] = "NEW_EXPERT_CURATED_ORDER_LIST";
  MessageRichCardType["CONSUMER_INTERESTED_IN_CURATED_ORDER"] = "CONSUMER_INTERESTED_IN_CURATED_ORDER";
  MessageRichCardType["NEW_EXPERT_CURATED_ITEMS"] = "NEW_EXPERT_CURATED_ITEMS";
  MessageRichCardType["NEW_SYSTEM_CURATED_ITEMS"] = "NEW_SYSTEM_CURATED_ITEMS";
  MessageRichCardType["UPDATED_EXPERT_CURATED_ITEMS"] = "UPDATED_EXPERT_CURATED_ITEMS";
  MessageRichCardType["FEEDBACK_REQUEST_FROM_EXPERT"] = "FEEDBACK_REQUEST_FROM_EXPERT";
  MessageRichCardType["REFERRAL_REQUEST_FROM_EXPERT"] = "REFERRAL_REQUEST_FROM_EXPERT";
  MessageRichCardType["SYSTEM_CURATED_ITEM_SURVEY"] = "SYSTEM_CURATED_ITEM_SURVEY";
  MessageRichCardType["SIMPLE_CURATED_ORDER"] = "SIMPLE_CURATED_ORDER";
  MessageRichCardType["CONTACT_COLLECTION_REQUEST"] = "CONTACT_COLLECTION_REQUEST";
  MessageRichCardType["GUEST_CHAT_CREATE_REQUEST"] = "GUEST_CHAT_CREATE_REQUEST";
  MessageRichCardType["PAYMENT_VERIFICATION_REQUEST"] = "PAYMENT_VERIFICATION_REQUEST";
  MessageRichCardType["EXPERT_AWAY_AUTO_REPLY"] = "EXPERT_AWAY_AUTO_REPLY";
  MessageRichCardType["SELLABLE_REQUESTED"] = "SELLABLE_REQUESTED";
  MessageRichCardType["SELLABLE_PRICE_MATCH_REQUESTED"] = "SELLABLE_PRICE_MATCH_REQUESTED";
  MessageRichCardType["CONVERSATION_STARTER_SENT"] = "CONVERSATION_STARTER_SENT";
})(MessageRichCardType || (MessageRichCardType = {}));

var MessageUnsubscribeTag;

(function (MessageUnsubscribeTag) {
  MessageUnsubscribeTag["CURATION"] = "CURATION";
  MessageUnsubscribeTag["ONBOARDING"] = "ONBOARDING";
  MessageUnsubscribeTag["MESSAGE_NOTIFICATION"] = "MESSAGE_NOTIFICATION";
  MessageUnsubscribeTag["POST_PURCHASE"] = "POST_PURCHASE";
  MessageUnsubscribeTag["ABANDONED_ORDER"] = "ABANDONED_ORDER";
  MessageUnsubscribeTag["PATH_ONBOARDING"] = "PATH_ONBOARDING";
  MessageUnsubscribeTag["REFERRAL"] = "REFERRAL";
  MessageUnsubscribeTag["LEAD_CAMPAIGN"] = "LEAD_CAMPAIGN";
})(MessageUnsubscribeTag || (MessageUnsubscribeTag = {}));

var MessagingChannelType;

(function (MessagingChannelType) {
  MessagingChannelType["SMS"] = "SMS";
  MessagingChannelType["EMAIL"] = "EMAIL";
  MessagingChannelType["FACEBOOK"] = "FACEBOOK";
  MessagingChannelType["PUSH_NOTIFICATION"] = "PUSH_NOTIFICATION";
})(MessagingChannelType || (MessagingChannelType = {}));

var MessagingUserType;

(function (MessagingUserType) {
  MessagingUserType["USER"] = "USER";
  MessagingUserType["MERCHANT"] = "MERCHANT";
  MessagingUserType["BUSINESS_USER"] = "BUSINESS_USER";
  MessagingUserType["OPERATOR"] = "OPERATOR";
  MessagingUserType["DEAL_BOT"] = "DEAL_BOT";
  MessagingUserType["ONBOARDING_SPECIALIST"] = "ONBOARDING_SPECIALIST";
  MessagingUserType["SUPPORT"] = "SUPPORT";
})(MessagingUserType || (MessagingUserType = {}));

var MonetaryAmountDenominationType;

(function (MonetaryAmountDenominationType) {
  /** Return amount in the default denomination (e.g.: dollars and cents, e.g.: "12.34" for $12.34 */
  MonetaryAmountDenominationType["DEFAULT"] = "DEFAULT";
  /** Return amount in the smallest denomination for the given currency (e.g.: "1234" for $12.34) */

  MonetaryAmountDenominationType["SMALLEST"] = "SMALLEST";
})(MonetaryAmountDenominationType || (MonetaryAmountDenominationType = {}));

var NotificationType;

(function (NotificationType) {
  NotificationType["TRANSACTIONAL"] = "TRANSACTIONAL";
  NotificationType["GENERAL"] = "GENERAL";
  NotificationType["DIRECT_MESSAGE"] = "DIRECT_MESSAGE";
  NotificationType["CURATION"] = "CURATION";
  NotificationType["OFFERS"] = "OFFERS";
  NotificationType["ARTICLES_AND_VIDEOS"] = "ARTICLES_AND_VIDEOS";
  NotificationType["EXPERT_ONBOARDING"] = "EXPERT_ONBOARDING";
  NotificationType["EXPERT_DEACTIVATION"] = "EXPERT_DEACTIVATION";
  NotificationType["SURGE_SHIFTS"] = "SURGE_SHIFTS";
})(NotificationType || (NotificationType = {}));

var NumericPathFlowQuestionDisplayType;

(function (NumericPathFlowQuestionDisplayType) {
  NumericPathFlowQuestionDisplayType["HEIGHT_IN_INCHES"] = "HEIGHT_IN_INCHES";
  NumericPathFlowQuestionDisplayType["STAR_RATING"] = "STAR_RATING";
})(NumericPathFlowQuestionDisplayType || (NumericPathFlowQuestionDisplayType = {}));

var NumericPathFlowQuestionUnitType;

(function (NumericPathFlowQuestionUnitType) {
  NumericPathFlowQuestionUnitType["INCHES"] = "INCHES";
  NumericPathFlowQuestionUnitType["FEET"] = "FEET";
  NumericPathFlowQuestionUnitType["POUNDS"] = "POUNDS";
  NumericPathFlowQuestionUnitType["CENTIMETERS"] = "CENTIMETERS";
  NumericPathFlowQuestionUnitType["KILOGRAMS"] = "KILOGRAMS";
  NumericPathFlowQuestionUnitType["DOLLARS"] = "DOLLARS";
})(NumericPathFlowQuestionUnitType || (NumericPathFlowQuestionUnitType = {}));

var NumericPathFlowQuestionValueType;

(function (NumericPathFlowQuestionValueType) {
  NumericPathFlowQuestionValueType["INTEGER"] = "INTEGER";
  NumericPathFlowQuestionValueType["DECIMAL"] = "DECIMAL";
})(NumericPathFlowQuestionValueType || (NumericPathFlowQuestionValueType = {}));

var NumericPathQuestionSchemaGenericRenderingStyleUnitPlacement;

(function (NumericPathQuestionSchemaGenericRenderingStyleUnitPlacement) {
  NumericPathQuestionSchemaGenericRenderingStyleUnitPlacement["LEFT"] = "LEFT";
  NumericPathQuestionSchemaGenericRenderingStyleUnitPlacement["RIGHT"] = "RIGHT";
})(NumericPathQuestionSchemaGenericRenderingStyleUnitPlacement || (NumericPathQuestionSchemaGenericRenderingStyleUnitPlacement = {}));

var NumericRangeDisplayFacetType;

(function (NumericRangeDisplayFacetType) {
  /** Render the number as is */
  NumericRangeDisplayFacetType["DEFAULT"] = "DEFAULT";
  /** Render the number (represented in cents) as USD currency */

  NumericRangeDisplayFacetType["USD_CURRENCY"] = "USD_CURRENCY";
})(NumericRangeDisplayFacetType || (NumericRangeDisplayFacetType = {}));

var OAuthType;

(function (OAuthType) {
  OAuthType["FACEBOOK"] = "FACEBOOK";
  OAuthType["GOOGLE"] = "GOOGLE";
  OAuthType["APPLE"] = "APPLE";
})(OAuthType || (OAuthType = {}));

var OfferState;

(function (OfferState) {
  OfferState["INITIAL"] = "INITIAL";
  OfferState["GENERATED"] = "GENERATED";
  OfferState["ACCEPTED"] = "ACCEPTED";
  OfferState["EXPIRED"] = "EXPIRED";
  OfferState["WITHDRAWN"] = "WITHDRAWN";
})(OfferState || (OfferState = {}));
/**
 * =============
 * Ops UI permission
 * =============
 */


var OperatorPermission;

(function (OperatorPermission) {
  OperatorPermission["UI_OPS_MANAGE_CATALOG"] = "UI_OPS_MANAGE_CATALOG";
  OperatorPermission["UI_OPS_MANAGE_LEADS"] = "UI_OPS_MANAGE_LEADS";
  OperatorPermission["UI_OPS_MANAGE_CONSUMERS"] = "UI_OPS_MANAGE_CONSUMERS";
  OperatorPermission["UI_OPS_MANAGE_MERCHANTS"] = "UI_OPS_MANAGE_MERCHANTS";
  OperatorPermission["UI_OPS_MANAGE_EXPERTS"] = "UI_OPS_MANAGE_EXPERTS";
  OperatorPermission["UI_OPS_DEVTOOLS"] = "UI_OPS_DEVTOOLS";
  OperatorPermission["UI_OPS_MANAGE_ALL_ORDERS"] = "UI_OPS_MANAGE_ALL_ORDERS";
  OperatorPermission["UI_OPS_MANAGE_PAYROLL"] = "UI_OPS_MANAGE_PAYROLL";
  OperatorPermission["UI_OPS_MANAGE_ASSIGNED_ORDERS"] = "UI_OPS_MANAGE_ASSIGNED_ORDERS";
  OperatorPermission["UI_OPS_RESEARCH_ORDER_FULFILLMENT"] = "UI_OPS_RESEARCH_ORDER_FULFILLMENT";
  OperatorPermission["UI_OPS_FULFILL_ORDERS"] = "UI_OPS_FULFILL_ORDERS";
  OperatorPermission["UI_OPS_TEST_TRIGGER"] = "UI_OPS_TEST_TRIGGER";
  OperatorPermission["UI_OPS_ASSISTANT"] = "UI_OPS_ASSISTANT";
  OperatorPermission["UI_OPS_MANAGE_ORDERS_ASSIGNED_TO_SELF"] = "UI_OPS_MANAGE_ORDERS_ASSIGNED_TO_SELF";
  OperatorPermission["UI_OPS_ORDER_SUPPORT_EXPERIMENT"] = "UI_OPS_ORDER_SUPPORT_EXPERIMENT";
  OperatorPermission["UI_OPS_FULFILLMENT_TIER1_QUEUE"] = "UI_OPS_FULFILLMENT_TIER1_QUEUE";
  OperatorPermission["UI_OPS_FULFILLMENT_TIER2_QUEUE"] = "UI_OPS_FULFILLMENT_TIER2_QUEUE";
  OperatorPermission["UI_OPS_SUPPORT_TIER1_QUEUE"] = "UI_OPS_SUPPORT_TIER1_QUEUE";
  OperatorPermission["UI_OPS_SUPPORT_TIER2_QUEUE"] = "UI_OPS_SUPPORT_TIER2_QUEUE";
  OperatorPermission["UI_OPS_MANAGE_OPERATOR_TEAMS"] = "UI_OPS_MANAGE_OPERATOR_TEAMS";
})(OperatorPermission || (OperatorPermission = {}));

var OperatorRole;

(function (OperatorRole) {
  OperatorRole["CATALOG_MANAGER"] = "CATALOG_MANAGER";
  OperatorRole["ONBOARDING_SPECIALIST"] = "ONBOARDING_SPECIALIST";
  OperatorRole["LEAD_SUPPORT"] = "LEAD_SUPPORT";
  OperatorRole["ORDER_SUPPORT"] = "ORDER_SUPPORT";
  OperatorRole["SUPER_ADMIN"] = "SUPER_ADMIN";
  OperatorRole["ADMIN"] = "ADMIN";
  OperatorRole["FULFILLMENT_AGENT"] = "FULFILLMENT_AGENT";
  OperatorRole["PAYROLL_MANAGER"] = "PAYROLL_MANAGER";
  OperatorRole["CONTENT_MARKETING_MANAGER"] = "CONTENT_MARKETING_MANAGER";
  OperatorRole["ORDER_SUPPORT_LEAD"] = "ORDER_SUPPORT_LEAD";
  OperatorRole["ORDER_PAYMENT_MANAGER"] = "ORDER_PAYMENT_MANAGER";
  OperatorRole["ORDER_SUPPORT_EXPERIMENT"] = "ORDER_SUPPORT_EXPERIMENT";
  OperatorRole["FULFILLMENT_TIER_ONE"] = "FULFILLMENT_TIER_ONE";
  OperatorRole["FULFILLMENT_TIER_TWO"] = "FULFILLMENT_TIER_TWO";
  OperatorRole["SUPPORT_TIER_ONE"] = "SUPPORT_TIER_ONE";
  OperatorRole["SUPPORT_TIER_TWO"] = "SUPPORT_TIER_TWO";
  OperatorRole["SUPPORT_TIER_THREE"] = "SUPPORT_TIER_THREE";
  OperatorRole["ORDER_VERIFICATION"] = "ORDER_VERIFICATION";
  OperatorRole["TRACKING_UPDATE"] = "TRACKING_UPDATE";
  OperatorRole["LINE_ITEM_CLAIM"] = "LINE_ITEM_CLAIM";
  OperatorRole["SHIPMENT_PRICING_MANAGER"] = "SHIPMENT_PRICING_MANAGER";
  OperatorRole["OPERATOR_TEAMS_MANAGER"] = "OPERATOR_TEAMS_MANAGER";
})(OperatorRole || (OperatorRole = {}));

var OperatorShiftType;

(function (OperatorShiftType) {
  OperatorShiftType["AGENT"] = "AGENT";
})(OperatorShiftType || (OperatorShiftType = {}));

var OperatorTeam;

(function (OperatorTeam) {
  OperatorTeam["ORDER_CLAIM"] = "ORDER_CLAIM";
  OperatorTeam["ORDER_VERIFICATION"] = "ORDER_VERIFICATION";
  OperatorTeam["TRACKING"] = "TRACKING";
  OperatorTeam["SUPPORT_TIER_ONE"] = "SUPPORT_TIER_ONE";
  OperatorTeam["SUPPORT_TIER_TWO"] = "SUPPORT_TIER_TWO";
  OperatorTeam["SUPPORT_TIER_THREE"] = "SUPPORT_TIER_THREE";
  OperatorTeam["FULFILLMENT_ESCALATION"] = "FULFILLMENT_ESCALATION";
  OperatorTeam["SUPPORT_ESCALATION"] = "SUPPORT_ESCALATION";
  OperatorTeam["TRACKING_ESCALATION"] = "TRACKING_ESCALATION";
})(OperatorTeam || (OperatorTeam = {}));

var OrderActivityDetailType;

(function (OrderActivityDetailType) {
  OrderActivityDetailType["OPERATOR_ASSIGNED"] = "OPERATOR_ASSIGNED";
  OrderActivityDetailType["MERCHANT_CLAIMED"] = "MERCHANT_CLAIMED";
  OrderActivityDetailType["TRACKING_UPDATED"] = "TRACKING_UPDATED";
  OrderActivityDetailType["TRACKING_REMOVED"] = "TRACKING_REMOVED";
  OrderActivityDetailType["ORDER_ESCALATED"] = "ORDER_ESCALATED";
  OrderActivityDetailType["ITEM_SHIPPED"] = "ITEM_SHIPPED";
  OrderActivityDetailType["ESCALATION_CLOSED"] = "ESCALATION_CLOSED";
  OrderActivityDetailType["DEAL_INVENTORY_REQUESTED"] = "DEAL_INVENTORY_REQUESTED";
  OrderActivityDetailType["DEAL_INVENTORY_REQUEST_FAILED"] = "DEAL_INVENTORY_REQUEST_FAILED";
  OrderActivityDetailType["DEAL_INVENTORY_REQUEST_CANCELED"] = "DEAL_INVENTORY_REQUEST_CANCELED";
  OrderActivityDetailType["DEAL_INVENTORY_CLAIMED"] = "DEAL_INVENTORY_CLAIMED";
  OrderActivityDetailType["DEAL_INVENTORY_FULFILLMENT_ORDER_CANCELED"] = "DEAL_INVENTORY_FULFILLMENT_ORDER_CANCELED";
  OrderActivityDetailType["ITEM_RETURN_REQUESTED"] = "ITEM_RETURN_REQUESTED";
  OrderActivityDetailType["RETURN_SHIPMENT_TRACKING_UPDATED"] = "RETURN_SHIPMENT_TRACKING_UPDATED";
  OrderActivityDetailType["ITEM_RETURN_SHIPPED"] = "ITEM_RETURN_SHIPPED";
  OrderActivityDetailType["ITEM_RETURN_RECEIVED"] = "ITEM_RETURN_RECEIVED";
  OrderActivityDetailType["RETURN_SHIPMENT_TRACKING_REMOVED"] = "RETURN_SHIPMENT_TRACKING_REMOVED";
  OrderActivityDetailType["FULFILLMENT_PROCESS_UPDATED"] = "FULFILLMENT_PROCESS_UPDATED";
  OrderActivityDetailType["ITEM_RECEIVED"] = "ITEM_RECEIVED";
  OrderActivityDetailType["ITEM_ORDER_VERIFICATION"] = "ITEM_ORDER_VERIFICATION";
  OrderActivityDetailType["REFUND_REQUESTED"] = "REFUND_REQUESTED";
  OrderActivityDetailType["REFUND_STATE_UPDATED"] = "REFUND_STATE_UPDATED";
  OrderActivityDetailType["REFUND_AMOUNT_ADJUSTED"] = "REFUND_AMOUNT_ADJUSTED";
  OrderActivityDetailType["ORDER_ADDRESS_CHANGED"] = "ORDER_ADDRESS_CHANGED";
  OrderActivityDetailType["EXPERT_CONTRIBUTION_CHANGED"] = "EXPERT_CONTRIBUTION_CHANGED";
  OrderActivityDetailType["RETURN_DESTINATION_CHANGED"] = "RETURN_DESTINATION_CHANGED";
  OrderActivityDetailType["MERCHANT_REFUND_UPDATED"] = "MERCHANT_REFUND_UPDATED";
  OrderActivityDetailType["CONFIRMED_RETURN_LABEL_SENT"] = "CONFIRMED_RETURN_LABEL_SENT";
})(OrderActivityDetailType || (OrderActivityDetailType = {}));

var OrderCancellationReason;

(function (OrderCancellationReason) {
  OrderCancellationReason["DIDNT_LIKE"] = "DIDNT_LIKE";
  OrderCancellationReason["WRONG_AMOUNT"] = "WRONG_AMOUNT";
  OrderCancellationReason["WRONG_PRODUCT"] = "WRONG_PRODUCT";
  OrderCancellationReason["WRONG_COLOR"] = "WRONG_COLOR";
})(OrderCancellationReason || (OrderCancellationReason = {}));

var OrderChangeStatus;

(function (OrderChangeStatus) {
  OrderChangeStatus["CREATED"] = "CREATED";
  OrderChangeStatus["IN_PROGRESS"] = "IN_PROGRESS";
  OrderChangeStatus["CANCELLED"] = "CANCELLED";
  OrderChangeStatus["FAILED"] = "FAILED";
  OrderChangeStatus["COMPLETED"] = "COMPLETED";
})(OrderChangeStatus || (OrderChangeStatus = {}));

var OrderChargeableStatusType;

(function (OrderChargeableStatusType) {
  /** The order can be charged */
  OrderChargeableStatusType["CAN_CHARGE"] = "CAN_CHARGE";
  /** The order has already been charged. */

  OrderChargeableStatusType["ALREADY_CHARGED"] = "ALREADY_CHARGED";
  /** The order is empty. */

  OrderChargeableStatusType["EMPTY"] = "EMPTY";
  /** The order requires a shipping address, but none was provided. Not relevant for OrderChargeableUseCase.CHECKOUT */

  OrderChargeableStatusType["NO_SHIPPING_ADDRESS"] = "NO_SHIPPING_ADDRESS";
  /**
   * The order requires a service address, but none was set by the expert. Orders should never reach the customer in
   * this state as the address should be set by the expert beforehand.
   */

  OrderChargeableStatusType["NO_SERVICE_LOCATION"] = "NO_SERVICE_LOCATION";
  /** The order is expired; the user must reach out to the expert to renew the order. */

  OrderChargeableStatusType["EXPIRED"] = "EXPIRED";
  /**
   * The order requires a minimum amount (e.g.: Orders shipped to Australia need to have at least $125 in the cart)
   * Use the `message` property on `OrderChargeableStatus` to display a message containing the exact amount the user
   * needs.
   */

  OrderChargeableStatusType["BELOW_MINIMUM_AMOUNT"] = "BELOW_MINIMUM_AMOUNT";
  /**
   * The order is in a preview state (only available for viewing); the user must reach out to the expert to receive
   * a new purchase-able order.
   */

  OrderChargeableStatusType["IN_PREVIEW"] = "IN_PREVIEW";
})(OrderChargeableStatusType || (OrderChargeableStatusType = {}));

var OrderChargeableUseCase;

(function (OrderChargeableUseCase) {
  /** Checking if the checkout process can be started */
  OrderChargeableUseCase["CHECKOUT"] = "CHECKOUT";
  /** Checking if the order can be purchased (payment provided to stripe/paypal/etc, and order charged) */

  OrderChargeableUseCase["PURCHASE"] = "PURCHASE";
})(OrderChargeableUseCase || (OrderChargeableUseCase = {}));

var OrderCostComponent;

(function (OrderCostComponent) {
  /** Includes the price for AD_HOC, SELLABLE, and BASE_PRICE source types (the core price of what's being purchased) */
  OrderCostComponent["CORE"] = "CORE";
  /** Tip paid to Deal.com experts */

  OrderCostComponent["EXPERT_TIP"] = "EXPERT_TIP";
  /** Fixed gratuity (e.g.: mandatory crew gratuity for charters) */

  OrderCostComponent["GRATUITY"] = "GRATUITY";
  /** Prepaid incidental charges (e.g.: advanced provisional allowance for yacht charters) */

  OrderCostComponent["PREPAID_INCIDENTAL"] = "PREPAID_INCIDENTAL";
  /** Shipping */

  OrderCostComponent["SHIPMENT"] = "SHIPMENT";
  /** Tax */

  OrderCostComponent["TAX_ADJUSTMENTS"] = "TAX_ADJUSTMENTS";
  /** Discounts through promotions */

  OrderCostComponent["DISCOUNT_ADJUSTMENTS"] = "DISCOUNT_ADJUSTMENTS";
  /** Refunds */

  OrderCostComponent["REFUNDS"] = "REFUNDS";
  /** Gift Card */

  OrderCostComponent["GIFT_CARD"] = "GIFT_CARD";
  /** Gift Card */

  OrderCostComponent["MEMBERSHIP"] = "MEMBERSHIP";
})(OrderCostComponent || (OrderCostComponent = {}));

var OrderEscalationLabel;

(function (OrderEscalationLabel) {
  OrderEscalationLabel["NEED_CONSUMER_INPUT"] = "NEED_CONSUMER_INPUT";
  OrderEscalationLabel["NEED_MERCHANT_INPUT"] = "NEED_MERCHANT_INPUT";
})(OrderEscalationLabel || (OrderEscalationLabel = {}));

var OrderEscalationPriority;

(function (OrderEscalationPriority) {
  OrderEscalationPriority["HIGH"] = "HIGH";
  OrderEscalationPriority["NORMAL"] = "NORMAL";
})(OrderEscalationPriority || (OrderEscalationPriority = {}));

var OrderEscalationSearchSort;

(function (OrderEscalationSearchSort) {
  OrderEscalationSearchSort["CREATED_AT"] = "CREATED_AT";
  OrderEscalationSearchSort["STATUS"] = "STATUS";
  OrderEscalationSearchSort["ORDER_ID"] = "ORDER_ID";
  OrderEscalationSearchSort["USER_ID"] = "USER_ID";
  OrderEscalationSearchSort["PAID_AT"] = "PAID_AT";
})(OrderEscalationSearchSort || (OrderEscalationSearchSort = {}));

var OrderEscalationSource;

(function (OrderEscalationSource) {
  OrderEscalationSource["CONSUMER"] = "CONSUMER";
  OrderEscalationSource["EXPERT"] = "EXPERT";
  OrderEscalationSource["OPERATIONS"] = "OPERATIONS";
})(OrderEscalationSource || (OrderEscalationSource = {}));

var OrderEscalationStatus;

(function (OrderEscalationStatus) {
  OrderEscalationStatus["NEW"] = "NEW";
  OrderEscalationStatus["IN_PROGRESS"] = "IN_PROGRESS";
  OrderEscalationStatus["COMPLETED"] = "COMPLETED";
})(OrderEscalationStatus || (OrderEscalationStatus = {}));

var OrderEscalationType;

(function (OrderEscalationType) {
  OrderEscalationType["ITEM_UNAVAILABLE"] = "ITEM_UNAVAILABLE";
  OrderEscalationType["MISSING_SPECS"] = "MISSING_SPECS";
  OrderEscalationType["ORDER_ADJUSTMENT"] = "ORDER_ADJUSTMENT";
  OrderEscalationType["CANCELLATION"] = "CANCELLATION";
  OrderEscalationType["RETURN"] = "RETURN";
  OrderEscalationType["EXCHANGE"] = "EXCHANGE";
  OrderEscalationType["MISSING_ITEM"] = "MISSING_ITEM";
  OrderEscalationType["TRACKING_INQUIRY"] = "TRACKING_INQUIRY";
  OrderEscalationType["ORDER_INFORMATION"] = "ORDER_INFORMATION";
  OrderEscalationType["OTHER"] = "OTHER";
})(OrderEscalationType || (OrderEscalationType = {}));

var OrderFulfillmentState;

(function (OrderFulfillmentState) {
  OrderFulfillmentState["NEW"] = "NEW";
  OrderFulfillmentState["CLAIMED"] = "CLAIMED";
  OrderFulfillmentState["READY"] = "READY";
  OrderFulfillmentState["FULFILLED"] = "FULFILLED";
})(OrderFulfillmentState || (OrderFulfillmentState = {}));

var OrderLabel;

(function (OrderLabel) {
  OrderLabel["UNCLAIMED"] = "UNCLAIMED";
  OrderLabel["TRACKING_NEEDED"] = "TRACKING_NEEDED";
  OrderLabel["TRACKING_OVERDUE"] = "TRACKING_OVERDUE";
})(OrderLabel || (OrderLabel = {}));

var OrderLineItemGroupPriceStrategy;

(function (OrderLineItemGroupPriceStrategy) {
  /** This line item has no price, and is strictly added as a grouping line item with the children having prices. */
  OrderLineItemGroupPriceStrategy["IGNORE_SELF_DEFAULT_CHILDREN"] = "IGNORE_SELF_DEFAULT_CHILDREN";
  /** This line item has a price, with the child line item prices being ignored / not respected. */

  OrderLineItemGroupPriceStrategy["ONLY_SELF_IGNORE_CHILDREN"] = "ONLY_SELF_IGNORE_CHILDREN";
})(OrderLineItemGroupPriceStrategy || (OrderLineItemGroupPriceStrategy = {}));

var OrderLineItemGroupTaxStrategy;

(function (OrderLineItemGroupTaxStrategy) {
  /** All line items will retain their default tax calculation. */
  OrderLineItemGroupTaxStrategy["DEFAULT"] = "DEFAULT";
  /**
   * All line items that are children of the current line item will use the current line item's tax calculation.
   * This is useful when the grouping parent line item is a service (e.g.: charters) that are taxed using the service
   * location - not the shipping address. This strategy will use that same calculation (service location) for all child
   * line items (e.g.: ensure that add-on food line item is taxed like the charter).
   */

  OrderLineItemGroupTaxStrategy["PROPAGATE_SELF_TO_CHILDREN"] = "PROPAGATE_SELF_TO_CHILDREN";
})(OrderLineItemGroupTaxStrategy || (OrderLineItemGroupTaxStrategy = {}));

var OrderLineItemsGroupingType;

(function (OrderLineItemsGroupingType) {
  OrderLineItemsGroupingType["TRACKING"] = "TRACKING";
})(OrderLineItemsGroupingType || (OrderLineItemsGroupingType = {}));

var OrderLineItemSourceType;

(function (OrderLineItemSourceType) {
  /** No additional metadata; ad-hoc line item */
  OrderLineItemSourceType["AD_HOC"] = "AD_HOC";
  /** Line item is linked to a sellable */

  OrderLineItemSourceType["SELLABLE"] = "SELLABLE";
  /** Line item is a child line item, indicating the base price of the parent (primarily used for services) */

  OrderLineItemSourceType["BASE_PRICE"] = "BASE_PRICE";
  /** Line item represents a tip to Deal.com experts */

  OrderLineItemSourceType["EXPERT_TIP"] = "EXPERT_TIP";
  /** Fixed gratuity */

  OrderLineItemSourceType["GRATUITY"] = "GRATUITY";
  /** Prepaid incidental charges */

  OrderLineItemSourceType["PREPAID_INCIDENTAL"] = "PREPAID_INCIDENTAL";
  /** Shipment cost line item */

  OrderLineItemSourceType["SHIPMENT"] = "SHIPMENT";
  /** Refund for one or more items in the order */

  OrderLineItemSourceType["REFUND"] = "REFUND";
  /** Gift card purchase */

  OrderLineItemSourceType["GIFT_CARD"] = "GIFT_CARD";
  /** Optional warranty purchase with a product */

  OrderLineItemSourceType["WARRANTY"] = "WARRANTY";
  /** Gift card purchase */

  OrderLineItemSourceType["MEMBERSHIP"] = "MEMBERSHIP";
})(OrderLineItemSourceType || (OrderLineItemSourceType = {}));

var OrderLineItemState;

(function (OrderLineItemState) {
  OrderLineItemState["PENDING_CLAIM"] = "PENDING_CLAIM";
  OrderLineItemState["CLAIMED"] = "CLAIMED";
  OrderLineItemState["NEW"] = "NEW";
  OrderLineItemState["PAID"] = "PAID";
  OrderLineItemState["READY_TO_CLAIM"] = "READY_TO_CLAIM";
  OrderLineItemState["PENDING_SHIPPING"] = "PENDING_SHIPPING";
  OrderLineItemState["READY"] = "READY";
  OrderLineItemState["RECEIVED"] = "RECEIVED";
  OrderLineItemState["RETURN_PENDING_SHIPPING"] = "RETURN_PENDING_SHIPPING";
  OrderLineItemState["RETURN_REQUESTED"] = "RETURN_REQUESTED";
  OrderLineItemState["RETURN_RECEIVED"] = "RETURN_RECEIVED";
  OrderLineItemState["RETURN_SHIPPED"] = "RETURN_SHIPPED";
  OrderLineItemState["SHIPPED"] = "SHIPPED";
  OrderLineItemState["UNAVAILABLE"] = "UNAVAILABLE";
  OrderLineItemState["CUSTOMIZING"] = "CUSTOMIZING";
})(OrderLineItemState || (OrderLineItemState = {}));

var OrderPreSubmitAction;

(function (OrderPreSubmitAction) {
  OrderPreSubmitAction["CHECKOUT_STARTED"] = "CHECKOUT_STARTED";
  OrderPreSubmitAction["ADD_TO_CART"] = "ADD_TO_CART";
  OrderPreSubmitAction["PAYMENT_INFO_ENTERED"] = "PAYMENT_INFO_ENTERED";
})(OrderPreSubmitAction || (OrderPreSubmitAction = {}));

var OrderRefundReason;

(function (OrderRefundReason) {
  OrderRefundReason["DIDNT_LIKE"] = "DIDNT_LIKE";
  OrderRefundReason["NOT_EXPECTED"] = "NOT_EXPECTED";
  OrderRefundReason["WRONG_ITEM"] = "WRONG_ITEM";
  OrderRefundReason["BAD_DESCRIPTION"] = "BAD_DESCRIPTION";
  OrderRefundReason["DEFECTIVE"] = "DEFECTIVE";
  OrderRefundReason["DAMAGED_IN_SHIPPING"] = "DAMAGED_IN_SHIPPING";
  OrderRefundReason["NEVER_ARRIVED"] = "NEVER_ARRIVED";
  OrderRefundReason["ARRIVED_LATE"] = "ARRIVED_LATE";
  OrderRefundReason["UNAPPROVED"] = "UNAPPROVED";
  OrderRefundReason["BAD_WEATHER"] = "BAD_WEATHER";
  OrderRefundReason["EQUIPMENT_MALFUNCTION"] = "EQUIPMENT_MALFUNCTION";
  OrderRefundReason["WRONG_AMOUNT"] = "WRONG_AMOUNT";
  OrderRefundReason["WRONG_SIZE"] = "WRONG_SIZE";
  OrderRefundReason["WRONG_COLOR"] = "WRONG_COLOR";
  OrderRefundReason["DAMAGED_SHIPPING_BOX_OK"] = "DAMAGED_SHIPPING_BOX_OK";
  OrderRefundReason["DAMAGED_SHIPPING_BOX_DAMAGED"] = "DAMAGED_SHIPPING_BOX_DAMAGED";
  OrderRefundReason["UNAVAILABLE_INVENTORY"] = "UNAVAILABLE_INVENTORY";
  OrderRefundReason["REPLACED_INVENTORY"] = "REPLACED_INVENTORY";
  OrderRefundReason["LOST_DURING_SHIPPING"] = "LOST_DURING_SHIPPING";
  OrderRefundReason["UNABLE_TO_EXPEDITE_SHIPPING"] = "UNABLE_TO_EXPEDITE_SHIPPING";
  OrderRefundReason["PRICE_MATCH"] = "PRICE_MATCH";
  OrderRefundReason["CUSTOMER_REQUEST"] = "CUSTOMER_REQUEST";
})(OrderRefundReason || (OrderRefundReason = {}));

var OrderRefundRequestReason;

(function (OrderRefundRequestReason) {
  OrderRefundRequestReason["MISSING_PROMOTION"] = "MISSING_PROMOTION";
  OrderRefundRequestReason["DISCOUNT_CASH"] = "DISCOUNT_CASH";
  OrderRefundRequestReason["DELAYED_SHIPPING"] = "DELAYED_SHIPPING";
  OrderRefundRequestReason["CUSTOMER_HAPPINESS"] = "CUSTOMER_HAPPINESS";
})(OrderRefundRequestReason || (OrderRefundRequestReason = {}));

var OrderRefundStatus;

(function (OrderRefundStatus) {
  OrderRefundStatus["SUCCESS"] = "SUCCESS";
  OrderRefundStatus["PENDING"] = "PENDING";
  OrderRefundStatus["FAILED"] = "FAILED";
  OrderRefundStatus["REJECTED"] = "REJECTED";
  OrderRefundStatus["CANCELLED"] = "CANCELLED";
})(OrderRefundStatus || (OrderRefundStatus = {}));

var OrderRefundType;

(function (OrderRefundType) {
  OrderRefundType["REFUND"] = "REFUND";
  OrderRefundType["RETURN"] = "RETURN";
  OrderRefundType["CANCELLATION"] = "CANCELLATION";
})(OrderRefundType || (OrderRefundType = {}));

var OrderSearchSort;

(function (OrderSearchSort) {
  OrderSearchSort["PAID_AT"] = "PAID_AT";
  OrderSearchSort["CREATED_AT"] = "CREATED_AT";
  OrderSearchSort["EFFECTIVE_ORDER_DATE"] = "EFFECTIVE_ORDER_DATE";
  OrderSearchSort["EFFECTIVE_ORDER_DATE_ASC"] = "EFFECTIVE_ORDER_DATE_ASC";
})(OrderSearchSort || (OrderSearchSort = {}));

var OrderState;

(function (OrderState) {
  OrderState["CART"] = "CART";
  OrderState["CREATED"] = "CREATED";
  OrderState["SUBMITTED"] = "SUBMITTED";
  OrderState["CONSUMER_PAYMENT_PENDING"] = "CONSUMER_PAYMENT_PENDING";
  OrderState["CONSUMER_PAYMENT_IN_REVIEW"] = "CONSUMER_PAYMENT_IN_REVIEW";
  OrderState["CONSUMER_PAYMENT_COMPLETED"] = "CONSUMER_PAYMENT_COMPLETED";
  OrderState["CONSUMER_PAYMENT_FAILED"] = "CONSUMER_PAYMENT_FAILED";
  OrderState["CONSUMER_PAYMENT_PARTIAL"] = "CONSUMER_PAYMENT_PARTIAL";
  OrderState["CONSUMER_OVERPAID"] = "CONSUMER_OVERPAID";
  OrderState["CONSUMER_PAYMENT_REFUNDED"] = "CONSUMER_PAYMENT_REFUNDED";
  OrderState["CONSUMER_PAYMENT_CANCELED"] = "CONSUMER_PAYMENT_CANCELED";
})(OrderState || (OrderState = {}));

var PartnerAccountContactType;

(function (PartnerAccountContactType) {
  PartnerAccountContactType["REMIT_PAYMENT"] = "REMIT_PAYMENT";
  PartnerAccountContactType["PURCHASE_ORDER"] = "PURCHASE_ORDER";
  PartnerAccountContactType["CLAIM_DOCUMENTATION"] = "CLAIM_DOCUMENTATION";
  PartnerAccountContactType["CEO"] = "CEO";
  PartnerAccountContactType["VP_OF_SALES"] = "VP_OF_SALES";
  PartnerAccountContactType["NATIONAL_SALES_MANAGER"] = "NATIONAL_SALES_MANAGER";
  PartnerAccountContactType["REGIONAL_SALES_MANAGER"] = "REGIONAL_SALES_MANAGER";
  PartnerAccountContactType["SALES_REP"] = "SALES_REP";
  PartnerAccountContactType["CUSTOMER_SERVICE_REP"] = "CUSTOMER_SERVICE_REP";
  PartnerAccountContactType["CO_OP"] = "CO_OP";
  PartnerAccountContactType["VENDOR_COMPLIANCE"] = "VENDOR_COMPLIANCE";
  PartnerAccountContactType["RETURNS"] = "RETURNS";
  PartnerAccountContactType["TRANSPORTATION"] = "TRANSPORTATION";
  PartnerAccountContactType["PRODUCT_CONTENT"] = "PRODUCT_CONTENT";
})(PartnerAccountContactType || (PartnerAccountContactType = {}));

var PartnerAccountState;

(function (PartnerAccountState) {
  PartnerAccountState["PENDING"] = "PENDING";
  PartnerAccountState["ACTIVE"] = "ACTIVE";
  PartnerAccountState["DEACTIVATED"] = "DEACTIVATED";
})(PartnerAccountState || (PartnerAccountState = {}));

var PartnerUserState;

(function (PartnerUserState) {
  PartnerUserState["ACTIVE"] = "ACTIVE";
  PartnerUserState["DEACTIVATED"] = "DEACTIVATED";
})(PartnerUserState || (PartnerUserState = {}));

var PathAttributeValueType;

(function (PathAttributeValueType) {
  PathAttributeValueType["STATIC"] = "STATIC";
})(PathAttributeValueType || (PathAttributeValueType = {}));

var PathConditionEnumDeclarationType;

(function (PathConditionEnumDeclarationType) {
  PathConditionEnumDeclarationType["ATTRIBUTE"] = "ATTRIBUTE";
  PathConditionEnumDeclarationType["STATIC"] = "STATIC";
})(PathConditionEnumDeclarationType || (PathConditionEnumDeclarationType = {}));

var PathConditionLogicalType;

(function (PathConditionLogicalType) {
  PathConditionLogicalType["AND"] = "AND";
  PathConditionLogicalType["OR"] = "OR";
})(PathConditionLogicalType || (PathConditionLogicalType = {}));

var PathConditionOperandValueTypeName;

(function (PathConditionOperandValueTypeName) {
  PathConditionOperandValueTypeName["LONG"] = "LONG";
  PathConditionOperandValueTypeName["LONG_RANGE"] = "LONG_RANGE";
  PathConditionOperandValueTypeName["BIG_DECIMAL"] = "BIG_DECIMAL";
  PathConditionOperandValueTypeName["BIG_DECIMAL_RANGE"] = "BIG_DECIMAL_RANGE";
  PathConditionOperandValueTypeName["STRING"] = "STRING";
  PathConditionOperandValueTypeName["ENUM"] = "ENUM";
  PathConditionOperandValueTypeName["LOCAL_DATE"] = "LOCAL_DATE";
  PathConditionOperandValueTypeName["LOCAL_DATE_RANGE"] = "LOCAL_DATE_RANGE";
  PathConditionOperandValueTypeName["LOCAL_TIME"] = "LOCAL_TIME";
  PathConditionOperandValueTypeName["LOCAL_TIME_RANGE"] = "LOCAL_TIME_RANGE";
  PathConditionOperandValueTypeName["LOCAL_DATE_TIME"] = "LOCAL_DATE_TIME";
  PathConditionOperandValueTypeName["LOCAL_DATE_TIME_RANGE"] = "LOCAL_DATE_TIME_RANGE";
  PathConditionOperandValueTypeName["ZONE_ID"] = "ZONE_ID";
  PathConditionOperandValueTypeName["DURATION"] = "DURATION";
  PathConditionOperandValueTypeName["ID"] = "ID";
  PathConditionOperandValueTypeName["BOOLEAN"] = "BOOLEAN";
})(PathConditionOperandValueTypeName || (PathConditionOperandValueTypeName = {}));

var PathConditionOperatorType;

(function (PathConditionOperatorType) {
  PathConditionOperatorType["TRUE"] = "TRUE";
  PathConditionOperatorType["FALSE"] = "FALSE";
  PathConditionOperatorType["EQUAL"] = "EQUAL";
  PathConditionOperatorType["NOT_EQUAL"] = "NOT_EQUAL";
  PathConditionOperatorType["LESSER_THAN"] = "LESSER_THAN";
  PathConditionOperatorType["LESSER_THAN_OR_EQUAL"] = "LESSER_THAN_OR_EQUAL";
  PathConditionOperatorType["GREATER_THAN"] = "GREATER_THAN";
  PathConditionOperatorType["GREATER_THAN_OR_EQUAL"] = "GREATER_THAN_OR_EQUAL";
  PathConditionOperatorType["ONE_OF"] = "ONE_OF";
  PathConditionOperatorType["NOT_ONE_OF"] = "NOT_ONE_OF";
  PathConditionOperatorType["EXISTS"] = "EXISTS";
  PathConditionOperatorType["DOES_NOT_EXIST"] = "DOES_NOT_EXIST";
  PathConditionOperatorType["ENCLOSED_BY"] = "ENCLOSED_BY";
  PathConditionOperatorType["CONNECTED"] = "CONNECTED";
  PathConditionOperatorType["IN_RANGE"] = "IN_RANGE";
  PathConditionOperatorType["CONTAINS"] = "CONTAINS";
  PathConditionOperatorType["DOES_NOT_CONTAIN"] = "DOES_NOT_CONTAIN";
  PathConditionOperatorType["PARTIAL_MATCH"] = "PARTIAL_MATCH";
  PathConditionOperatorType["DOES_NOT_PARTIALLY_MATCH"] = "DOES_NOT_PARTIALLY_MATCH";
})(PathConditionOperatorType || (PathConditionOperatorType = {}));

var PathConditionType;

(function (PathConditionType) {
  PathConditionType["COMPARISON"] = "COMPARISON";
  PathConditionType["LOGICAL"] = "LOGICAL";
})(PathConditionType || (PathConditionType = {}));

var PathEditorRichTextContentPartType;

(function (PathEditorRichTextContentPartType) {
  PathEditorRichTextContentPartType["TEXT"] = "TEXT";
  PathEditorRichTextContentPartType["NEW_LINE"] = "NEW_LINE";
})(PathEditorRichTextContentPartType || (PathEditorRichTextContentPartType = {}));

var PathEditorValidationErrorTargetType;

(function (PathEditorValidationErrorTargetType) {
  PathEditorValidationErrorTargetType["QUESTION"] = "QUESTION";
  PathEditorValidationErrorTargetType["LIST_QUESTION_CHOICE"] = "LIST_QUESTION_CHOICE";
  PathEditorValidationErrorTargetType["BRANCH_RULE"] = "BRANCH_RULE";
  PathEditorValidationErrorTargetType["PORT"] = "PORT";
})(PathEditorValidationErrorTargetType || (PathEditorValidationErrorTargetType = {}));

var PathEditorValidationErrorTier;

(function (PathEditorValidationErrorTier) {
  PathEditorValidationErrorTier["MISSING_DATA"] = "MISSING_DATA";
  PathEditorValidationErrorTier["INVALID_DATA"] = "INVALID_DATA";
})(PathEditorValidationErrorTier || (PathEditorValidationErrorTier = {}));

var PathEditorValidationErrorType;

(function (PathEditorValidationErrorType) {
  PathEditorValidationErrorType["MISSING_SLUG"] = "MISSING_SLUG";
  PathEditorValidationErrorType["MALFORMED_SLUG"] = "MALFORMED_SLUG";
  PathEditorValidationErrorType["DUPLICATE_SLUG"] = "DUPLICATE_SLUG";
  PathEditorValidationErrorType["BRANCH_CONTAINER_RULES_EMPTY"] = "BRANCH_CONTAINER_RULES_EMPTY";
  PathEditorValidationErrorType["CREATE_REQUEST_LEAD_MISSING_CATEGORY"] = "CREATE_REQUEST_LEAD_MISSING_CATEGORY";
  PathEditorValidationErrorType["CREATE_EXPERT_APPLICATION_MISSING_CATEGORY"] = "CREATE_EXPERT_APPLICATION_MISSING_CATEGORY";
  PathEditorValidationErrorType["CREATE_SURVEY_RESPONSE_MISSING_NAME"] = "CREATE_SURVEY_RESPONSE_MISSING_NAME";
  PathEditorValidationErrorType["QUESTIONS_MISSING_ATTRIBUTE"] = "QUESTIONS_MISSING_ATTRIBUTE";
  PathEditorValidationErrorType["QUESTIONS_INVALID_ATTRIBUTE"] = "QUESTIONS_INVALID_ATTRIBUTE";
  PathEditorValidationErrorType["QUESTIONS_CHOICES_EMPTY"] = "QUESTIONS_CHOICES_EMPTY";
  PathEditorValidationErrorType["QUESTIONS_CHOICES_MISSING_TEXT_AND_IMAGE"] = "QUESTIONS_CHOICES_MISSING_TEXT_AND_IMAGE";
  PathEditorValidationErrorType["QUESTIONS_CHOICES_MISSING_ATTRIBUTE_VALUE"] = "QUESTIONS_CHOICES_MISSING_ATTRIBUTE_VALUE";
  PathEditorValidationErrorType["QUESTIONS_CHOICES_INVALID_ATTRIBUTE_VALUE"] = "QUESTIONS_CHOICES_INVALID_ATTRIBUTE_VALUE";
  PathEditorValidationErrorType["QUESTIONS_EMPTY"] = "QUESTIONS_EMPTY";
  PathEditorValidationErrorType["CONDITION_MISSING_OPERAND"] = "CONDITION_MISSING_OPERAND";
  PathEditorValidationErrorType["CONDITION_MISSING_OPERATOR"] = "CONDITION_MISSING_OPERATOR";
  PathEditorValidationErrorType["CONDITION_INVALID_OPERAND_OPERATOR_COMBINATION"] = "CONDITION_INVALID_OPERAND_OPERATOR_COMBINATION";
  PathEditorValidationErrorType["PATH_SCHEMA_REFERENCE_INVALID"] = "PATH_SCHEMA_REFERENCE_INVALID";
  PathEditorValidationErrorType["PATH_SCHEMA_FRAGMENT_REFERENCE_INVALID"] = "PATH_SCHEMA_FRAGMENT_REFERENCE_INVALID";
  PathEditorValidationErrorType["MISSING_EDGE"] = "MISSING_EDGE";
  PathEditorValidationErrorType["INTERSTITIAL_IMAGE_TEXT_BLOCKS_LIMIT"] = "INTERSTITIAL_IMAGE_TEXT_BLOCKS_LIMIT";
  PathEditorValidationErrorType["INTERSTITIAL_IMAGE_TEXT_BLOCK_EMPTY"] = "INTERSTITIAL_IMAGE_TEXT_BLOCK_EMPTY";
  PathEditorValidationErrorType["INJECT_ATTRIBUTES_NO_ENTITY_ID_SOURCES"] = "INJECT_ATTRIBUTES_NO_ENTITY_ID_SOURCES";
  PathEditorValidationErrorType["INJECT_ATTRIBUTES_NO_ALLOW_LIST"] = "INJECT_ATTRIBUTES_NO_ALLOW_LIST";
})(PathEditorValidationErrorType || (PathEditorValidationErrorType = {}));

var PathFlowOnCompleteRedirectLocation;

(function (PathFlowOnCompleteRedirectLocation) {
  /** Reload the current page, this is used for paths that happen in-place */
  PathFlowOnCompleteRedirectLocation["RELOAD_CURRENT_PAGE"] = "RELOAD_CURRENT_PAGE";
  /** Expert profile page with selection screen. Only valid for paths completed with a lead. */

  PathFlowOnCompleteRedirectLocation["EXPERT_PROFILE"] = "EXPERT_PROFILE";
  /** Default inbox page */

  PathFlowOnCompleteRedirectLocation["INBOX"] = "INBOX";
  /** Redirect to login page */

  PathFlowOnCompleteRedirectLocation["LOGIN"] = "LOGIN";
  /** Redirect to the completion page after an application is submitted */

  PathFlowOnCompleteRedirectLocation["APPLY_FINISH"] = "APPLY_FINISH";
  /** Redirect to selected department page */

  PathFlowOnCompleteRedirectLocation["DEPARTMENT_PAGE"] = "DEPARTMENT_PAGE";
  /** Redirect to selected category page */

  PathFlowOnCompleteRedirectLocation["CATEGORY"] = "CATEGORY";
  /**
   * For golf experiment only, a redirect that will take the user back into
   * the path system to add their phone number
   */

  PathFlowOnCompleteRedirectLocation["PHONE_COLLECTION_PATH"] = "PHONE_COLLECTION_PATH";
})(PathFlowOnCompleteRedirectLocation || (PathFlowOnCompleteRedirectLocation = {}));

var PathFlowPageMetadataType;

(function (PathFlowPageMetadataType) {
  PathFlowPageMetadataType["INTERSTITIAL"] = "INTERSTITIAL";
  PathFlowPageMetadataType["CUSTOM"] = "CUSTOM";
  /** Below are deprecated */

  PathFlowPageMetadataType["LOADING_QUESTIONS"] = "LOADING_QUESTIONS";
  PathFlowPageMetadataType["CONNECTING_TO_OPERATOR"] = "CONNECTING_TO_OPERATOR";
  PathFlowPageMetadataType["FINDING_MERCHANTS"] = "FINDING_MERCHANTS";
  PathFlowPageMetadataType["HIGH_SECURITY"] = "HIGH_SECURITY";
  PathFlowPageMetadataType["WELCOME"] = "WELCOME";
})(PathFlowPageMetadataType || (PathFlowPageMetadataType = {}));

var PathFlowThemeType;

(function (PathFlowThemeType) {
  PathFlowThemeType["DEFAULT"] = "DEFAULT";
  PathFlowThemeType["SNOWBOARD"] = "SNOWBOARD";
  PathFlowThemeType["CHAT_LIKE"] = "CHAT_LIKE";
})(PathFlowThemeType || (PathFlowThemeType = {}));

var PathGraphContainerSort;

(function (PathGraphContainerSort) {
  PathGraphContainerSort["NAME"] = "NAME";
  PathGraphContainerSort["UPDATED_AT"] = "UPDATED_AT";
  PathGraphContainerSort["KEYWORD_RELEVANCE"] = "KEYWORD_RELEVANCE";
})(PathGraphContainerSort || (PathGraphContainerSort = {}));

var PathGraphContainerState;

(function (PathGraphContainerState) {
  PathGraphContainerState["DRAFT"] = "DRAFT";
  PathGraphContainerState["IN_REVIEW"] = "IN_REVIEW";
  PathGraphContainerState["PUBLISHED"] = "PUBLISHED";
  PathGraphContainerState["ARCHIVED"] = "ARCHIVED";
})(PathGraphContainerState || (PathGraphContainerState = {}));

var PathGraphContainerStateFilter;

(function (PathGraphContainerStateFilter) {
  PathGraphContainerStateFilter["ALL"] = "ALL";
  PathGraphContainerStateFilter["ALL_INCLUDE_ARCHIVED"] = "ALL_INCLUDE_ARCHIVED";
  PathGraphContainerStateFilter["IN_REVIEW"] = "IN_REVIEW";
  PathGraphContainerStateFilter["DRAFT"] = "DRAFT";
  PathGraphContainerStateFilter["PUBLISHED"] = "PUBLISHED";
})(PathGraphContainerStateFilter || (PathGraphContainerStateFilter = {}));

var PathGraphFlowRunMode;

(function (PathGraphFlowRunMode) {
  /** Path is executing all actions with real side effects (e.g.: creating accounts, etc) */
  PathGraphFlowRunMode["LIVE"] = "LIVE";
  /**
   * Path is not executing any operation that produces external side effects (like creating accounts), and instead will
   * attempt to display DryRunInfoPathNodeFlowViewModel in place of action executions to detail what would happen in
   * a real execution.
   */

  PathGraphFlowRunMode["DRY_RUN"] = "DRY_RUN";
})(PathGraphFlowRunMode || (PathGraphFlowRunMode = {}));

var PathNodeConfigType;

(function (PathNodeConfigType) {
  PathNodeConfigType["START"] = "START";
  PathNodeConfigType["PATH_SCHEMA"] = "PATH_SCHEMA";
  PathNodeConfigType["PATH_SCHEMA_END"] = "PATH_SCHEMA_END";
  PathNodeConfigType["PATH_SCHEMA_FRAGMENT"] = "PATH_SCHEMA_FRAGMENT";
  PathNodeConfigType["PATH_SCHEMA_FRAGMENT_END"] = "PATH_SCHEMA_FRAGMENT_END";
  PathNodeConfigType["PATH_SCHEMA_REFERENCE"] = "PATH_SCHEMA_REFERENCE";
  PathNodeConfigType["PATH_SCHEMA_FRAGMENT_REFERENCE"] = "PATH_SCHEMA_FRAGMENT_REFERENCE";
  PathNodeConfigType["QUESTION"] = "QUESTION";
  PathNodeConfigType["INTERSTITIAL"] = "INTERSTITIAL";
  PathNodeConfigType["REDIRECT"] = "REDIRECT";
  PathNodeConfigType["BRANCH_CONTAINER"] = "BRANCH_CONTAINER";
  PathNodeConfigType["BRANCH_RULE"] = "BRANCH_RULE";
  PathNodeConfigType["BRANCH_FALLBACK_RULE"] = "BRANCH_FALLBACK_RULE";
  PathNodeConfigType["CREATE_ACCOUNT_ACTION"] = "CREATE_ACCOUNT_ACTION";
  PathNodeConfigType["CREATE_REQUEST_LEAD_ACTION"] = "CREATE_REQUEST_LEAD_ACTION";
  PathNodeConfigType["CREATE_EXPERT_APPLICATION_ACTION"] = "CREATE_EXPERT_APPLICATION_ACTION";
  PathNodeConfigType["CREATE_CONSUMER_EXPERT_REVIEW_ACTION"] = "CREATE_CONSUMER_EXPERT_REVIEW_ACTION";
  PathNodeConfigType["INJECT_ATTRIBUTES_ACTION"] = "INJECT_ATTRIBUTES_ACTION";
  PathNodeConfigType["CREATE_SURVEY_RESPONSE_ACTION"] = "CREATE_SURVEY_RESPONSE_ACTION";
})(PathNodeConfigType || (PathNodeConfigType = {}));

var PathNodeDynamicExpanderStateType;

(function (PathNodeDynamicExpanderStateType) {
  PathNodeDynamicExpanderStateType["PATH_SCHEMA_REFERENCE"] = "PATH_SCHEMA_REFERENCE";
})(PathNodeDynamicExpanderStateType || (PathNodeDynamicExpanderStateType = {}));

var PathNodeExpanderSetting;

(function (PathNodeExpanderSetting) {
  PathNodeExpanderSetting["EXPANDED"] = "EXPANDED";
  PathNodeExpanderSetting["COLLAPSED"] = "COLLAPSED";
})(PathNodeExpanderSetting || (PathNodeExpanderSetting = {}));

var PathPortType;

(function (PathPortType) {
  PathPortType["INCOMING"] = "INCOMING";
  PathPortType["OUTGOING"] = "OUTGOING";
})(PathPortType || (PathPortType = {}));

var PathQuestionDisplayComponentSchemaType;

(function (PathQuestionDisplayComponentSchemaType) {
  /** Show terms and conditions */
  PathQuestionDisplayComponentSchemaType["TERMS_AND_CONDITIONS"] = "TERMS_AND_CONDITIONS";
  /** Telephone Consumer Protection Act Compliance disclaimer */

  PathQuestionDisplayComponentSchemaType["TCPA_COMPLIANCE"] = "TCPA_COMPLIANCE";
})(PathQuestionDisplayComponentSchemaType || (PathQuestionDisplayComponentSchemaType = {}));

var PathQuestionSchemaType;

(function (PathQuestionSchemaType) {
  PathQuestionSchemaType["LIST"] = "LIST";
  PathQuestionSchemaType["INPUT_TEXT"] = "INPUT_TEXT";
  PathQuestionSchemaType["NUMERIC"] = "NUMERIC";
  PathQuestionSchemaType["DATE"] = "DATE";
})(PathQuestionSchemaType || (PathQuestionSchemaType = {}));

var PathSchemaDomainType;

(function (PathSchemaDomainType) {
  /** "r" is the short form used in slugs */
  PathSchemaDomainType["REQUEST"] = "REQUEST";
  /** "ea" is the short form used in slugs */

  PathSchemaDomainType["EXPERT_APPLICATION"] = "EXPERT_APPLICATION";
  /** "cre" is the short form used in slugs */

  PathSchemaDomainType["CONSUMER_REVIEW_FOR_EXPERT"] = "CONSUMER_REVIEW_FOR_EXPERT";
  /** "s" is the short form used in slugs */

  PathSchemaDomainType["SURVEY_RESPONSE"] = "SURVEY_RESPONSE";
})(PathSchemaDomainType || (PathSchemaDomainType = {}));

var PathValidationErrorTag;

(function (PathValidationErrorTag) {
  /** If this error is produced, the client must have the user login, or change the contact information being used to proceed */
  PathValidationErrorTag["REQUIRES_LOGIN_TO_PROCEED"] = "REQUIRES_LOGIN_TO_PROCEED";
  /** Indicates an internal error, typically surfaced if the API is misused, or some type of developer/administrative error. */

  PathValidationErrorTag["INTERNAL"] = "INTERNAL";
})(PathValidationErrorTag || (PathValidationErrorTag = {}));

var PayComponentType;

(function (PayComponentType) {
  PayComponentType["COMMISSION"] = "COMMISSION";
  PayComponentType["QUALITY_CONVERSATION"] = "QUALITY_CONVERSATION";
  PayComponentType["TIP"] = "TIP";
  PayComponentType["FIRST_SHIFTS_GUARANTEED_PAY"] = "FIRST_SHIFTS_GUARANTEED_PAY";
  PayComponentType["HOURLY_ON_CALL"] = "HOURLY_ON_CALL";
  PayComponentType["MANUAL_ADJUSTMENT"] = "MANUAL_ADJUSTMENT";
  PayComponentType["REFERRAL_FIRST_ORDER"] = "REFERRAL_FIRST_ORDER";
  PayComponentType["TEAM_LEAD_COMMISSION"] = "TEAM_LEAD_COMMISSION";
})(PayComponentType || (PayComponentType = {}));

var PayLineItemSortField;

(function (PayLineItemSortField) {
  PayLineItemSortField["PAY_COMPONENT_TYPE"] = "PAY_COMPONENT_TYPE";
  PayLineItemSortField["POSTED_AT"] = "POSTED_AT";
  PayLineItemSortField["AMOUNT"] = "AMOUNT";
})(PayLineItemSortField || (PayLineItemSortField = {}));

var PaymentActionType;

(function (PaymentActionType) {
  PaymentActionType["STRIPE_REQUIRED_PAYMENT_ACTION"] = "STRIPE_REQUIRED_PAYMENT_ACTION";
  PaymentActionType["STRIPE_REQUIRED_SETUP_ACTION"] = "STRIPE_REQUIRED_SETUP_ACTION";
})(PaymentActionType || (PaymentActionType = {}));

var PaymentActivityType;

(function (PaymentActivityType) {
  PaymentActivityType["FULL_PAYMENT"] = "FULL_PAYMENT";
  PaymentActivityType["DEPOSIT"] = "DEPOSIT";
  PaymentActivityType["REMAINING_BALANCE"] = "REMAINING_BALANCE";
})(PaymentActivityType || (PaymentActivityType = {}));

var PaymentMethod;

(function (PaymentMethod) {
  PaymentMethod["CARD"] = "CARD";
  PaymentMethod["PAYPAL"] = "PAYPAL";
  PaymentMethod["THREE_D_SECURE"] = "THREE_D_SECURE";
  PaymentMethod["APPLE_PAY"] = "APPLE_PAY";
  PaymentMethod["ANDROID_PAY"] = "ANDROID_PAY";
  PaymentMethod["GOOGLE_PAY"] = "GOOGLE_PAY";
  PaymentMethod["PAY_BY_INSTALLMENT"] = "PAY_BY_INSTALLMENT";
  PaymentMethod["WIRE_TRANSFER"] = "WIRE_TRANSFER";
  PaymentMethod["BANK_CHECK"] = "BANK_CHECK";
})(PaymentMethod || (PaymentMethod = {}));

var PaymentProcessorType;

(function (PaymentProcessorType) {
  PaymentProcessorType["STRIPE"] = "STRIPE";
  PaymentProcessorType["PAYPAL"] = "PAYPAL";
  PaymentProcessorType["AFTERPAY"] = "AFTERPAY";
  PaymentProcessorType["AFFIRM"] = "AFFIRM";
  PaymentProcessorType["DEAL"] = "DEAL";
})(PaymentProcessorType || (PaymentProcessorType = {}));

var PaymentRefundStatus;

(function (PaymentRefundStatus) {
  PaymentRefundStatus["PENDING"] = "PENDING";
  PaymentRefundStatus["SUCCESS"] = "SUCCESS";
  PaymentRefundStatus["FAILED"] = "FAILED";
})(PaymentRefundStatus || (PaymentRefundStatus = {}));

var PaymentSourceStatus;

(function (PaymentSourceStatus) {
  /** indicates the source is archived, for ex: on expiry, account closure, deleting previously saved card */
  PaymentSourceStatus["ARCHIVED"] = "ARCHIVED";
  PaymentSourceStatus["CANCELED"] = "CANCELED";
  /** Only chargeable Source can be used to create a charge */

  PaymentSourceStatus["CHARGEABLE"] = "CHARGEABLE";
  /** This indicates an older Source that is now detached from the user. */

  PaymentSourceStatus["CONSUMED"] = "CONSUMED";
  PaymentSourceStatus["FAILED"] = "FAILED";
  PaymentSourceStatus["PENDING"] = "PENDING";
  PaymentSourceStatus["PENDING_INTENT"] = "PENDING_INTENT";
})(PaymentSourceStatus || (PaymentSourceStatus = {}));
/**
 * Whether this source should be reusable or not. Some source types may or may not be reusable by construction,
 * while other may leave the option at creation. If an incompatible value is passed, an error will be returned.
 */


var PaymentSourceUsage;

(function (PaymentSourceUsage) {
  PaymentSourceUsage["REUSABLE"] = "REUSABLE";
  PaymentSourceUsage["SINGLE_USE"] = "SINGLE_USE";
})(PaymentSourceUsage || (PaymentSourceUsage = {}));

var PaymentVerificationMethod;

(function (PaymentVerificationMethod) {
  PaymentVerificationMethod["CODE"] = "CODE";
  PaymentVerificationMethod["AMOUNT"] = "AMOUNT";
})(PaymentVerificationMethod || (PaymentVerificationMethod = {}));

var PayoutSortField;

(function (PayoutSortField) {
  PayoutSortField["POSTED_AT"] = "POSTED_AT";
  PayoutSortField["TOTAL_AMOUNT"] = "TOTAL_AMOUNT";
  PayoutSortField["COMMISSION_AMOUNT"] = "COMMISSION_AMOUNT";
  PayoutSortField["QUALITY_CONVERSATION_AMOUNT"] = "QUALITY_CONVERSATION_AMOUNT";
  PayoutSortField["TIP_AMOUNT"] = "TIP_AMOUNT";
  PayoutSortField["FIRST_SHIFTS_GUARANTEED_PAY_AMOUNT"] = "FIRST_SHIFTS_GUARANTEED_PAY_AMOUNT";
  PayoutSortField["HOURLY_ON_CALL_AMOUNT"] = "HOURLY_ON_CALL_AMOUNT";
  PayoutSortField["MANUAL_ADJUSTMENT_AMOUNT"] = "MANUAL_ADJUSTMENT_AMOUNT";
})(PayoutSortField || (PayoutSortField = {}));

var PayoutState;

(function (PayoutState) {
  PayoutState["CREATED"] = "CREATED";
  PayoutState["PENDING_APPROVAL"] = "PENDING_APPROVAL";
  PayoutState["APPROVED"] = "APPROVED";
  PayoutState["ERROR"] = "ERROR";
  PayoutState["PAID"] = "PAID";
  PayoutState["ARCHIVED"] = "ARCHIVED";
})(PayoutState || (PayoutState = {}));

var PayStructureRevisionState;

(function (PayStructureRevisionState) {
  PayStructureRevisionState["DRAFT"] = "DRAFT";
  PayStructureRevisionState["ACTIVE"] = "ACTIVE";
  PayStructureRevisionState["PENDING"] = "PENDING";
  PayStructureRevisionState["DEACTIVATED"] = "DEACTIVATED";
})(PayStructureRevisionState || (PayStructureRevisionState = {}));
/**
 * =============
 * this is used in biz-app, we should migrate to BusinessUserPermission
 * =============
 */


var Permission;

(function (Permission) {
  Permission["UI_OVERWRITE_SELLABLE_PRICE"] = "UI_OVERWRITE_SELLABLE_PRICE";
  Permission["UI_ON_CALL_EXPERT"] = "UI_ON_CALL_EXPERT";
  Permission["UI_ACCEPT_NEW_LEAD"] = "UI_ACCEPT_NEW_LEAD";
})(Permission || (Permission = {}));

var PostalAddressLocationDisplayType;

(function (PostalAddressLocationDisplayType) {
  PostalAddressLocationDisplayType["CITY_STATE"] = "CITY_STATE";
})(PostalAddressLocationDisplayType || (PostalAddressLocationDisplayType = {}));

var PresenceStatus;

(function (PresenceStatus) {
  PresenceStatus["ONLINE"] = "ONLINE";
  PresenceStatus["ONLINE_INACTIVE"] = "ONLINE_INACTIVE";
  PresenceStatus["OFFLINE"] = "OFFLINE";
  PresenceStatus["PUSH_NOTIFICATION"] = "PUSH_NOTIFICATION";
  PresenceStatus["SMS"] = "SMS";
})(PresenceStatus || (PresenceStatus = {}));

var ProductCatalogGroupRevisionState;

(function (ProductCatalogGroupRevisionState) {
  ProductCatalogGroupRevisionState["PUBLISHED"] = "PUBLISHED";
  ProductCatalogGroupRevisionState["DRAFT"] = "DRAFT";
  ProductCatalogGroupRevisionState["ARCHIVED"] = "ARCHIVED";
})(ProductCatalogGroupRevisionState || (ProductCatalogGroupRevisionState = {}));

var ProductCatalogRevisionState;

(function (ProductCatalogRevisionState) {
  ProductCatalogRevisionState["PUBLISHED"] = "PUBLISHED";
  ProductCatalogRevisionState["DRAFT"] = "DRAFT";
  ProductCatalogRevisionState["ARCHIVED"] = "ARCHIVED";
})(ProductCatalogRevisionState || (ProductCatalogRevisionState = {}));

var ProductCatalogSort;

(function (ProductCatalogSort) {
  /** The date when it is first published */
  ProductCatalogSort["FIRST_PUBLISHED"] = "FIRST_PUBLISHED";
  /** The date when it is last updated */

  ProductCatalogSort["LAST_UPDATED"] = "LAST_UPDATED";
})(ProductCatalogSort || (ProductCatalogSort = {}));

var ProductCondition;

(function (ProductCondition) {
  ProductCondition["NEW"] = "NEW";
  ProductCondition["EXCELLENT"] = "EXCELLENT";
  ProductCondition["GOOD"] = "GOOD";
  ProductCondition["FAIR"] = "FAIR";
})(ProductCondition || (ProductCondition = {}));

var ProductReturnDestination;

(function (ProductReturnDestination) {
  ProductReturnDestination["WAREHOUSE"] = "WAREHOUSE";
  ProductReturnDestination["MERCHANT"] = "MERCHANT";
  ProductReturnDestination["OFFICE"] = "OFFICE";
  ProductReturnDestination["UNKNOWN"] = "UNKNOWN";
})(ProductReturnDestination || (ProductReturnDestination = {}));

var ProfileHighlightIconType;

(function (ProfileHighlightIconType) {
  ProfileHighlightIconType["BEER"] = "BEER";
  ProfileHighlightIconType["CAKE"] = "CAKE";
  ProfileHighlightIconType["CALENDAR"] = "CALENDAR";
  ProfileHighlightIconType["CHAT"] = "CHAT";
  ProfileHighlightIconType["CHECK"] = "CHECK";
  ProfileHighlightIconType["COCKTAIL"] = "COCKTAIL";
  ProfileHighlightIconType["DRINK"] = "DRINK";
  ProfileHighlightIconType["GOLF_CLUB"] = "GOLF_CLUB";
  ProfileHighlightIconType["GOLF_CLUB_SET"] = "GOLF_CLUB_SET";
  ProfileHighlightIconType["GOLF_COURSE"] = "GOLF_COURSE";
  ProfileHighlightIconType["HEART"] = "HEART";
  ProfileHighlightIconType["LOCATION"] = "LOCATION";
  ProfileHighlightIconType["DIPLOMA"] = "DIPLOMA";
  ProfileHighlightIconType["SKIER"] = "SKIER";
  ProfileHighlightIconType["SNOWBOARDER"] = "SNOWBOARDER";
  ProfileHighlightIconType["MOUNTAIN"] = "MOUNTAIN";
  ProfileHighlightIconType["SNOWFLAKE"] = "SNOWFLAKE";
  ProfileHighlightIconType["SMILE"] = "SMILE";
  ProfileHighlightIconType["STAR"] = "STAR";
})(ProfileHighlightIconType || (ProfileHighlightIconType = {}));

var ProfileHighlightSource;

(function (ProfileHighlightSource) {
  ProfileHighlightSource["SYSTEM"] = "SYSTEM";
  ProfileHighlightSource["USER"] = "USER";
})(ProfileHighlightSource || (ProfileHighlightSource = {}));

var ProfileHighlightValueType;

(function (ProfileHighlightValueType) {
  ProfileHighlightValueType["TEXT"] = "TEXT";
  ProfileHighlightValueType["ENUMERATION"] = "ENUMERATION";
  ProfileHighlightValueType["DATE"] = "DATE";
})(ProfileHighlightValueType || (ProfileHighlightValueType = {}));

var PromotionActionType;

(function (PromotionActionType) {
  PromotionActionType["PERCENT_OFF_LINE_ITEMS"] = "PERCENT_OFF_LINE_ITEMS";
  PromotionActionType["AMOUNT_OFF_ORDER"] = "AMOUNT_OFF_ORDER";
})(PromotionActionType || (PromotionActionType = {}));

var PromotionDisabledReason;

(function (PromotionDisabledReason) {
  PromotionDisabledReason["MANUAL"] = "MANUAL";
  PromotionDisabledReason["REPLACED"] = "REPLACED";
  PromotionDisabledReason["EXPIRED"] = "EXPIRED";
  PromotionDisabledReason["REACHED_USAGE_LIMIT"] = "REACHED_USAGE_LIMIT";
})(PromotionDisabledReason || (PromotionDisabledReason = {}));

var PromotionQueryFlagType;

(function (PromotionQueryFlagType) {
  /** Surface items including items with this flag set */
  PromotionQueryFlagType["INCLUDE"] = "INCLUDE";
  /** Only surface items with this flag set */

  PromotionQueryFlagType["ONLY"] = "ONLY";
  /** Exclude items with this flag set */

  PromotionQueryFlagType["NONE"] = "NONE";
})(PromotionQueryFlagType || (PromotionQueryFlagType = {}));

var PromotionRuleComparisonOperator;

(function (PromotionRuleComparisonOperator) {
  PromotionRuleComparisonOperator["GREATER_THAN"] = "GREATER_THAN";
  PromotionRuleComparisonOperator["GREATER_THAN_OR_EQUAL"] = "GREATER_THAN_OR_EQUAL";
  PromotionRuleComparisonOperator["EQUAL"] = "EQUAL";
  PromotionRuleComparisonOperator["LESS_THAN"] = "LESS_THAN";
  PromotionRuleComparisonOperator["LESS_THAN_OR_EQUAL"] = "LESS_THAN_OR_EQUAL";
})(PromotionRuleComparisonOperator || (PromotionRuleComparisonOperator = {}));

var PromotionRuleFilterStrategy;

(function (PromotionRuleFilterStrategy) {
  /**
   * Filtering reduces the scope of the promotion actions. For example, if the rule is to `FILTER` for sellables in
   * the snowboard category, a subsequent promotion action to take 10% off will only take 10% off of the sellables
   * in the snowboard category - not other items in the cart. If no line items fall into the filter criteria, the
   * promotion will not be applied to the order.
   */
  PromotionRuleFilterStrategy["FILTER"] = "FILTER";
  /**
   * Excluding forces the promotion to not be the order if any of its criteria are met. For example, if the rule is
   * to `EXCLUDE` sellable X, any order with sellable X will not be eligible for the promotion.
   */

  PromotionRuleFilterStrategy["EXCLUDE"] = "EXCLUDE";
})(PromotionRuleFilterStrategy || (PromotionRuleFilterStrategy = {}));

var PromotionRuleType;

(function (PromotionRuleType) {
  PromotionRuleType["ORDER_AMOUNT"] = "ORDER_AMOUNT";
  PromotionRuleType["SELLABLE_FILTER"] = "SELLABLE_FILTER";
  PromotionRuleType["SELLABLE_CATEGORY_FILTER"] = "SELLABLE_CATEGORY_FILTER";
  PromotionRuleType["SELLABLE_BRAND_FILTER"] = "SELLABLE_BRAND_FILTER";
  PromotionRuleType["SELLABLE_ATTRIBUTE_FILTER"] = "SELLABLE_ATTRIBUTE_FILTER";
  PromotionRuleType["PURCHASED_ORDER_COUNT"] = "PURCHASED_ORDER_COUNT";
  PromotionRuleType["USER_USAGE_LIMIT"] = "USER_USAGE_LIMIT";
})(PromotionRuleType || (PromotionRuleType = {}));

var PromotionSourceType;

(function (PromotionSourceType) {
  PromotionSourceType["REFERRER"] = "REFERRER";
  PromotionSourceType["REFEREE"] = "REFEREE";
  PromotionSourceType["REGISTRATION"] = "REGISTRATION";
  PromotionSourceType["SOCIAL_SHARING"] = "SOCIAL_SHARING";
})(PromotionSourceType || (PromotionSourceType = {}));

var PromotionState;

(function (PromotionState) {
  PromotionState["DRAFT"] = "DRAFT";
  PromotionState["ACTIVE"] = "ACTIVE";
  PromotionState["DISABLED"] = "DISABLED";
})(PromotionState || (PromotionState = {}));

var PurchasableMembershipType;

(function (PurchasableMembershipType) {
  PurchasableMembershipType["CURATED_INSIDER"] = "CURATED_INSIDER";
})(PurchasableMembershipType || (PurchasableMembershipType = {}));

var RawSellableAttributeValuePatternFlag;

(function (RawSellableAttributeValuePatternFlag) {
  RawSellableAttributeValuePatternFlag["UNIX_LINES"] = "UNIX_LINES";
  RawSellableAttributeValuePatternFlag["CASE_INSENSITIVE"] = "CASE_INSENSITIVE";
  RawSellableAttributeValuePatternFlag["COMMENTS"] = "COMMENTS";
  RawSellableAttributeValuePatternFlag["MULTILINE"] = "MULTILINE";
  RawSellableAttributeValuePatternFlag["LITERAL"] = "LITERAL";
  RawSellableAttributeValuePatternFlag["DOTALL"] = "DOTALL";
  RawSellableAttributeValuePatternFlag["UNICODE_CASE"] = "UNICODE_CASE";
  RawSellableAttributeValuePatternFlag["CANON_EQ"] = "CANON_EQ";
  RawSellableAttributeValuePatternFlag["UNICODE_CHARACTER_CLASS"] = "UNICODE_CHARACTER_CLASS";
})(RawSellableAttributeValuePatternFlag || (RawSellableAttributeValuePatternFlag = {}));

var RawSellableSourceShopifyType;

(function (RawSellableSourceShopifyType) {
  RawSellableSourceShopifyType["MANUFACTURER_DROP_SHIP"] = "MANUFACTURER_DROP_SHIP";
  RawSellableSourceShopifyType["PARTNER_DROP_SHIP"] = "PARTNER_DROP_SHIP";
})(RawSellableSourceShopifyType || (RawSellableSourceShopifyType = {}));

var RawSellableSourceState;

(function (RawSellableSourceState) {
  RawSellableSourceState["ACTIVE"] = "ACTIVE";
  RawSellableSourceState["INACTIVE"] = "INACTIVE";
})(RawSellableSourceState || (RawSellableSourceState = {}));

var RawSellableSourceType;

(function (RawSellableSourceType) {
  RawSellableSourceType["SCRAPER"] = "SCRAPER";
  RawSellableSourceType["DEAL_INVENTORY"] = "DEAL_INVENTORY";
  RawSellableSourceType["GOOGLE_SHOPPING_FEED"] = "GOOGLE_SHOPPING_FEED";
  RawSellableSourceType["GOOGLE_SHOPPING_SEARCH"] = "GOOGLE_SHOPPING_SEARCH";
  RawSellableSourceType["LEVEL9_FEED"] = "LEVEL9_FEED";
  RawSellableSourceType["SHOPIFY"] = "SHOPIFY";
  RawSellableSourceType["WALMART"] = "WALMART";
  RawSellableSourceType["IMPACT"] = "IMPACT";
  RawSellableSourceType["FROMUTH"] = "FROMUTH";
})(RawSellableSourceType || (RawSellableSourceType = {}));

var RawSellableStandardizationActionType;

(function (RawSellableStandardizationActionType) {
  RawSellableStandardizationActionType["SET_CATEGORY"] = "SET_CATEGORY";
  RawSellableStandardizationActionType["SET_ATTRIBUTE_VALUE"] = "SET_ATTRIBUTE_VALUE";
  RawSellableStandardizationActionType["COPY_ATTRIBUTE_VALUE"] = "COPY_ATTRIBUTE_VALUE";
  RawSellableStandardizationActionType["REMOVE_ATTRIBUTE"] = "REMOVE_ATTRIBUTE";
  RawSellableStandardizationActionType["REPLACE_ATTRIBUTE_VALUE"] = "REPLACE_ATTRIBUTE_VALUE";
  RawSellableStandardizationActionType["MARK_OUT_OF_STOCK"] = "MARK_OUT_OF_STOCK";
  RawSellableStandardizationActionType["DEACTIVATE"] = "DEACTIVATE";
  RawSellableStandardizationActionType["HIDE_FROM_CONSUMER_SEARCH"] = "HIDE_FROM_CONSUMER_SEARCH";
  RawSellableStandardizationActionType["SET_TITLE"] = "SET_TITLE";
  RawSellableStandardizationActionType["SET_VARIATION_GROUP_TITLE"] = "SET_VARIATION_GROUP_TITLE";
  RawSellableStandardizationActionType["SET_VARIATION_GROUP_REFERENCE"] = "SET_VARIATION_GROUP_REFERENCE";
  RawSellableStandardizationActionType["SET_BRAND"] = "SET_BRAND";
  RawSellableStandardizationActionType["SET_MPN"] = "SET_MPN";
  RawSellableStandardizationActionType["SET_ATTRIBUTE_VARIATION_DIMENSION"] = "SET_ATTRIBUTE_VARIATION_DIMENSION";
  RawSellableStandardizationActionType["SET_DESCRIPTION"] = "SET_DESCRIPTION";
  RawSellableStandardizationActionType["RENAME_ATTRIBUTE"] = "RENAME_ATTRIBUTE";
  RawSellableStandardizationActionType["MARK_NONE_VARIANT"] = "MARK_NONE_VARIANT";
})(RawSellableStandardizationActionType || (RawSellableStandardizationActionType = {}));

var RawSellableStandardizationResultState;

(function (RawSellableStandardizationResultState) {
  RawSellableStandardizationResultState["PENDING"] = "PENDING";
  RawSellableStandardizationResultState["COMPLETED"] = "COMPLETED";
})(RawSellableStandardizationResultState || (RawSellableStandardizationResultState = {}));

var RawSellableStandardizationRuleConditionType;

(function (RawSellableStandardizationRuleConditionType) {
  RawSellableStandardizationRuleConditionType["LOGICAL"] = "LOGICAL";
  RawSellableStandardizationRuleConditionType["BINARY"] = "BINARY";
  RawSellableStandardizationRuleConditionType["CONSTANT"] = "CONSTANT";
})(RawSellableStandardizationRuleConditionType || (RawSellableStandardizationRuleConditionType = {}));

var RawSellableStandardizationRuleFieldType;

(function (RawSellableStandardizationRuleFieldType) {
  RawSellableStandardizationRuleFieldType["BOOLEAN"] = "BOOLEAN";
  RawSellableStandardizationRuleFieldType["STRING"] = "STRING";
  RawSellableStandardizationRuleFieldType["STRING_LIST"] = "STRING_LIST";
  RawSellableStandardizationRuleFieldType["ID"] = "ID";
  RawSellableStandardizationRuleFieldType["ID_LIST"] = "ID_LIST";
  RawSellableStandardizationRuleFieldType["INTEGER"] = "INTEGER";
  RawSellableStandardizationRuleFieldType["DECIMAL"] = "DECIMAL";
})(RawSellableStandardizationRuleFieldType || (RawSellableStandardizationRuleFieldType = {}));

var RawSellableStandardizationRuleParameterType;

(function (RawSellableStandardizationRuleParameterType) {
  RawSellableStandardizationRuleParameterType["ENTITY_FIELD"] = "ENTITY_FIELD";
  RawSellableStandardizationRuleParameterType["LITERAL_VALUE"] = "LITERAL_VALUE";
})(RawSellableStandardizationRuleParameterType || (RawSellableStandardizationRuleParameterType = {}));

var RawSellableStandardizationRuleState;

(function (RawSellableStandardizationRuleState) {
  RawSellableStandardizationRuleState["ACTIVE"] = "ACTIVE";
  RawSellableStandardizationRuleState["INACTIVE"] = "INACTIVE";
})(RawSellableStandardizationRuleState || (RawSellableStandardizationRuleState = {}));

var RawSellableState;

(function (RawSellableState) {
  RawSellableState["ACTIVE"] = "ACTIVE";
  RawSellableState["INACTIVE"] = "INACTIVE";
})(RawSellableState || (RawSellableState = {}));

var RecommendedListType;

(function (RecommendedListType) {
  /**
   * Recommendation list built using  a combination of multiple user Attributes learnt from
   * the Path Deal request. More specifically, it uses Gender, Price, Brand, Primary Attributes and other secondary
   * attributes to build this request.
   * The list built only if brand and primary attributes are present in the users request
   * Accessories are explicitly excluded
   */
  RecommendedListType["MY_TOP_LIST"] = "MY_TOP_LIST";
  /** This is similar to TOP LIST but enforces a strict matching of user request attributes. */

  RecommendedListType["STRICT_MY_TOP_LIST"] = "STRICT_MY_TOP_LIST";
  /**
   * Recommendation list built using price and primary attributes from users path request attributes
   * Each primary attribute has a separate list
   * The list built only if primary attributes are present in the users request
   * Accessories are explicitly excluded
   */

  RecommendedListType["PRICE_AND_PRIMARY_ATTRIBUTES"] = "PRICE_AND_PRIMARY_ATTRIBUTES";
  /**
   * Recommendation list built using brands and primary attributes from users path request attributes
   * Each brand has a separate list
   * The list built only if brand attributes are present in the users request
   * Accessories are explicitly excluded
   */

  RecommendedListType["BRAND_AND_PRIMARY_ATTRIBUTES"] = "BRAND_AND_PRIMARY_ATTRIBUTES";
  /**
   * Recommendation list built using accessories selected by the user in the path request
   * Each Accessory has a separate list
   */

  RecommendedListType["ACCESSORIES"] = "ACCESSORIES";
  /** Recommended list built using curated lists that were recommended to similar users */

  RecommendedListType["CURATED_LIST_TO_SIMILAR_USERS"] = "CURATED_LIST_TO_SIMILAR_USERS";
  /**
   * This recommendation list is used to build a digest of recommendations based on user intent from the deal request
   * The relevancy favors most recent sellables and also favors sellables with price within users budget
   * that has changed recently.
   */

  RecommendedListType["PRICE_SENSITIVE_INTENT_BASED_DIGEST"] = "PRICE_SENSITIVE_INTENT_BASED_DIGEST";
  /** the recommended list built from a custom list defined by the operator or expert */

  RecommendedListType["CUSTOM"] = "CUSTOM";
})(RecommendedListType || (RecommendedListType = {}));

var RedirectPathNodeConfigType;

(function (RedirectPathNodeConfigType) {
  RedirectPathNodeConfigType["RETURN_TO_PREVIOUS_CONTEXT"] = "RETURN_TO_PREVIOUS_CONTEXT";
  RedirectPathNodeConfigType["INBOX"] = "INBOX";
  RedirectPathNodeConfigType["APPLY_FINISH"] = "APPLY_FINISH";
  RedirectPathNodeConfigType["SURVEY_FINISH"] = "SURVEY_FINISH";
})(RedirectPathNodeConfigType || (RedirectPathNodeConfigType = {}));

var ReferralMedium;

(function (ReferralMedium) {
  ReferralMedium["EMAIL"] = "EMAIL";
  ReferralMedium["FACEBOOK"] = "FACEBOOK";
  ReferralMedium["LINK"] = "LINK";
})(ReferralMedium || (ReferralMedium = {}));

var ReferralType;

(function (ReferralType) {
  ReferralType["CONSUMER_GENERIC"] = "CONSUMER_GENERIC";
  ReferralType["CONSUMER_TO_EXPERT"] = "CONSUMER_TO_EXPERT";
  ReferralType["EXPERT_DIRECT"] = "EXPERT_DIRECT";
})(ReferralType || (ReferralType = {}));

var ReferrerIncentiveType;

(function (ReferrerIncentiveType) {
  ReferrerIncentiveType["CREDIT_FOR_SOCIAL_SHARE"] = "CREDIT_FOR_SOCIAL_SHARE";
  ReferrerIncentiveType["PERCENT_OFF_ON_FIRST_REFEREE_ORDER"] = "PERCENT_OFF_ON_FIRST_REFEREE_ORDER";
})(ReferrerIncentiveType || (ReferrerIncentiveType = {}));

var RegisterCustomerErrorCode;

(function (RegisterCustomerErrorCode) {
  RegisterCustomerErrorCode["ALREADY_REGISTERED"] = "ALREADY_REGISTERED";
  RegisterCustomerErrorCode["INVALID_PHONE_NUMBER"] = "INVALID_PHONE_NUMBER";
  RegisterCustomerErrorCode["INVALID_EMAIL_ADDRESS"] = "INVALID_EMAIL_ADDRESS";
  RegisterCustomerErrorCode["INVALID_SMS_SIGN_IN"] = "INVALID_SMS_SIGN_IN";
  RegisterCustomerErrorCode["FAILED_OAUTH"] = "FAILED_OAUTH";
  RegisterCustomerErrorCode["INVALID_HANDLE_VERIFICATION_TOKEN"] = "INVALID_HANDLE_VERIFICATION_TOKEN";
})(RegisterCustomerErrorCode || (RegisterCustomerErrorCode = {}));

var RelativeDateUnit;

(function (RelativeDateUnit) {
  RelativeDateUnit["NANOS"] = "NANOS";
  RelativeDateUnit["MILLIS"] = "MILLIS";
  RelativeDateUnit["SECONDS"] = "SECONDS";
  RelativeDateUnit["MINUTES"] = "MINUTES";
  RelativeDateUnit["HOURS"] = "HOURS";
  RelativeDateUnit["DAYS"] = "DAYS";
  RelativeDateUnit["MONTHS"] = "MONTHS";
  RelativeDateUnit["YEARS"] = "YEARS";
})(RelativeDateUnit || (RelativeDateUnit = {}));

var ReopenTicketReason;

(function (ReopenTicketReason) {
  ReopenTicketReason["NOT_RESOLVED"] = "NOT_RESOLVED";
  ReopenTicketReason["EXPERT_COMMENT"] = "EXPERT_COMMENT";
  ReopenTicketReason["CANCELLATION_ROLLBACK"] = "CANCELLATION_ROLLBACK";
})(ReopenTicketReason || (ReopenTicketReason = {}));

var ReportAccessScope;

(function (ReportAccessScope) {
  ReportAccessScope["BUSINESS_USER"] = "BUSINESS_USER";
  ReportAccessScope["TEAM"] = "TEAM";
  ReportAccessScope["DEPARTMENT"] = "DEPARTMENT";
  ReportAccessScope["GLOBAL"] = "GLOBAL";
})(ReportAccessScope || (ReportAccessScope = {}));

var ReportColumnFormat;

(function (ReportColumnFormat) {
  ReportColumnFormat["NONE"] = "NONE";
  ReportColumnFormat["PERCENTAGE"] = "PERCENTAGE";
  ReportColumnFormat["CURRENCY"] = "CURRENCY";
})(ReportColumnFormat || (ReportColumnFormat = {}));

var ReportColumnValueType;

(function (ReportColumnValueType) {
  ReportColumnValueType["STRING"] = "STRING";
  ReportColumnValueType["INTEGER"] = "INTEGER";
  ReportColumnValueType["DOUBLE"] = "DOUBLE";
})(ReportColumnValueType || (ReportColumnValueType = {}));

var ReportSchemaType;

(function (ReportSchemaType) {
  /** The total amount of conversations, and the amount of new conversations in the last week. */
  ReportSchemaType["CONVERSATIONS_COUNT"] = "CONVERSATIONS_COUNT";
  /** Stats about expert ratings; total rating count, and average rating score. */

  ReportSchemaType["EXPERT_RATING_STATS"] = "EXPERT_RATING_STATS";
  /** The total amount of curations, and the amount of new curations in the last week. */

  ReportSchemaType["CURATIONS_COUNT"] = "CURATIONS_COUNT";
  /** Most popular brands recommended by experts, grouped by category */

  ReportSchemaType["RECOMMENDED_BY_EXPERTS_CAT_BRAND_STATS"] = "RECOMMENDED_BY_EXPERTS_CAT_BRAND_STATS";
  /**
   * Most popular brands recommended by experts, grouped and rolled up by category
   * linked to department (e.g.: winter sports, golf, etc)
   */

  ReportSchemaType["RECOMMENDED_BY_EXPERTS_DEPT_CAT_BRAND_STATS"] = "RECOMMENDED_BY_EXPERTS_DEPT_CAT_BRAND_STATS";
})(ReportSchemaType || (ReportSchemaType = {}));

var ReturnPolicyType;

(function (ReturnPolicyType) {
  ReturnPolicyType["NO_RETURNS_ACCEPTED"] = "NO_RETURNS_ACCEPTED";
  ReturnPolicyType["STANDARD"] = "STANDARD";
})(ReturnPolicyType || (ReturnPolicyType = {}));

var ReturnRefundMethod;

(function (ReturnRefundMethod) {
  ReturnRefundMethod["ORIGINAL_PAYMENT"] = "ORIGINAL_PAYMENT";
  ReturnRefundMethod["STORE_CREDIT"] = "STORE_CREDIT";
})(ReturnRefundMethod || (ReturnRefundMethod = {}));

var ReturnShippingPaidBy;

(function (ReturnShippingPaidBy) {
  ReturnShippingPaidBy["NOT_APPLICABLE"] = "NOT_APPLICABLE";
  ReturnShippingPaidBy["MERCHANT"] = "MERCHANT";
  ReturnShippingPaidBy["CUSTOMER"] = "CUSTOMER";
})(ReturnShippingPaidBy || (ReturnShippingPaidBy = {}));

var RevisionChangeType;

(function (RevisionChangeType) {
  RevisionChangeType["CREATED"] = "CREATED";
  RevisionChangeType["PUBLISHED"] = "PUBLISHED";
  RevisionChangeType["DEACTIVATED"] = "DEACTIVATED";
  RevisionChangeType["IMPORTED"] = "IMPORTED";
})(RevisionChangeType || (RevisionChangeType = {}));

var RevisionState;

(function (RevisionState) {
  RevisionState["DRAFT"] = "DRAFT";
  RevisionState["PUBLISHED"] = "PUBLISHED";
  RevisionState["DEACTIVATED"] = "DEACTIVATED";
})(RevisionState || (RevisionState = {}));

var RichPathNodeOwningEntityType;

(function (RichPathNodeOwningEntityType) {
  RichPathNodeOwningEntityType["PATH_SCHEMA_REVISION"] = "PATH_SCHEMA_REVISION";
  RichPathNodeOwningEntityType["PATH_SCHEMA_FRAGMENT_REVISION"] = "PATH_SCHEMA_FRAGMENT_REVISION";
})(RichPathNodeOwningEntityType || (RichPathNodeOwningEntityType = {}));

var RpalExclusionReason;

(function (RpalExclusionReason) {
  RpalExclusionReason["SPAM"] = "SPAM";
  RpalExclusionReason["TRAINING"] = "TRAINING";
  RpalExclusionReason["SELF_CHECKOUT"] = "SELF_CHECKOUT";
  RpalExclusionReason["NON_RESPONSIVE"] = "NON_RESPONSIVE";
  RpalExclusionReason["STOPPED"] = "STOPPED";
  RpalExclusionReason["BUSINESS_DEVELOPMENT"] = "BUSINESS_DEVELOPMENT";
  RpalExclusionReason["RECRUITING"] = "RECRUITING";
  RpalExclusionReason["OTHER"] = "OTHER";
})(RpalExclusionReason || (RpalExclusionReason = {}));

var SavedExpertCuratedItemState;

(function (SavedExpertCuratedItemState) {
  SavedExpertCuratedItemState["DRAFT"] = "DRAFT";
  SavedExpertCuratedItemState["PUBLISHED"] = "PUBLISHED";
  SavedExpertCuratedItemState["ARCHIVED"] = "ARCHIVED";
})(SavedExpertCuratedItemState || (SavedExpertCuratedItemState = {}));

var SavedSellableReason;

(function (SavedSellableReason) {
  SavedSellableReason["PRICE"] = "PRICE";
  SavedSellableReason["STYLE"] = "STYLE";
  SavedSellableReason["HIGH_QUALITY"] = "HIGH_QUALITY";
  SavedSellableReason["BRAND"] = "BRAND";
  SavedSellableReason["FEATURES"] = "FEATURES";
})(SavedSellableReason || (SavedSellableReason = {}));

var ScheduledPaymentState;

(function (ScheduledPaymentState) {
  ScheduledPaymentState["SCHEDULED"] = "SCHEDULED";
  ScheduledPaymentState["EXECUTED"] = "EXECUTED";
  ScheduledPaymentState["CANCELED"] = "CANCELED";
})(ScheduledPaymentState || (ScheduledPaymentState = {}));

var SchedulingUserRole;

(function (SchedulingUserRole) {
  SchedulingUserRole["EXPERT"] = "EXPERT";
  SchedulingUserRole["ON_CALL_EXPERT"] = "ON_CALL_EXPERT";
  SchedulingUserRole["CHARTER_EXPERT"] = "CHARTER_EXPERT";
  SchedulingUserRole["ENTRY_EXPERT"] = "ENTRY_EXPERT";
})(SchedulingUserRole || (SchedulingUserRole = {}));

var ScrapingJobType;

(function (ScrapingJobType) {
  ScrapingJobType["SCRAPINGHUB"] = "SCRAPINGHUB";
})(ScrapingJobType || (ScrapingJobType = {}));

var ScrapingSellablePriceSourceSpider;

(function (ScrapingSellablePriceSourceSpider) {
  ScrapingSellablePriceSourceSpider["EVO"] = "EVO";
  ScrapingSellablePriceSourceSpider["PROGOLFYAKIMA"] = "PROGOLFYAKIMA";
  ScrapingSellablePriceSourceSpider["JENSONUSA"] = "JENSONUSA";
  ScrapingSellablePriceSourceSpider["BIKEBLING"] = "BIKEBLING";
  ScrapingSellablePriceSourceSpider["CHAINREACTIONCYCLES"] = "CHAINREACTIONCYCLES";
  ScrapingSellablePriceSourceSpider["CAMBRIABIKE"] = "CAMBRIABIKE";
})(ScrapingSellablePriceSourceSpider || (ScrapingSellablePriceSourceSpider = {}));

var SearchFilterFieldAttributeSchemaMetadataSearchFilterEntity;

(function (SearchFilterFieldAttributeSchemaMetadataSearchFilterEntity) {
  SearchFilterFieldAttributeSchemaMetadataSearchFilterEntity["LEAD"] = "LEAD";
})(SearchFilterFieldAttributeSchemaMetadataSearchFilterEntity || (SearchFilterFieldAttributeSchemaMetadataSearchFilterEntity = {}));

var SellableAttributePromotionRuleReferenceComparison;

(function (SellableAttributePromotionRuleReferenceComparison) {
  SellableAttributePromotionRuleReferenceComparison["EQUAL"] = "EQUAL";
  SellableAttributePromotionRuleReferenceComparison["NOT_EQUAL"] = "NOT_EQUAL";
})(SellableAttributePromotionRuleReferenceComparison || (SellableAttributePromotionRuleReferenceComparison = {}));

var SellableBadge;

(function (SellableBadge) {
  /** Used for items in our warehouse to indicate gurantees on delivery estimates. */
  SellableBadge["SHIPPED_BY_CURATED"] = "SHIPPED_BY_CURATED";
  /** Used for items drop-shipped by manufacturer */

  SellableBadge["SHIPPED_BY_MANUFACTURER"] = "SHIPPED_BY_MANUFACTURER";
  /** Used for items shipped by a retail partner */

  SellableBadge["SHIPPED_BY_PARTNER"] = "SHIPPED_BY_PARTNER";
  /** Used for items whose Sale price is manually overridden and is lower than any of the known price sources */

  SellableBadge["SECRET_DEAL"] = "SECRET_DEAL";
})(SellableBadge || (SellableBadge = {}));

var SellableCategoryFilterPromotionRuleReferenceTraversalOption;

(function (SellableCategoryFilterPromotionRuleReferenceTraversalOption) {
  SellableCategoryFilterPromotionRuleReferenceTraversalOption["INCLUDE_PARENTS"] = "INCLUDE_PARENTS";
  SellableCategoryFilterPromotionRuleReferenceTraversalOption["INCLUDE_CHILDREN"] = "INCLUDE_CHILDREN";
})(SellableCategoryFilterPromotionRuleReferenceTraversalOption || (SellableCategoryFilterPromotionRuleReferenceTraversalOption = {}));

var SellableCustomOfferRuleType;

(function (SellableCustomOfferRuleType) {
  SellableCustomOfferRuleType["PRICE_MATCH"] = "PRICE_MATCH";
  SellableCustomOfferRuleType["CUSTOM_ITEM"] = "CUSTOM_ITEM";
})(SellableCustomOfferRuleType || (SellableCustomOfferRuleType = {}));

var SellableExpertCuratedItemNoteStatsSort;

(function (SellableExpertCuratedItemNoteStatsSort) {
  /** Number of approved review */
  SellableExpertCuratedItemNoteStatsSort["APPROVED_COUNT"] = "APPROVED_COUNT";
  /** Number of pending review */

  SellableExpertCuratedItemNoteStatsSort["PENDING_COUNT"] = "PENDING_COUNT";
  /** Number of rejected review */

  SellableExpertCuratedItemNoteStatsSort["REJECTED_COUNT"] = "REJECTED_COUNT";
  /** Of PDP page views in last week */

  SellableExpertCuratedItemNoteStatsSort["PRODUCT_VIEWS"] = "PRODUCT_VIEWS";
  /** of times parent sellable has been recommended */

  SellableExpertCuratedItemNoteStatsSort["TIMES_RECOMMENDED"] = "TIMES_RECOMMENDED";
})(SellableExpertCuratedItemNoteStatsSort || (SellableExpertCuratedItemNoteStatsSort = {}));

var SellablePriceSourceType;

(function (SellablePriceSourceType) {
  SellablePriceSourceType["DEAL"] = "DEAL";
  SellablePriceSourceType["AMAZON"] = "AMAZON";
  SellablePriceSourceType["EBAY"] = "EBAY";
  SellablePriceSourceType["SCRAPING"] = "SCRAPING";
  SellablePriceSourceType["YADAV"] = "YADAV";
  SellablePriceSourceType["RAW_SELLABLE_SCRAPER"] = "RAW_SELLABLE_SCRAPER";
  SellablePriceSourceType["RAW_SELLABLE_FEED"] = "RAW_SELLABLE_FEED";
  SellablePriceSourceType["RAW_SELLABLE_GOOGLE_PRODUCT"] = "RAW_SELLABLE_GOOGLE_PRODUCT";
  SellablePriceSourceType["RAW_SELLABLE_SHOPIFY"] = "RAW_SELLABLE_SHOPIFY";
  SellablePriceSourceType["RAW_SELLABLE_WALMART"] = "RAW_SELLABLE_WALMART";
  SellablePriceSourceType["RAW_SELLABLE_IMPACT"] = "RAW_SELLABLE_IMPACT";
  SellablePriceSourceType["RAW_SELLABLE_FROMUTH"] = "RAW_SELLABLE_FROMUTH";
  SellablePriceSourceType["DEAL_INVENTORY"] = "DEAL_INVENTORY";
  SellablePriceSourceType["GOOGLE_SHOPPING"] = "GOOGLE_SHOPPING";
})(SellablePriceSourceType || (SellablePriceSourceType = {}));

var SellableQuestionCandidateState;

(function (SellableQuestionCandidateState) {
  SellableQuestionCandidateState["PENDING"] = "PENDING";
  SellableQuestionCandidateState["REJECTED"] = "REJECTED";
  SellableQuestionCandidateState["APPROVED"] = "APPROVED";
})(SellableQuestionCandidateState || (SellableQuestionCandidateState = {}));

var SellableQuestionState;

(function (SellableQuestionState) {
  SellableQuestionState["ACTIVE"] = "ACTIVE";
  SellableQuestionState["INACTIVE"] = "INACTIVE";
})(SellableQuestionState || (SellableQuestionState = {}));

var SellableSearchFacetsQueryFilter;

(function (SellableSearchFacetsQueryFilter) {
  /**
   * Returns facets that have attributes that are marked as PRIMARY in the specific category.
   * In case there are multiple PRIMARY attributes in a Category, it returns the first one after category specific
   * custom sorting, to provide deterministic behavior.
   */
  SellableSearchFacetsQueryFilter["FIRST_PRIMARY_ATTRIBUTE_ONLY"] = "FIRST_PRIMARY_ATTRIBUTE_ONLY";
  /** All facets with PRIMARY attributes are returned, ordered by category specific sorting. */

  SellableSearchFacetsQueryFilter["ALL_PRIMARY_ATTRIBUTES"] = "ALL_PRIMARY_ATTRIBUTES";
  /**
   * Returns facets that have attributes that are marked as SECONDARY in the specific category.
   * In case there are multiple SECONDARY attributes in a Category, it returns the first one after category specific
   * custom sorting, to provide deterministic behavior.
   */

  SellableSearchFacetsQueryFilter["FIRST_SECONDARY_ATTRIBUTE_ONLY"] = "FIRST_SECONDARY_ATTRIBUTE_ONLY";
  /** All facets with SECONDARY attributes are returned, ordered by category specific sorting. */

  SellableSearchFacetsQueryFilter["ALL_SECONDARY_ATTRIBUTES"] = "ALL_SECONDARY_ATTRIBUTES";
  /** Returns brand facets for the specific category */

  SellableSearchFacetsQueryFilter["INCLUDE_BRANDS"] = "INCLUDE_BRANDS";
  /** Excludes out of stock sellables while building the facets */

  SellableSearchFacetsQueryFilter["EXCLUDE_OUT_OF_STOCK"] = "EXCLUDE_OUT_OF_STOCK";
  /** Include gender facet */

  SellableSearchFacetsQueryFilter["INCLUDE_GENDER"] = "INCLUDE_GENDER";
  /** Include Sale price facet as a range */

  SellableSearchFacetsQueryFilter["INCLUDE_SALE_PRICE_RANGE"] = "INCLUDE_SALE_PRICE_RANGE";
  /** Only includes sellables that have discounts */

  SellableSearchFacetsQueryFilter["INCLUDE_DISCOUNTED_ONLY"] = "INCLUDE_DISCOUNTED_ONLY";
})(SellableSearchFacetsQueryFilter || (SellableSearchFacetsQueryFilter = {}));

var SellableSearchFilter;

(function (SellableSearchFilter) {
  /**
   * Returns sellables that have discounts only
   * In addition if the sorting is by relevancy, it boosts the sellables that have their price updated recently
   * higher in the result set.
   */
  SellableSearchFilter["DISCOUNTED"] = "DISCOUNTED";
  /** Exclude out of stock sellables */

  SellableSearchFilter["EXCLUDE_OUT_OF_STOCK"] = "EXCLUDE_OUT_OF_STOCK";
  /** Include only pre-orders in the search result. */

  SellableSearchFilter["PRE_ORDER_ONLY"] = "PRE_ORDER_ONLY";
  /** Dual state to include both in stock items and pre-orders */

  SellableSearchFilter["INCLUDE_IN_STOCK_OR_PRE_ORDER"] = "INCLUDE_IN_STOCK_OR_PRE_ORDER";
  /** Only show sellables that are in stock in Deal warehouse */

  SellableSearchFilter["SHIPPED_BY_CURATED"] = "SHIPPED_BY_CURATED";
  /** Only show sellables that are drop-shipped by manufacturer */

  SellableSearchFilter["SHIPPED_BY_MANUFACTURER"] = "SHIPPED_BY_MANUFACTURER";
  /**
   * Only show sellables with a deal.
   * A sellable is considered to have a Secret deal if its salePriceOverride is lower than the salePrice of all known sources
   */

  SellableSearchFilter["SECRET_DEAL"] = "SECRET_DEAL";
})(SellableSearchFilter || (SellableSearchFilter = {}));
/** Sellable Search Page Module Types */


var SellableSearchPageModuleType;

(function (SellableSearchPageModuleType) {
  SellableSearchPageModuleType["TOP_LIST"] = "TOP_LIST";
  SellableSearchPageModuleType["ARTICLE"] = "ARTICLE";
  SellableSearchPageModuleType["CONVERSATION_STARTER"] = "CONVERSATION_STARTER";
})(SellableSearchPageModuleType || (SellableSearchPageModuleType = {}));

var SellableSearchPageRelatedLinksType;

(function (SellableSearchPageRelatedLinksType) {
  SellableSearchPageRelatedLinksType["DOWNWARDS_SEARCH"] = "DOWNWARDS_SEARCH";
  SellableSearchPageRelatedLinksType["SIDEWAYS_SEARCH"] = "SIDEWAYS_SEARCH";
  SellableSearchPageRelatedLinksType["BRAND_SEARCH"] = "BRAND_SEARCH";
  SellableSearchPageRelatedLinksType["ARTICLE"] = "ARTICLE";
  SellableSearchPageRelatedLinksType["TOP_LIST"] = "TOP_LIST";
})(SellableSearchPageRelatedLinksType || (SellableSearchPageRelatedLinksType = {}));

var SellableSearchUseCase;

(function (SellableSearchUseCase) {
  SellableSearchUseCase["CONSUMER_SEARCH"] = "CONSUMER_SEARCH";
  SellableSearchUseCase["EXPERT_SEARCH"] = "EXPERT_SEARCH";
  SellableSearchUseCase["IMPERSONATE_CONSUMER"] = "IMPERSONATE_CONSUMER";
  SellableSearchUseCase["OPS_SEARCH"] = "OPS_SEARCH";
  /** This use case for consumer does not take the user intent into account and is basically a simple brand search query */

  SellableSearchUseCase["CONSUMER_HOME_PAGE_BY_BRANDS"] = "CONSUMER_HOME_PAGE_BY_BRANDS";
})(SellableSearchUseCase || (SellableSearchUseCase = {}));

var SellableServiceLocationDisplayType;

(function (SellableServiceLocationDisplayType) {
  SellableServiceLocationDisplayType["CITY_STATE"] = "CITY_STATE";
})(SellableServiceLocationDisplayType || (SellableServiceLocationDisplayType = {}));

var SellableSort;

(function (SellableSort) {
  /** Average sale price is calculated as (min + max)/2 for all variations */
  SellableSort["AVG_SALE_PRICE"] = "AVG_SALE_PRICE";
  /** Best offer price is our secret deal price and should only be shown to the experts. */

  SellableSort["BEST_OFFER_PRICE"] = "BEST_OFFER_PRICE";
  /** Savings = actual price - sale price */

  SellableSort["MAX_PRICE_SAVINGS"] = "MAX_PRICE_SAVINGS";
  /** Percent savings = (actual price - sale price)/actual price */

  SellableSort["MAX_PRICE_PERCENT_SAVINGS"] = "MAX_PRICE_PERCENT_SAVINGS";
  /** Defined as the unique page views in the last 7 days */

  SellableSort["POPULARITY"] = "POPULARITY";
  /** Defined as the number of purchases in the last 30 days */

  SellableSort["BEST_SELLER"] = "BEST_SELLER";
  /** Relevance score computed from sellables that match users intent */

  SellableSort["RELEVANCE"] = "RELEVANCE";
  /** sort by times recommended by expert */

  SellableSort["MOST_RECOMMENDED_BY_EXPERTS"] = "MOST_RECOMMENDED_BY_EXPERTS";
  /** This is the fastest way to get results if ordering is not important */

  SellableSort["INDEX_ORDER"] = "INDEX_ORDER";
  /** An stable way to paginate across all indexed documents */

  SellableSort["DOC_ID_ORDER"] = "DOC_ID_ORDER";
})(SellableSort || (SellableSort = {}));

var SellableSourceExternalIdType;

(function (SellableSourceExternalIdType) {
  SellableSourceExternalIdType["YADAV_DIAMOND"] = "YADAV_DIAMOND";
  SellableSourceExternalIdType["YADAV_SETTING"] = "YADAV_SETTING";
})(SellableSourceExternalIdType || (SellableSourceExternalIdType = {}));

var SellableSourceType;

(function (SellableSourceType) {
  SellableSourceType["URL"] = "URL";
  SellableSourceType["EXTERNAL_ID"] = "EXTERNAL_ID";
  SellableSourceType["STANDARDIZED_SELLABLE_GROUP"] = "STANDARDIZED_SELLABLE_GROUP";
  SellableSourceType["PRODUCT_CATALOG"] = "PRODUCT_CATALOG";
  SellableSourceType["PRODUCT_CATALOG_GROUP"] = "PRODUCT_CATALOG_GROUP";
})(SellableSourceType || (SellableSourceType = {}));

var SellableTopListDefinitionSort;

(function (SellableTopListDefinitionSort) {
  SellableTopListDefinitionSort["TITLE"] = "TITLE";
  SellableTopListDefinitionSort["CREATED_AT"] = "CREATED_AT";
  SellableTopListDefinitionSort["UPDATED_AT"] = "UPDATED_AT";
  SellableTopListDefinitionSort["PUBLISHED_AT"] = "PUBLISHED_AT";
})(SellableTopListDefinitionSort || (SellableTopListDefinitionSort = {}));

var SellableTopListState;

(function (SellableTopListState) {
  SellableTopListState["DRAFT"] = "DRAFT";
  SellableTopListState["PUBLISHED"] = "PUBLISHED";
  SellableTopListState["ARCHIVED"] = "ARCHIVED";
})(SellableTopListState || (SellableTopListState = {}));

var SellableType;

(function (SellableType) {
  SellableType["PRODUCT"] = "PRODUCT";
  SellableType["SERVICE"] = "SERVICE";
})(SellableType || (SellableType = {}));

var ShiftAssignmentMode;

(function (ShiftAssignmentMode) {
  ShiftAssignmentMode["CLAIM"] = "CLAIM";
  ShiftAssignmentMode["RESERVE"] = "RESERVE";
  ShiftAssignmentMode["DRY_RUN"] = "DRY_RUN";
  ShiftAssignmentMode["NONE"] = "NONE";
})(ShiftAssignmentMode || (ShiftAssignmentMode = {}));

var ShiftAttendanceStatus;

(function (ShiftAttendanceStatus) {
  ShiftAttendanceStatus["NOT_APPLICABLE"] = "NOT_APPLICABLE";
  ShiftAttendanceStatus["PRESENT"] = "PRESENT";
  ShiftAttendanceStatus["STARTED_LATE"] = "STARTED_LATE";
  ShiftAttendanceStatus["ENDED_EARLY"] = "ENDED_EARLY";
  ShiftAttendanceStatus["ABSENT"] = "ABSENT";
  ShiftAttendanceStatus["EXCUSED"] = "EXCUSED";
})(ShiftAttendanceStatus || (ShiftAttendanceStatus = {}));

var ShiftChangeRequestType;

(function (ShiftChangeRequestType) {
  ShiftChangeRequestType["GIVE_UP"] = "GIVE_UP";
  ShiftChangeRequestType["SWAP"] = "SWAP";
})(ShiftChangeRequestType || (ShiftChangeRequestType = {}));

var ShiftGiveUpReason;

(function (ShiftGiveUpReason) {
  ShiftGiveUpReason["PICK_ANOTHER_SHIFT"] = "PICK_ANOTHER_SHIFT";
  ShiftGiveUpReason["SICK"] = "SICK";
  ShiftGiveUpReason["EMERGENCY"] = "EMERGENCY";
  ShiftGiveUpReason["OTHER"] = "OTHER";
})(ShiftGiveUpReason || (ShiftGiveUpReason = {}));

var ShiftProbationFilterType;

(function (ShiftProbationFilterType) {
  ShiftProbationFilterType["CURRENT"] = "CURRENT";
  ShiftProbationFilterType["PENDING"] = "PENDING";
})(ShiftProbationFilterType || (ShiftProbationFilterType = {}));

var ShiftSlotState;

(function (ShiftSlotState) {
  ShiftSlotState["SHIFTS_PROPOSED"] = "SHIFTS_PROPOSED";
  ShiftSlotState["SHIFTS_RESERVED"] = "SHIFTS_RESERVED";
  ShiftSlotState["SHIFTS_OPEN"] = "SHIFTS_OPEN";
})(ShiftSlotState || (ShiftSlotState = {}));

var ShipmentPricingTierType;

(function (ShipmentPricingTierType) {
  ShipmentPricingTierType["WAREHOUSE"] = "WAREHOUSE";
  ShipmentPricingTierType["TIER_ONE_PARTNER"] = "TIER_ONE_PARTNER";
  ShipmentPricingTierType["TIER_TWO_PARTNER"] = "TIER_TWO_PARTNER";
})(ShipmentPricingTierType || (ShipmentPricingTierType = {}));

var ShippingGroupStrategy;

(function (ShippingGroupStrategy) {
  ShippingGroupStrategy["FEWEST_PACKAGES"] = "FEWEST_PACKAGES";
  ShippingGroupStrategy["LEGACY"] = "LEGACY";
})(ShippingGroupStrategy || (ShippingGroupStrategy = {}));

var ShippingMethod;

(function (ShippingMethod) {
  /** Standard ground (default) */
  ShippingMethod["STANDARD"] = "STANDARD";
  /** Expedited shipping */

  ShippingMethod["EXPEDITED"] = "EXPEDITED";
})(ShippingMethod || (ShippingMethod = {}));

var ShippingPolicy;

(function (ShippingPolicy) {
  ShippingPolicy["NO_SHIPPING"] = "NO_SHIPPING";
  ShippingPolicy["FREE_SHIPPING"] = "FREE_SHIPPING";
  ShippingPolicy["PAID_BY_CUSTOMER"] = "PAID_BY_CUSTOMER";
})(ShippingPolicy || (ShippingPolicy = {}));

var ShippingStatus;

(function (ShippingStatus) {
  ShippingStatus["UNKNOWN"] = "UNKNOWN";
  ShippingStatus["IN_TRANSIT"] = "IN_TRANSIT";
  ShippingStatus["DELIVERED"] = "DELIVERED";
  ShippingStatus["FAILURE"] = "FAILURE";
  ShippingStatus["RETURNED"] = "RETURNED";
})(ShippingStatus || (ShippingStatus = {}));

var SimpleCuratedOrderType;

(function (SimpleCuratedOrderType) {
  SimpleCuratedOrderType["EXPERT_CONSULTATION_FEE"] = "EXPERT_CONSULTATION_FEE";
  SimpleCuratedOrderType["GIFT_CARD"] = "GIFT_CARD";
  SimpleCuratedOrderType["CURATED_INSIDERS_MEMBERSHIP"] = "CURATED_INSIDERS_MEMBERSHIP";
})(SimpleCuratedOrderType || (SimpleCuratedOrderType = {}));

var SocialMediaType;

(function (SocialMediaType) {
  SocialMediaType["FACEBOOK"] = "FACEBOOK";
  SocialMediaType["TWITTER"] = "TWITTER";
  SocialMediaType["LINKEDIN"] = "LINKEDIN";
  SocialMediaType["INSTAGRAM"] = "INSTAGRAM";
  SocialMediaType["PINTEREST"] = "PINTEREST";
  SocialMediaType["YOUTUBE"] = "YOUTUBE";
  SocialMediaType["STRAVA"] = "STRAVA";
})(SocialMediaType || (SocialMediaType = {}));
/** Common ordering context, each query should define its specific sortable fields as enums. */


var SortOrder;

(function (SortOrder) {
  SortOrder["ASC"] = "ASC";
  SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));

var StandardizedSellableGroupCandidateState;

(function (StandardizedSellableGroupCandidateState) {
  StandardizedSellableGroupCandidateState["PENDING"] = "PENDING";
  StandardizedSellableGroupCandidateState["ACCEPTED"] = "ACCEPTED";
  StandardizedSellableGroupCandidateState["REJECTED"] = "REJECTED";
})(StandardizedSellableGroupCandidateState || (StandardizedSellableGroupCandidateState = {}));

var StandardizedSellableGroupState;

(function (StandardizedSellableGroupState) {
  StandardizedSellableGroupState["ACTIVE"] = "ACTIVE";
  StandardizedSellableGroupState["INACTIVE"] = "INACTIVE";
})(StandardizedSellableGroupState || (StandardizedSellableGroupState = {}));

var StandardizedSellableState;

(function (StandardizedSellableState) {
  StandardizedSellableState["ACTIVE"] = "ACTIVE";
  StandardizedSellableState["INACTIVE"] = "INACTIVE";
})(StandardizedSellableState || (StandardizedSellableState = {}));

var StringBinaryConditionDefinitionOperator;

(function (StringBinaryConditionDefinitionOperator) {
  StringBinaryConditionDefinitionOperator["IN"] = "IN";
  StringBinaryConditionDefinitionOperator["NOT_IN"] = "NOT_IN";
  StringBinaryConditionDefinitionOperator["EXISTS"] = "EXISTS";
  StringBinaryConditionDefinitionOperator["NOT_EXISTS"] = "NOT_EXISTS";
})(StringBinaryConditionDefinitionOperator || (StringBinaryConditionDefinitionOperator = {}));

var StringFieldType;

(function (StringFieldType) {
  StringFieldType["EMAIL_ADDRESS"] = "EMAIL_ADDRESS";
  StringFieldType["SMS_NUMBER"] = "SMS_NUMBER";
  StringFieldType["DURATION"] = "DURATION";
  StringFieldType["JSON"] = "JSON";
  StringFieldType["STRING_ID"] = "STRING_ID";
})(StringFieldType || (StringFieldType = {}));

var StripeAuthenticationFlow;

(function (StripeAuthenticationFlow) {
  StripeAuthenticationFlow["REDIRECT"] = "redirect";
  StripeAuthenticationFlow["RECEIVER"] = "receiver";
  StripeAuthenticationFlow["CODE_VERIFICATION"] = "code_verification";
  StripeAuthenticationFlow["NONE"] = "none";
})(StripeAuthenticationFlow || (StripeAuthenticationFlow = {}));

var StripeCodeVerificationStatus;

(function (StripeCodeVerificationStatus) {
  StripeCodeVerificationStatus["PENDING"] = "pending";
  StripeCodeVerificationStatus["AWAITING_VERIFICATION"] = "awaiting_verification";
  StripeCodeVerificationStatus["SUCCEEDED"] = "succeeded";
  StripeCodeVerificationStatus["FAILED"] = "failed";
})(StripeCodeVerificationStatus || (StripeCodeVerificationStatus = {}));

var SuggestedActionContext;

(function (SuggestedActionContext) {
  SuggestedActionContext["CONSUMER_STARTED_CHECKOUT"] = "CONSUMER_STARTED_CHECKOUT";
  SuggestedActionContext["CONSUMER_COMPLETED_CHECKOUT"] = "CONSUMER_COMPLETED_CHECKOUT";
  SuggestedActionContext["CONSUMER_VIEWED_CURATION"] = "CONSUMER_VIEWED_CURATION";
  SuggestedActionContext["CONSUMER_ADDED_TO_CART"] = "CONSUMER_ADDED_TO_CART";
  SuggestedActionContext["CONSUMER_VIEWED_SELLABLE"] = "CONSUMER_VIEWED_SELLABLE";
  SuggestedActionContext["CONSUMER_BACK_ONSITE"] = "CONSUMER_BACK_ONSITE";
  SuggestedActionContext["STALE_CONVERSATION"] = "STALE_CONVERSATION";
})(SuggestedActionContext || (SuggestedActionContext = {}));

var SuggestedActionType;

(function (SuggestedActionType) {
  SuggestedActionType["SEND_INITIAL_RESPONSE"] = "SEND_INITIAL_RESPONSE";
  SuggestedActionType["RESPOND_TO_NEW_MESSAGE"] = "RESPOND_TO_NEW_MESSAGE";
  SuggestedActionType["FOLLOW_UP"] = "FOLLOW_UP";
  SuggestedActionType["CALL"] = "CALL";
  SuggestedActionType["SNOOZE"] = "SNOOZE";
  SuggestedActionType["STAR"] = "STAR";
  SuggestedActionType["ARCHIVE"] = "ARCHIVE";
  SuggestedActionType["REQUEST_EXPERT_REVIEW"] = "REQUEST_EXPERT_REVIEW";
  SuggestedActionType["REQUEST_EXPERT_REFERRAL"] = "REQUEST_EXPERT_REFERRAL";
  SuggestedActionType["SEND_CURATION"] = "SEND_CURATION";
  SuggestedActionType["CLASSIFY_ARCHIVED_LEAD"] = "CLASSIFY_ARCHIVED_LEAD";
  SuggestedActionType["REVIEW_SURVEY"] = "REVIEW_SURVEY";
  SuggestedActionType["FULFILL_PROMISE"] = "FULFILL_PROMISE";
  SuggestedActionType["CURATION_VIEWED_FOLLOW_UP"] = "CURATION_VIEWED_FOLLOW_UP";
  SuggestedActionType["SELLABLE_VIEWED_FOLLOW_UP"] = "SELLABLE_VIEWED_FOLLOW_UP";
  SuggestedActionType["PRODUCT_ADDED_TO_CART_FOLLOW_UP"] = "PRODUCT_ADDED_TO_CART_FOLLOW_UP";
  SuggestedActionType["ORDER_CHANGE"] = "ORDER_CHANGE";
  SuggestedActionType["ORDER_CANCELLATION"] = "ORDER_CANCELLATION";
  SuggestedActionType["ORDER_RETURN"] = "ORDER_RETURN";
  SuggestedActionType["ORDER_EXCHANGE"] = "ORDER_EXCHANGE";
  SuggestedActionType["ORDER_ITEM_UNAVAILABLE"] = "ORDER_ITEM_UNAVAILABLE";
  SuggestedActionType["VIEW_TICKET_UPDATE"] = "VIEW_TICKET_UPDATE";
})(SuggestedActionType || (SuggestedActionType = {}));

var SuggestedIndividualExpertCuratedItemProConTypeaheadSort;

(function (SuggestedIndividualExpertCuratedItemProConTypeaheadSort) {
  SuggestedIndividualExpertCuratedItemProConTypeaheadSort["PROS_FIRST"] = "PROS_FIRST";
  SuggestedIndividualExpertCuratedItemProConTypeaheadSort["CONS_FIRST"] = "CONS_FIRST";
})(SuggestedIndividualExpertCuratedItemProConTypeaheadSort || (SuggestedIndividualExpertCuratedItemProConTypeaheadSort = {}));

var SuggestedSellableFilter;

(function (SuggestedSellableFilter) {
  /** Whether to exclude out of stock sellables */
  SuggestedSellableFilter["EXCLUDE_OUT_OF_STOCK"] = "EXCLUDE_OUT_OF_STOCK";
  /** Dual state to include both in stock items and pre-orders */

  SuggestedSellableFilter["INCLUDE_IN_STOCK_OR_PRE_ORDER"] = "INCLUDE_IN_STOCK_OR_PRE_ORDER";
  /** Include only pre-orders in the search result. */

  SuggestedSellableFilter["PRE_ORDER_ONLY"] = "PRE_ORDER_ONLY";
  /** Only show sellables that are in stock in Deal warehouse */

  SuggestedSellableFilter["SHIPPED_BY_CURATED"] = "SHIPPED_BY_CURATED";
  /** Only show sellables that are drop-shipped by manufacturer */

  SuggestedSellableFilter["SHIPPED_BY_MANUFACTURER"] = "SHIPPED_BY_MANUFACTURER";
  /**
   * Only show sellables with a deal, a sellable is considered to have a Secret deal if its salePriceOverride is
   * lower than the salePrice of all known sources
   */

  SuggestedSellableFilter["SECRET_DEAL"] = "SECRET_DEAL";
})(SuggestedSellableFilter || (SuggestedSellableFilter = {}));

var SuggestedSellableReviewAnswer;

(function (SuggestedSellableReviewAnswer) {
  SuggestedSellableReviewAnswer["YES"] = "YES";
  SuggestedSellableReviewAnswer["NOT_SURE"] = "NOT_SURE";
  SuggestedSellableReviewAnswer["NO"] = "NO";
})(SuggestedSellableReviewAnswer || (SuggestedSellableReviewAnswer = {}));

var SuggestedSupportAction;

(function (SuggestedSupportAction) {
  SuggestedSupportAction["SUPPORT_RESPONSE_NEEDED"] = "SUPPORT_RESPONSE_NEEDED";
})(SuggestedSupportAction || (SuggestedSupportAction = {}));

var SuggestExpertCuratedItemNotesSort;

(function (SuggestExpertCuratedItemNotesSort) {
  /** Sort by purchase rate, usage count, note length */
  SuggestExpertCuratedItemNotesSort["DEFAULT"] = "DEFAULT";
  /** Sort by usage count, note length */

  SuggestExpertCuratedItemNotesSort["USAGES"] = "USAGES";
  /** Sort by featured, usage count */

  SuggestExpertCuratedItemNotesSort["FEATURED"] = "FEATURED";
})(SuggestExpertCuratedItemNotesSort || (SuggestExpertCuratedItemNotesSort = {}));

var SupportTaskAction;

(function (SupportTaskAction) {
  SupportTaskAction["CREATE_TASK"] = "CREATE_TASK";
  SupportTaskAction["ASSIGN"] = "ASSIGN";
  SupportTaskAction["UNASSIGN"] = "UNASSIGN";
  SupportTaskAction["DISMISS"] = "DISMISS";
  SupportTaskAction["DELEGATE_LEAD"] = "DELEGATE_LEAD";
  SupportTaskAction["REASSIGN_LEAD"] = "REASSIGN_LEAD";
  SupportTaskAction["SUGGEST_LEAD_ACTIONS"] = "SUGGEST_LEAD_ACTIONS";
  SupportTaskAction["ESCALATE_LEAD_FOR_DELEGATION"] = "ESCALATE_LEAD_FOR_DELEGATION";
  SupportTaskAction["ESCALATE_LEAD_FOR_REASSIGNMENT"] = "ESCALATE_LEAD_FOR_REASSIGNMENT";
  SupportTaskAction["REQUEST_ORDER_SUPPORT_FOR_LEAD"] = "REQUEST_ORDER_SUPPORT_FOR_LEAD";
  SupportTaskAction["SNOOZE"] = "SNOOZE";
  SupportTaskAction["UNSNOOZE"] = "UNSNOOZE";
  SupportTaskAction["SPAM_RISK"] = "SPAM_RISK";
})(SupportTaskAction || (SupportTaskAction = {}));

var SupportTaskListEventType;

(function (SupportTaskListEventType) {
  SupportTaskListEventType["ADD"] = "ADD";
  SupportTaskListEventType["REMOVE"] = "REMOVE";
})(SupportTaskListEventType || (SupportTaskListEventType = {}));

var SupportTaskState;

(function (SupportTaskState) {
  SupportTaskState["PENDING"] = "PENDING";
  SupportTaskState["ASSIGNED"] = "ASSIGNED";
  SupportTaskState["COMPLETED"] = "COMPLETED";
})(SupportTaskState || (SupportTaskState = {}));

var SupportTaskType;

(function (SupportTaskType) {
  SupportTaskType["LEAD"] = "LEAD";
  SupportTaskType["ORDER"] = "ORDER";
})(SupportTaskType || (SupportTaskType = {}));

var SystemCuratedConsumerSellableReactionRating;

(function (SystemCuratedConsumerSellableReactionRating) {
  SystemCuratedConsumerSellableReactionRating["SKIP"] = "SKIP";
  SystemCuratedConsumerSellableReactionRating["DISLIKE"] = "DISLIKE";
  SystemCuratedConsumerSellableReactionRating["LIKE"] = "LIKE";
  SystemCuratedConsumerSellableReactionRating["LOVE"] = "LOVE";
})(SystemCuratedConsumerSellableReactionRating || (SystemCuratedConsumerSellableReactionRating = {}));

var SystemCuratedItemSurveyTerminationReason;

(function (SystemCuratedItemSurveyTerminationReason) {
  SystemCuratedItemSurveyTerminationReason["SKIPPED"] = "SKIPPED";
  SystemCuratedItemSurveyTerminationReason["TERMINATED_EARLY"] = "TERMINATED_EARLY";
  SystemCuratedItemSurveyTerminationReason["REVIEWED_ALL"] = "REVIEWED_ALL";
})(SystemCuratedItemSurveyTerminationReason || (SystemCuratedItemSurveyTerminationReason = {}));

var SystemCuratedItemType;

(function (SystemCuratedItemType) {
  SystemCuratedItemType["EXPERT_CURATED_ITEMS_FROM_SIMILAR_USER"] = "EXPERT_CURATED_ITEMS_FROM_SIMILAR_USER";
  SystemCuratedItemType["EXPERT_CURATED_ITEMS_FROM_SIMILAR_USER_RANKED_BY_TIMES_RECOMMENDED"] = "EXPERT_CURATED_ITEMS_FROM_SIMILAR_USER_RANKED_BY_TIMES_RECOMMENDED";
  SystemCuratedItemType["TOP_RECOMMENDATIONS_BASED_ON_DEAL_REQUEST"] = "TOP_RECOMMENDATIONS_BASED_ON_DEAL_REQUEST";
  SystemCuratedItemType["SIMILAR_USER_AND_TOP_RECOMMENDATIONS_GLOBALLY_RANKED"] = "SIMILAR_USER_AND_TOP_RECOMMENDATIONS_GLOBALLY_RANKED";
})(SystemCuratedItemType || (SystemCuratedItemType = {}));

var TagType;

(function (TagType) {
  TagType["BROADCAST_LEAD_QUALITY"] = "BROADCAST_LEAD_QUALITY";
  TagType["BROADCAST_CONVERSION_STRATEGY"] = "BROADCAST_CONVERSION_STRATEGY";
  TagType["BROADCAST_TRUST_STRATEGY"] = "BROADCAST_TRUST_STRATEGY";
  TagType["REMINDER_TASK_TYPE"] = "REMINDER_TASK_TYPE";
})(TagType || (TagType = {}));

var TemplateDataModelType;

(function (TemplateDataModelType) {
  TemplateDataModelType["DATA_OBJECT"] = "DATA_OBJECT";
  TemplateDataModelType["CUSTOM_QUERY"] = "CUSTOM_QUERY";
  TemplateDataModelType["NAMED_QUERIES"] = "NAMED_QUERIES";
})(TemplateDataModelType || (TemplateDataModelType = {}));

var TemplateFragmentParameterType;

(function (TemplateFragmentParameterType) {
  TemplateFragmentParameterType["TEXT"] = "TEXT";
  TemplateFragmentParameterType["BOOLEAN"] = "BOOLEAN";
  TemplateFragmentParameterType["OBJECT"] = "OBJECT";
  TemplateFragmentParameterType["IMAGE_URL"] = "IMAGE_URL";
  TemplateFragmentParameterType["ACTION_URL"] = "ACTION_URL";
  TemplateFragmentParameterType["ENUMERATION"] = "ENUMERATION";
})(TemplateFragmentParameterType || (TemplateFragmentParameterType = {}));

var TemplateFragmentType;

(function (TemplateFragmentType) {
  TemplateFragmentType["BLOCK"] = "BLOCK";
  TemplateFragmentType["HEADER"] = "HEADER";
  TemplateFragmentType["FOOTER"] = "FOOTER";
  TemplateFragmentType["BANNER"] = "BANNER";
  TemplateFragmentType["MODULE"] = "MODULE";
  TemplateFragmentType["PAGE_WRAPPER"] = "PAGE_WRAPPER";
  TemplateFragmentType["NONE"] = "NONE";
})(TemplateFragmentType || (TemplateFragmentType = {}));

var TemplateSearchSort;

(function (TemplateSearchSort) {
  TemplateSearchSort["PUBLISHED_AT"] = "PUBLISHED_AT";
  TemplateSearchSort["CREATED_AT"] = "CREATED_AT";
  TemplateSearchSort["TITLE"] = "TITLE";
})(TemplateSearchSort || (TemplateSearchSort = {}));

var TemplateTagSyntax;

(function (TemplateTagSyntax) {
  TemplateTagSyntax["DEFAULT"] = "DEFAULT";
  TemplateTagSyntax["ALTERNATIVE"] = "ALTERNATIVE";
})(TemplateTagSyntax || (TemplateTagSyntax = {}));

var TemplateTypeGroup;

(function (TemplateTypeGroup) {
  TemplateTypeGroup["ONBOARDING"] = "ONBOARDING";
  TemplateTypeGroup["NURTURING"] = "NURTURING";
  TemplateTypeGroup["FEEDBACK"] = "FEEDBACK";
  TemplateTypeGroup["CURATION"] = "CURATION";
  TemplateTypeGroup["EXPERT_ONBOARDING"] = "EXPERT_ONBOARDING";
  TemplateTypeGroup["MESSAGE_ROUTING"] = "MESSAGE_ROUTING";
  TemplateTypeGroup["EXPERT_NOTIFICATION"] = "EXPERT_NOTIFICATION";
  TemplateTypeGroup["POST_PURCHASE"] = "POST_PURCHASE";
  TemplateTypeGroup["CONSUMER_REQUEST"] = "CONSUMER_REQUEST";
  TemplateTypeGroup["CAMPAIGN"] = "CAMPAIGN";
  TemplateTypeGroup["ABANDONED_CART"] = "ABANDONED_CART";
  TemplateTypeGroup["ABANDONED_CHECKOUT"] = "ABANDONED_CHECKOUT";
  TemplateTypeGroup["PATH_DROPOFF"] = "PATH_DROPOFF";
  TemplateTypeGroup["FULFILLMENT"] = "FULFILLMENT";
  TemplateTypeGroup["REFERRAL"] = "REFERRAL";
})(TemplateTypeGroup || (TemplateTypeGroup = {}));

var TextPathEditorRichTextContentPartStyle;

(function (TextPathEditorRichTextContentPartStyle) {
  TextPathEditorRichTextContentPartStyle["IDENTIFIER"] = "IDENTIFIER";
})(TextPathEditorRichTextContentPartStyle || (TextPathEditorRichTextContentPartStyle = {}));

var ThreeDSecureVerification;

(function (ThreeDSecureVerification) {
  /** 3D Secure is required, and the process must be completed for a charge to be successful. */
  ThreeDSecureVerification["REQUIRED"] = "REQUIRED";
  /**
   * 3D Secure is recommended. The process is not required, but it is highly recommended and
   * has minimal impact to your conversion rate.
   */

  ThreeDSecureVerification["RECOMMENDED"] = "RECOMMENDED";
  /**
   * 3D Secure is optional. The process is neither required nor recommended, but it can be performed to
   * help reduce the likelihood of fraud.
   */

  ThreeDSecureVerification["OPTIONAL"] = "OPTIONAL";
  /** 3D Secure is not supported on this card. Proceed with a regular card payment instead. */

  ThreeDSecureVerification["NOT_SUPPORTED"] = "NOT_SUPPORTED";
})(ThreeDSecureVerification || (ThreeDSecureVerification = {}));

var TicketActionReason;

(function (TicketActionReason) {
  TicketActionReason["CUSTOMER_PREFERENCE"] = "CUSTOMER_PREFERENCE";
  TicketActionReason["EXPERT_RECOMMENDATION"] = "EXPERT_RECOMMENDATION";
  TicketActionReason["MISSING_EXPERT_INFO"] = "MISSING_EXPERT_INFO";
  TicketActionReason["MERCHANT_UPDATE"] = "MERCHANT_UPDATE";
  TicketActionReason["NEED_MERCHANT_TRACKING"] = "NEED_MERCHANT_TRACKING";
  TicketActionReason["UPDATE_TRACKING"] = "UPDATE_TRACKING";
  TicketActionReason["CONFIRM_INVENTORY"] = "CONFIRM_INVENTORY";
  TicketActionReason["CLAIM_ITEM"] = "CLAIM_ITEM";
})(TicketActionReason || (TicketActionReason = {}));

var TicketActionType;

(function (TicketActionType) {
  TicketActionType["CONTACT_CUSTOMER"] = "CONTACT_CUSTOMER";
  TicketActionType["CONTACT_MERCHANT"] = "CONTACT_MERCHANT";
  TicketActionType["CONTACT_EXPERT"] = "CONTACT_EXPERT";
  TicketActionType["CONTACT_CARRIER"] = "CONTACT_CARRIER";
  TicketActionType["GENERATE_SHIPPING_LABEL"] = "GENERATE_SHIPPING_LABEL";
  TicketActionType["VERIFY_ORDER"] = "VERIFY_ORDER";
  TicketActionType["UPDATE_TRACKING"] = "UPDATE_TRACKING";
  TicketActionType["REQUEST_CANCELLATION"] = "REQUEST_CANCELLATION";
  TicketActionType["REQUEST_REFUND"] = "REQUEST_REFUND";
  TicketActionType["UPDATE_ORDER"] = "UPDATE_ORDER";
  TicketActionType["MERGE_TICKETS"] = "MERGE_TICKETS";
  TicketActionType["TRANSFER_TICKET"] = "TRANSFER_TICKET";
})(TicketActionType || (TicketActionType = {}));

var TicketActivityType;

(function (TicketActivityType) {
  TicketActivityType["TICKET_ASSIGNED"] = "TICKET_ASSIGNED";
  TicketActivityType["TICKET_UNASSIGNED"] = "TICKET_UNASSIGNED";
  TicketActivityType["DUE_DATE_CHANGED"] = "DUE_DATE_CHANGED";
  TicketActivityType["FIELD_UPDATED"] = "FIELD_UPDATED";
  TicketActivityType["SNOOZE_CHANGED"] = "SNOOZE_CHANGED";
  TicketActivityType["TICKET_MERGED"] = "TICKET_MERGED";
  TicketActivityType["QUEUE_TRANSFER"] = "QUEUE_TRANSFER";
  TicketActivityType["TICKET_PICKED_UP"] = "TICKET_PICKED_UP";
  TicketActivityType["TICKET_CLOSED"] = "TICKET_CLOSED";
  TicketActivityType["TICKET_REOPENED"] = "TICKET_REOPENED";
  TicketActivityType["TICKET_CREATED"] = "TICKET_CREATED";
  TicketActivityType["DEPENDENCY_UPDATED"] = "DEPENDENCY_UPDATED";
  TicketActivityType["TICKET_COMMENT_ADDED"] = "TICKET_COMMENT_ADDED";
})(TicketActivityType || (TicketActivityType = {}));

var TicketCommentType;

(function (TicketCommentType) {
  TicketCommentType["AGENT_NOTES"] = "AGENT_NOTES";
  TicketCommentType["REPLY_TO_EXPERT"] = "REPLY_TO_EXPERT";
  TicketCommentType["EXPERT_RESPONSE"] = "EXPERT_RESPONSE";
})(TicketCommentType || (TicketCommentType = {}));

var TicketPriority;

(function (TicketPriority) {
  TicketPriority["NORMAL"] = "NORMAL";
  TicketPriority["HIGH"] = "HIGH";
})(TicketPriority || (TicketPriority = {}));

var TicketQueue;

(function (TicketQueue) {
  TicketQueue["FULFILLMENT_TIER_ONE"] = "FULFILLMENT_TIER_ONE";
  TicketQueue["FULFILLMENT_TIER_TWO"] = "FULFILLMENT_TIER_TWO";
  TicketQueue["SUPPORT_TIER_ONE"] = "SUPPORT_TIER_ONE";
  TicketQueue["SUPPORT_TIER_TWO"] = "SUPPORT_TIER_TWO";
  TicketQueue["SUPPORT_TIER_THREE"] = "SUPPORT_TIER_THREE";
})(TicketQueue || (TicketQueue = {}));

var TicketRequestChannel;

(function (TicketRequestChannel) {
  TicketRequestChannel["CUSTOMER_ESCALATION"] = "CUSTOMER_ESCALATION";
  TicketRequestChannel["EXPERT_CHAT"] = "EXPERT_CHAT";
  TicketRequestChannel["AGENT_ESCALATION"] = "AGENT_ESCALATION";
  TicketRequestChannel["EMAIL"] = "EMAIL";
  TicketRequestChannel["CALL"] = "CALL";
  TicketRequestChannel["WORKFLOW"] = "WORKFLOW";
})(TicketRequestChannel || (TicketRequestChannel = {}));

var TicketSearchSort;

(function (TicketSearchSort) {
  TicketSearchSort["CREATED_AT"] = "CREATED_AT";
  TicketSearchSort["UPDATED_AT"] = "UPDATED_AT";
  TicketSearchSort["DUE_AT"] = "DUE_AT";
})(TicketSearchSort || (TicketSearchSort = {}));

var TicketSnoozeChangeReason;

(function (TicketSnoozeChangeReason) {
  TicketSnoozeChangeReason["BACK_ORDERED"] = "BACK_ORDERED";
  TicketSnoozeChangeReason["MERCHANT_RESPONSE"] = "MERCHANT_RESPONSE";
  TicketSnoozeChangeReason["EXPERT_RESPONSE"] = "EXPERT_RESPONSE";
  TicketSnoozeChangeReason["CONSUMER_RESPONSE"] = "CONSUMER_RESPONSE";
  TicketSnoozeChangeReason["REFUND_REQUEST_UPDATE"] = "REFUND_REQUEST_UPDATE";
})(TicketSnoozeChangeReason || (TicketSnoozeChangeReason = {}));

var TicketState;

(function (TicketState) {
  TicketState["OPEN"] = "OPEN";
  TicketState["BLOCKED"] = "BLOCKED";
  TicketState["ACTIVE"] = "ACTIVE";
  TicketState["SNOOZED"] = "SNOOZED";
  TicketState["CLOSED"] = "CLOSED";
})(TicketState || (TicketState = {}));

var TicketTimelineFilterType;

(function (TicketTimelineFilterType) {
  TicketTimelineFilterType["ORDER_LINE_ITEM_ID"] = "ORDER_LINE_ITEM_ID";
})(TicketTimelineFilterType || (TicketTimelineFilterType = {}));

var TicketTimelineItemType;

(function (TicketTimelineItemType) {
  TicketTimelineItemType["COMMENT"] = "COMMENT";
  TicketTimelineItemType["WORKLOG"] = "WORKLOG";
  TicketTimelineItemType["TICKET_ACTIVITY"] = "TICKET_ACTIVITY";
  TicketTimelineItemType["ORDER_ACTIVITY"] = "ORDER_ACTIVITY";
})(TicketTimelineItemType || (TicketTimelineItemType = {}));

var TicketType;

(function (TicketType) {
  TicketType["LINE_ITEM_CLAIM"] = "LINE_ITEM_CLAIM";
  TicketType["UPDATE_TRACKING_INFO"] = "UPDATE_TRACKING_INFO";
  TicketType["ORDER_VERIFICATION"] = "ORDER_VERIFICATION";
  TicketType["PRODUCT_RETURN"] = "PRODUCT_RETURN";
  TicketType["CONSUMER_REFUND"] = "CONSUMER_REFUND";
  TicketType["MERCHANT_REFUND"] = "MERCHANT_REFUND";
  TicketType["ITEM_UNAVAILABLE"] = "ITEM_UNAVAILABLE";
  TicketType["MISSING_SPECS"] = "MISSING_SPECS";
  TicketType["ORDER_ADJUSTMENT"] = "ORDER_ADJUSTMENT";
  TicketType["CANCELLATION"] = "CANCELLATION";
  TicketType["RETURN"] = "RETURN";
  TicketType["EXCHANGE"] = "EXCHANGE";
  TicketType["MISSING_ITEM"] = "MISSING_ITEM";
  TicketType["TRACKING_INQUIRY"] = "TRACKING_INQUIRY";
  TicketType["ORDER_INFORMATION"] = "ORDER_INFORMATION";
  TicketType["OTHER"] = "OTHER";
  TicketType["FOLLOWUP_ACTION_REQUEST"] = "FOLLOWUP_ACTION_REQUEST";
  TicketType["GROUPED_ITEM_CLAIMS"] = "GROUPED_ITEM_CLAIMS";
  TicketType["PAYMENT_REFUND_REQUEST"] = "PAYMENT_REFUND_REQUEST";
})(TicketType || (TicketType = {}));

var TicketUnassignedReason;

(function (TicketUnassignedReason) {
  TicketUnassignedReason["SHIFT_ENDED"] = "SHIFT_ENDED";
})(TicketUnassignedReason || (TicketUnassignedReason = {}));

var TipMethodType;

(function (TipMethodType) {
  TipMethodType["PERCENT_OF_AMOUNT"] = "PERCENT_OF_AMOUNT";
  TipMethodType["FIXED_AMOUNT"] = "FIXED_AMOUNT";
})(TipMethodType || (TipMethodType = {}));

var TransactionStatus;

(function (TransactionStatus) {
  TransactionStatus["SUCCESS"] = "SUCCESS";
  TransactionStatus["PENDING"] = "PENDING";
  TransactionStatus["IN_REVIEW"] = "IN_REVIEW";
  TransactionStatus["FAILURE"] = "FAILURE";
  TransactionStatus["REFUNDED"] = "REFUNDED";
  TransactionStatus["OFFLINE"] = "OFFLINE";
  TransactionStatus["CANCELED"] = "CANCELED";
})(TransactionStatus || (TransactionStatus = {}));

var TransactionType;

(function (TransactionType) {
  TransactionType["CUSTOMER"] = "CUSTOMER";
  TransactionType["MERCHANT"] = "MERCHANT";
})(TransactionType || (TransactionType = {}));

var TransferTicketReason;

(function (TransferTicketReason) {
  TransferTicketReason["NEED_TO_CONTACT_CUSTOMER"] = "NEED_TO_CONTACT_CUSTOMER";
  TransferTicketReason["NEED_TO_CONTACT_MERCHANT"] = "NEED_TO_CONTACT_MERCHANT";
  TransferTicketReason["OTHER"] = "OTHER";
  TransferTicketReason["CUSTOMER_EXCEPTION"] = "CUSTOMER_EXCEPTION";
  TransferTicketReason["CLAIM_ITEM"] = "CLAIM_ITEM";
  TransferTicketReason["UNABLE_TO_VERIFY"] = "UNABLE_TO_VERIFY";
})(TransferTicketReason || (TransferTicketReason = {}));

var TriggerChangeType;

(function (TriggerChangeType) {
  TriggerChangeType["CREATED"] = "CREATED";
  TriggerChangeType["PUBLISHED"] = "PUBLISHED";
  TriggerChangeType["DEACTIVATED"] = "DEACTIVATED";
  TriggerChangeType["ARCHIVED"] = "ARCHIVED";
  TriggerChangeType["IMPORTED"] = "IMPORTED";
})(TriggerChangeType || (TriggerChangeType = {}));

var TriggerConditionType;

(function (TriggerConditionType) {
  TriggerConditionType["LOGICAL"] = "LOGICAL";
  TriggerConditionType["BINARY"] = "BINARY";
  TriggerConditionType["EXPERIMENT"] = "EXPERIMENT";
})(TriggerConditionType || (TriggerConditionType = {}));

var TriggerDelayIntervalType;

(function (TriggerDelayIntervalType) {
  TriggerDelayIntervalType["FIXED"] = "FIXED";
  TriggerDelayIntervalType["DYNAMIC"] = "DYNAMIC";
  TriggerDelayIntervalType["WITH_EXPERIMENT"] = "WITH_EXPERIMENT";
})(TriggerDelayIntervalType || (TriggerDelayIntervalType = {}));

var TriggerDurationUnit;

(function (TriggerDurationUnit) {
  TriggerDurationUnit["SECONDS"] = "SECONDS";
  TriggerDurationUnit["MINUTES"] = "MINUTES";
  TriggerDurationUnit["HOURS"] = "HOURS";
  TriggerDurationUnit["DAYS"] = "DAYS";
})(TriggerDurationUnit || (TriggerDurationUnit = {}));

var TriggerExecutionStatus;

(function (TriggerExecutionStatus) {
  TriggerExecutionStatus["STARTED"] = "STARTED";
  TriggerExecutionStatus["COMPLETED"] = "COMPLETED";
  TriggerExecutionStatus["SKIPPED"] = "SKIPPED";
  TriggerExecutionStatus["ERROR"] = "ERROR";
})(TriggerExecutionStatus || (TriggerExecutionStatus = {}));
/**
 * =============================
 * Trigger metadata.
 * =============================
 */


var TriggerFieldType;

(function (TriggerFieldType) {
  TriggerFieldType["BOOLEAN"] = "BOOLEAN";
  TriggerFieldType["INTEGER"] = "INTEGER";
  TriggerFieldType["DECIMAL"] = "DECIMAL";
  TriggerFieldType["STRING"] = "STRING";
  TriggerFieldType["STRING_LIST"] = "STRING_LIST";
  TriggerFieldType["DATE"] = "DATE";
  TriggerFieldType["ID"] = "ID";
  TriggerFieldType["ID_LIST"] = "ID_LIST";
})(TriggerFieldType || (TriggerFieldType = {}));

var TriggerNodeEdgeType;

(function (TriggerNodeEdgeType) {
  TriggerNodeEdgeType["NEXT"] = "NEXT";
  TriggerNodeEdgeType["TRUE"] = "TRUE";
  TriggerNodeEdgeType["FALSE"] = "FALSE";
})(TriggerNodeEdgeType || (TriggerNodeEdgeType = {}));

var TriggerNodeType;

(function (TriggerNodeType) {
  TriggerNodeType["DELAY"] = "DELAY";
  TriggerNodeType["FILTER"] = "FILTER";
  TriggerNodeType["BRANCH"] = "BRANCH";
  TriggerNodeType["ACTION"] = "ACTION";
  TriggerNodeType["WAIT"] = "WAIT";
  TriggerNodeType["JUMP"] = "JUMP";
})(TriggerNodeType || (TriggerNodeType = {}));

var TriggerParameterType;

(function (TriggerParameterType) {
  TriggerParameterType["ENTITY_FIELD"] = "ENTITY_FIELD";
  TriggerParameterType["EVENT_PARAMETER"] = "EVENT_PARAMETER";
  TriggerParameterType["LITERAL_VALUE"] = "LITERAL_VALUE";
  TriggerParameterType["TEMPLATE_TYPE"] = "TEMPLATE_TYPE";
})(TriggerParameterType || (TriggerParameterType = {}));

var TriggerSearchSort;

(function (TriggerSearchSort) {
  TriggerSearchSort["CREATED_AT"] = "CREATED_AT";
  TriggerSearchSort["PUBLISHED_AT"] = "PUBLISHED_AT";
  TriggerSearchSort["TITLE"] = "TITLE";
})(TriggerSearchSort || (TriggerSearchSort = {}));
/**
 * =============================
 * Trigger instance
 * =============================
 */


var TriggerState;

(function (TriggerState) {
  TriggerState["DRAFT"] = "DRAFT";
  TriggerState["TEST"] = "TEST";
  TriggerState["PUBLISHED"] = "PUBLISHED";
  TriggerState["DEACTIVATED"] = "DEACTIVATED";
  TriggerState["ARCHIVED"] = "ARCHIVED";
})(TriggerState || (TriggerState = {}));

var UnsavedSellableReason;

(function (UnsavedSellableReason) {
  UnsavedSellableReason["NOT_INTERESTED"] = "NOT_INTERESTED";
  UnsavedSellableReason["TOO_EXPENSIVE"] = "TOO_EXPENSIVE";
  UnsavedSellableReason["LOW_QUALITY"] = "LOW_QUALITY";
  UnsavedSellableReason["UGLY"] = "UGLY";
  UnsavedSellableReason["DONT_NEED"] = "DONT_NEED";
  UnsavedSellableReason["BOUGHT_ELSEWHERE"] = "BOUGHT_ELSEWHERE";
})(UnsavedSellableReason || (UnsavedSellableReason = {}));

var UpdateUserSourceToReferralErrorCode;

(function (UpdateUserSourceToReferralErrorCode) {
  UpdateUserSourceToReferralErrorCode["NOT_ELIGIBLE"] = "NOT_ELIGIBLE";
  UpdateUserSourceToReferralErrorCode["REFERRER_NOT_FOUND"] = "REFERRER_NOT_FOUND";
})(UpdateUserSourceToReferralErrorCode || (UpdateUserSourceToReferralErrorCode = {}));

var UserActivityType;

(function (UserActivityType) {
  UserActivityType["ADD_SELLABLE"] = "ADD_SELLABLE";
  UserActivityType["CHECKOUT_STARTED"] = "CHECKOUT_STARTED";
  UserActivityType["COMPLETE_ORDER"] = "COMPLETE_ORDER";
  UserActivityType["CURATED_LIST_VIEWED"] = "CURATED_LIST_VIEWED";
  UserActivityType["PAYMENT_INFO_ENTERED"] = "PAYMENT_INFO_ENTERED";
  UserActivityType["REMOVE_SELLABLE"] = "REMOVE_SELLABLE";
  UserActivityType["SEARCH_SELLABLES"] = "SEARCH_SELLABLES";
  UserActivityType["VIEW_CART"] = "VIEW_CART";
  UserActivityType["VIEW_SELLABLE"] = "VIEW_SELLABLE";
  UserActivityType["VOICE_CALL"] = "VOICE_CALL";
  UserActivityType["SAVED_SELLABLE"] = "SAVED_SELLABLE";
  UserActivityType["UNSAVED_SELLABLE"] = "UNSAVED_SELLABLE";
})(UserActivityType || (UserActivityType = {}));

var UserEditErrorCode;

(function (UserEditErrorCode) {
  UserEditErrorCode["FIRST_NAME_REQUIRED"] = "FIRST_NAME_REQUIRED";
  UserEditErrorCode["INVALID_CONTACT"] = "INVALID_CONTACT";
})(UserEditErrorCode || (UserEditErrorCode = {}));

var UserJourneyLeadStageStatus;

(function (UserJourneyLeadStageStatus) {
  UserJourneyLeadStageStatus["NO_CURATION"] = "NO_CURATION";
  UserJourneyLeadStageStatus["CURATION_READY"] = "CURATION_READY";
  UserJourneyLeadStageStatus["OLD_CURATION"] = "OLD_CURATION";
})(UserJourneyLeadStageStatus || (UserJourneyLeadStageStatus = {}));

var UserJourneyOrderStageStatus;

(function (UserJourneyOrderStageStatus) {
  UserJourneyOrderStageStatus["PLACED"] = "PLACED";
  UserJourneyOrderStageStatus["IN_TRANSIT"] = "IN_TRANSIT";
  UserJourneyOrderStageStatus["DELIVERED"] = "DELIVERED";
})(UserJourneyOrderStageStatus || (UserJourneyOrderStageStatus = {}));

var UserJourneyStageType;

(function (UserJourneyStageType) {
  UserJourneyStageType["NEW"] = "NEW";
  UserJourneyStageType["LEAD"] = "LEAD";
  UserJourneyStageType["ORDER"] = "ORDER";
})(UserJourneyStageType || (UserJourneyStageType = {}));

var UserRegistrationChannel;

(function (UserRegistrationChannel) {
  UserRegistrationChannel["PRE_FILLED_SMS"] = "PRE_FILLED_SMS";
})(UserRegistrationChannel || (UserRegistrationChannel = {}));

var UserSourceType;

(function (UserSourceType) {
  UserSourceType["ADS"] = "ADS";
  UserSourceType["REFERRAL"] = "REFERRAL";
  UserSourceType["EXPERT_REFERRAL"] = "EXPERT_REFERRAL";
  UserSourceType["PHONE_CALL"] = "PHONE_CALL";
  UserSourceType["SMS"] = "SMS";
  UserSourceType["EMAIL"] = "EMAIL";
  UserSourceType["INVESTOR"] = "INVESTOR";
  UserSourceType["PARTNER"] = "PARTNER";
  UserSourceType["ORGANIC"] = "ORGANIC";
})(UserSourceType || (UserSourceType = {}));

var VendorAgreementCashPaymentType;

(function (VendorAgreementCashPaymentType) {
  VendorAgreementCashPaymentType["STANDARD"] = "STANDARD";
  VendorAgreementCashPaymentType["PREPAID"] = "PREPAID";
  VendorAgreementCashPaymentType["CREDIT_CARD"] = "CREDIT_CARD";
})(VendorAgreementCashPaymentType || (VendorAgreementCashPaymentType = {}));

var VendorAgreementNetDating;

(function (VendorAgreementNetDating) {
  VendorAgreementNetDating["NET_30"] = "NET_30";
  VendorAgreementNetDating["NET_60"] = "NET_60";
  VendorAgreementNetDating["NET_90"] = "NET_90";
})(VendorAgreementNetDating || (VendorAgreementNetDating = {}));

var VendorAgreementPaymentFrequency;

(function (VendorAgreementPaymentFrequency) {
  VendorAgreementPaymentFrequency["MONTHLY"] = "MONTHLY";
  VendorAgreementPaymentFrequency["QUARTERLY"] = "QUARTERLY";
  VendorAgreementPaymentFrequency["BIANNUALLY"] = "BIANNUALLY";
})(VendorAgreementPaymentFrequency || (VendorAgreementPaymentFrequency = {}));

var VendorAgreementRevisionState;

(function (VendorAgreementRevisionState) {
  VendorAgreementRevisionState["DRAFT"] = "DRAFT";
  VendorAgreementRevisionState["IN_REVIEW"] = "IN_REVIEW";
  VendorAgreementRevisionState["PENDING_SIGNATURE"] = "PENDING_SIGNATURE";
  VendorAgreementRevisionState["PUBLISHED"] = "PUBLISHED";
  VendorAgreementRevisionState["ARCHIVED"] = "ARCHIVED";
})(VendorAgreementRevisionState || (VendorAgreementRevisionState = {}));

var VendorAgreementShippingType;

(function (VendorAgreementShippingType) {
  VendorAgreementShippingType["FREE_FREIGHT"] = "FREE_FREIGHT";
  VendorAgreementShippingType["PREPAID_FREIGHT"] = "PREPAID_FREIGHT";
  VendorAgreementShippingType["CURATED_PAID_SHIPPING"] = "CURATED_PAID_SHIPPING";
})(VendorAgreementShippingType || (VendorAgreementShippingType = {}));

var VerifyPendingAccessContactErrorCode;

(function (VerifyPendingAccessContactErrorCode) {
  VerifyPendingAccessContactErrorCode["INVALID_TOKEN"] = "INVALID_TOKEN";
})(VerifyPendingAccessContactErrorCode || (VerifyPendingAccessContactErrorCode = {}));

var WarrantyContractState;

(function (WarrantyContractState) {
  WarrantyContractState["ACTIVE"] = "ACTIVE";
  WarrantyContractState["CANCELED"] = "CANCELED";
})(WarrantyContractState || (WarrantyContractState = {}));

var WorkflowFailureResolution;

(function (WorkflowFailureResolution) {
  WorkflowFailureResolution["RETRY_WORKFLOW"] = "RETRY_WORKFLOW";
  WorkflowFailureResolution["AUTO_ESCALATE"] = "AUTO_ESCALATE";
  WorkflowFailureResolution["MANUAL_ESCALATE"] = "MANUAL_ESCALATE";
})(WorkflowFailureResolution || (WorkflowFailureResolution = {}));

var WorkflowType;

(function (WorkflowType) {
  WorkflowType["BASIC"] = "BASIC";
  WorkflowType["FULFILLMENT"] = "FULFILLMENT";
})(WorkflowType || (WorkflowType = {}));

export { AcceptEscalationResultStatus, AcceptRequestMode, AddressValidationStatus, AirportType, ApprovableEntityState, ApprovalRequestActivityEntryType, ApprovalRequestEntityType, ApprovalRequestState, ApprovalRequestSubmitDraftDependencyState, ApprovalReviewStatus, ArticleContentBlockType, ArticleRevisionState, ArticleSort, AttentionNeededLeadChangeType, AttributeFunction, AttributeSchemaMetadataType, AttributeSchemaRevisionQueryDraftFilter, AttributeSchemaRevisionSort, AttributeSchemaRevisionState, AttributeSearchFunction, AttributeType, AttributeValidatorType, AttributedHtmlTextViewModelAttributeType, AuthenticationMethod, AuthenticationResult, AwayAutoReplyStatus, BookingSearchSort, BookingState, BroadcastOfferType, BusinessUserActivityType, BusinessUserState, CallStatus, CallType, CampaignAudienceExternalPlatform, CampaignAudienceFacebookValueType, CampaignAudienceMemberType, CampaignAudienceSort, CampaignAudienceState, CampaignDeliveryFrequency, CampaignRecipientSortOrder, CampaignState, CardFieldValidationStatus, CardFundingType, CartSyncUseCase, CategoryTaxCaptureStrategy, CategoryType, ChallengeType, ChannelType, ClaimPromotionErrorCode, CloseTicketReason, ConditionType, ConsumerInitialLeadAction, ConsumerReviewSearchSort, ConsumerReviewSource, ConsumerSellableReactionRating, ConsumerSellableReactionReason, ConsumerSellableReactionSource, ContactType, ContentSelectionAdLevel, ContentSelectionChannelType, ContentSelectionDeviceType, ContentSelectionMethodType, ConversationStarterContextType, ConversationStarterLocation, DatePathFlowQuestionType, DateRangeFilterField, DateRangePathFlowQuestionType, DayOfWeek, DealState, DealTermsType, DepartmentNavigationLabelStyle, DepartmentNavigationResponsiveFullSizeOptions, DepartmentNavigationResponsiveSmallSizeOptions, DepartmentType, DependencyUpdateType, DurationUnit, EditableUserSourceType, EmbedMediaType, EndPathNodeConfigType, EntityCreatedTypePathGraphFlowEvent, Environment, EscalationItemCondition, EscalationResolution, ExperimentSortBy, ExperimentState, ExperimentUsageType, ExpertApplicationFolderItemChangeType, ExpertApplicationFolderType, ExpertApplicationInterviewState, ExpertApplicationInterviewType, ExpertApplicationRating, ExpertApplicationSearchSort, ExpertApplicationState, ExpertApplicationSubscriptionChangeType, ExpertApplicationSuggestedActionDismissReason, ExpertApplicationSuggestedActionType, ExpertApplicationTaskState, ExpertApplicationTaskType, ExpertCommissionRefundTreatment, ExpertCuratedItemNoteSort, ExpertCuratedItemNoteState, ExpertCuratedItemPriceOverrideReasonType, ExpertCuratedItemRankChangeType, ExpertCuratedItemRemovedReason, ExpertCuratedItemSort, ExpertCuratedItemStateFilter, ExpertCuratedItemTagType, ExpertCuratedItemWriteErrorType, ExpertCuratedOrderClosedReason, ExpertCuratedOrderSelectErrorCode, ExpertCuratedOrderServiceLocationErrorCode, ExpertCuratedOrderState, ExpertCuratedOrdersForLeadQueryCustomFilter, ExpertCuratedOrdersForLeadQueryDraftFilter, ExpertGender, ExpertHiringFeedbackState, ExpertHiringFeedbackType, ExpertLeadFolderGroupType, ExpertLeadFolderItemChangeType, ExpertLeadGateType, ExpertNoteVisibilityType, ExpertNotificationMode, ExpertNotificationType, ExpertPerformanceRating, ExpertPresenceStatus, ExpertProfileState, ExpertRecommendationStrategy, ExpertSearchSort, ExternalAdPlatform, ExternalAdStatus, ExternalInventoryItemSourceType, ExternalProfileType, ExternalVideoIdType, FacetImageType, FilterConditionType, FilterFieldNumberType, FilterLogicalOperator, FlightPlanEditErrorCode, FlightPlanState, FrontendTaskStatus, FulfillmentChannelType, FulfillmentOrderDeliveryStatus, FulfillmentOrderSourceType, FulfillmentServiceProvider, FulfillmentServiceType, FulfillmentStatus, FulfillmentSuggestionStatus, GetEntityErrorCode, GiftCardState, GuestConversationSequenceState, HandleType, IdPathFlowQuestionType, IdentityType, IncomingCallState, IndividualSellableProConType, InputTextPathFlowQuestionFieldType, InputTextPathFlowQuestionValidationType, InputTextPathQuestionSchemaRenderingStyle, InterstitialPathFlowPageMetadataType, InterstitialPathNodeConfigType, LeadActivityType, LeadAssignmentStage, LeadCampaignRecipientSortOrder, LeadCampaignState, LeadCampaignTriggerExecutionInterval, LeadEscalationLevel, LeadEscalationStatus, LeadEscalationType, LeadExpertRole, LeadIntentLabel, LeadParticipantType, LeadPostOrderCheckinReason, LeadReassignmentReason, LeadSortOrder, LeadSourceFlowType, LeadSourcePageType, LeadSupportTaskReason, LedgerTransactionType, LedgerType, ListPathFlowQuestionRenderStyle, ListPathFlowQuestionType, ListPathQuestionSchemaType, LogicalConditionOperator, LogicalOperator, LookupReferralCodeError, LtvType, ManualAdjustmentPayType, MerchantSortField, MerchantState, MessageBodyType, MessageRichCardType, MessageUnsubscribeTag, MessagingChannelType, MessagingUserType, MonetaryAmountDenominationType, NotificationType, NumericPathFlowQuestionDisplayType, NumericPathFlowQuestionUnitType, NumericPathFlowQuestionValueType, NumericPathQuestionSchemaGenericRenderingStyleUnitPlacement, NumericRangeDisplayFacetType, OAuthType, OfferState, OperatorPermission, OperatorRole, OperatorShiftType, OperatorTeam, OrderActivityDetailType, OrderCancellationReason, OrderChangeStatus, OrderChargeableStatusType, OrderChargeableUseCase, OrderCostComponent, OrderEscalationLabel, OrderEscalationPriority, OrderEscalationSearchSort, OrderEscalationSource, OrderEscalationStatus, OrderEscalationType, OrderFulfillmentState, OrderLabel, OrderLineItemGroupPriceStrategy, OrderLineItemGroupTaxStrategy, OrderLineItemSourceType, OrderLineItemState, OrderLineItemsGroupingType, OrderPreSubmitAction, OrderRefundReason, OrderRefundRequestReason, OrderRefundStatus, OrderRefundType, OrderSearchSort, OrderState, PartnerAccountContactType, PartnerAccountState, PartnerUserState, PathAttributeValueType, PathConditionEnumDeclarationType, PathConditionLogicalType, PathConditionOperandValueTypeName, PathConditionOperatorType, PathConditionType, PathEditorRichTextContentPartType, PathEditorValidationErrorTargetType, PathEditorValidationErrorTier, PathEditorValidationErrorType, PathFlowOnCompleteRedirectLocation, PathFlowPageMetadataType, PathFlowThemeType, PathGraphContainerSort, PathGraphContainerState, PathGraphContainerStateFilter, PathGraphFlowRunMode, PathNodeConfigType, PathNodeDynamicExpanderStateType, PathNodeExpanderSetting, PathPortType, PathQuestionDisplayComponentSchemaType, PathQuestionSchemaType, PathSchemaDomainType, PathValidationErrorTag, PayComponentType, PayLineItemSortField, PayStructureRevisionState, PaymentActionType, PaymentActivityType, PaymentMethod, PaymentProcessorType, PaymentRefundStatus, PaymentSourceStatus, PaymentSourceUsage, PaymentVerificationMethod, PayoutSortField, PayoutState, Permission, PostalAddressLocationDisplayType, PresenceStatus, ProductCatalogGroupRevisionState, ProductCatalogRevisionState, ProductCatalogSort, ProductCondition, ProductReturnDestination, ProfileHighlightIconType, ProfileHighlightSource, ProfileHighlightValueType, PromotionActionType, PromotionDisabledReason, PromotionQueryFlagType, PromotionRuleComparisonOperator, PromotionRuleFilterStrategy, PromotionRuleType, PromotionSourceType, PromotionState, PurchasableMembershipType, RawSellableAttributeValuePatternFlag, RawSellableSourceShopifyType, RawSellableSourceState, RawSellableSourceType, RawSellableStandardizationActionType, RawSellableStandardizationResultState, RawSellableStandardizationRuleConditionType, RawSellableStandardizationRuleFieldType, RawSellableStandardizationRuleParameterType, RawSellableStandardizationRuleState, RawSellableState, RecommendedListType, RedirectPathNodeConfigType, ReferralMedium, ReferralType, ReferrerIncentiveType, RegisterCustomerErrorCode, RelativeDateUnit, ReopenTicketReason, ReportAccessScope, ReportColumnFormat, ReportColumnValueType, ReportSchemaType, ReturnPolicyType, ReturnRefundMethod, ReturnShippingPaidBy, RevisionChangeType, RevisionState, RichPathNodeOwningEntityType, RpalExclusionReason, SavedExpertCuratedItemState, SavedSellableReason, ScheduledPaymentState, SchedulingUserRole, ScrapingJobType, ScrapingSellablePriceSourceSpider, SearchFilterFieldAttributeSchemaMetadataSearchFilterEntity, SellableAttributePromotionRuleReferenceComparison, SellableBadge, SellableCategoryFilterPromotionRuleReferenceTraversalOption, SellableCustomOfferRuleType, SellableExpertCuratedItemNoteStatsSort, SellablePriceSourceType, SellableQuestionCandidateState, SellableQuestionState, SellableSearchFacetsQueryFilter, SellableSearchFilter, SellableSearchPageModuleType, SellableSearchPageRelatedLinksType, SellableSearchUseCase, SellableServiceLocationDisplayType, SellableSort, SellableSourceExternalIdType, SellableSourceType, SellableTopListDefinitionSort, SellableTopListState, SellableType, ShiftAssignmentMode, ShiftAttendanceStatus, ShiftChangeRequestType, ShiftGiveUpReason, ShiftProbationFilterType, ShiftSlotState, ShipmentPricingTierType, ShippingGroupStrategy, ShippingMethod, ShippingPolicy, ShippingStatus, SimpleCuratedOrderType, SocialMediaType, SortOrder, StandardizedSellableGroupCandidateState, StandardizedSellableGroupState, StandardizedSellableState, StringBinaryConditionDefinitionOperator, StringFieldType, StripeAuthenticationFlow, StripeCodeVerificationStatus, SuggestExpertCuratedItemNotesSort, SuggestedActionContext, SuggestedActionType, SuggestedIndividualExpertCuratedItemProConTypeaheadSort, SuggestedSellableFilter, SuggestedSellableReviewAnswer, SuggestedSupportAction, SupportTaskAction, SupportTaskListEventType, SupportTaskState, SupportTaskType, SystemCuratedConsumerSellableReactionRating, SystemCuratedItemSurveyTerminationReason, SystemCuratedItemType, TagType, TemplateDataModelType, TemplateFragmentParameterType, TemplateFragmentType, TemplateSearchSort, TemplateTagSyntax, TemplateTypeGroup, TextPathEditorRichTextContentPartStyle, ThreeDSecureVerification, TicketActionReason, TicketActionType, TicketActivityType, TicketCommentType, TicketPriority, TicketQueue, TicketRequestChannel, TicketSearchSort, TicketSnoozeChangeReason, TicketState, TicketTimelineFilterType, TicketTimelineItemType, TicketType, TicketUnassignedReason, TipMethodType, TransactionStatus, TransactionType, TransferTicketReason, TriggerChangeType, TriggerConditionType, TriggerDelayIntervalType, TriggerDurationUnit, TriggerExecutionStatus, TriggerFieldType, TriggerNodeEdgeType, TriggerNodeType, TriggerParameterType, TriggerSearchSort, TriggerState, UnsavedSellableReason, UpdateUserSourceToReferralErrorCode, UserActivityType, UserEditErrorCode, UserJourneyLeadStageStatus, UserJourneyOrderStageStatus, UserJourneyStageType, UserRegistrationChannel, UserSourceType, VendorAgreementCashPaymentType, VendorAgreementNetDating, VendorAgreementPaymentFrequency, VendorAgreementRevisionState, VendorAgreementShippingType, VerifyPendingAccessContactErrorCode, WarrantyContractState, WorkflowFailureResolution, WorkflowType };
//# sourceMappingURL=types.js.map
